export * from '../models/AccessCondition.js';
export * from '../models/AccessConditionEffect.js';
export * from '../models/AccessConditionalExpression.js';
export * from '../models/AccessibleOrganizationAccount.js';
export * from '../models/Account.js';
export * from '../models/AccountConfigInput.js';
export * from '../models/AccountDisplayNameFilters.js';
export * from '../models/AccountIdCondition.js';
export * from '../models/AccountIdFilters.js';
export * from '../models/AccountInstallationMethod.js';
export * from '../models/AccountMetricsDestination.js';
export * from '../models/AccountNameFilters.js';
export * from '../models/AccountState.js';
export * from '../models/AccountStatusFilters.js';
export * from '../models/AccountStatusReason.js';
export * from '../models/AccountUpdateInput.js';
export * from '../models/AccountVersion.js';
export * from '../models/ActionFilters.js';
export * from '../models/ActivateAtlasOrganizationResponse.js';
export * from '../models/ActivateGcpFolderResponse.js';
export * from '../models/ActivateGcpOrganizationResponse.js';
export * from '../models/AddRestoreAtlasPrivateLinkRequest.js';
export * from '../models/AdeRestoreEncryptionConfig.js';
export * from '../models/AgreementWithCredits.js';
export * from '../models/Ami.js';
export * from '../models/AmiBlockDevice.js';
export * from '../models/AnnuallyConfig.js';
export * from '../models/AnomalyDataPoint.js';
export * from '../models/AnomalyGraphData.js';
export * from '../models/ApiCredentials.js';
export * from '../models/ApiCredentialsProperties.js';
export * from '../models/App.js';
export * from '../models/AppFilters.js';
export * from '../models/ApplicationOverride.js';
export * from '../models/AppsCondition.js';
export * from '../models/AppsDetails.js';
export * from '../models/AtlasCluster.js';
export * from '../models/AtlasClusters.js';
export * from '../models/AtlasOrganization.js';
export * from '../models/AtlasProject.js';
export * from '../models/AtlasProjects.js';
export * from '../models/AuditLog.js';
export * from '../models/AuditLogAction.js';
export * from '../models/AuditLogAuthMethod.js';
export * from '../models/AuditLogAuthStatus.js';
export * from '../models/AuditLogChangeSource.js';
export * from '../models/AuditLogCloudContext.js';
export * from '../models/AuditLogEnrichmentStatus.js';
export * from '../models/AuditLogEntitiesInner.js';
export * from '../models/AuditLogExtendedData.js';
export * from '../models/AuditLogExtendedDataAuth.js';
export * from '../models/AuditLogExtendedDataMpa.js';
export * from '../models/AuditLogFilterConditions.js';
export * from '../models/AuditLogInitiatorType.js';
export * from '../models/AuditLogMfaMethod.js';
export * from '../models/AuditLogSecurityContext.js';
export * from '../models/AuditLogStateSnapshot.js';
export * from '../models/AuthResponse.js';
export * from '../models/AuthV2AssociateSoftwareTokenRequest.js';
export * from '../models/AuthV2AssociateSoftwareTokenResponse.js';
export * from '../models/AuthV2ConfirmForgotPasswordRequest.js';
export * from '../models/AuthV2ForgotPasswordRequest.js';
export * from '../models/AuthV2ForgotPasswordResponse.js';
export * from '../models/AuthV2LoginRequest.js';
export * from '../models/AuthV2RespondChallengeRequest.js';
export * from '../models/AuthV2VerifySoftwareTokenRequest.js';
export * from '../models/AuthV2VerifySoftwareTokenResponse.js';
export * from '../models/AwsAccountConfigInput.js';
export * from '../models/AwsAccountMetricsDestination.js';
export * from '../models/AwsCassandraClusterRestoreDestination.js';
export * from '../models/AwsCassandraClusterRestoreTarget.js';
export * from '../models/AwsDatabaseDestination.js';
export * from '../models/AwsDynamoDBDestination.js';
export * from '../models/AwsDynamoDbResource.js';
export * from '../models/AwsDynamoDbSnapshotProperties.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.js';
export * from '../models/AwsEbsSnapshotConvertResult.js';
export * from '../models/AwsEbsVolumeResource.js';
export * from '../models/AwsEbsVolumeRestoreData.js';
export * from '../models/AwsEbsVolumeRestoreResult.js';
export * from '../models/AwsEbsVolumeSnapshotProperties.js';
export * from '../models/AwsEc2AmiConvertResult.js';
export * from '../models/AwsEc2InstanceRestoreDestination.js';
export * from '../models/AwsEc2InstanceRestoreResult.js';
export * from '../models/AwsEc2InstanceRestoreTarget.js';
export * from '../models/AwsEc2Resource.js';
export * from '../models/AwsEc2SnapshotProperties.js';
export * from '../models/AwsEksNamespaceResource.js';
export * from '../models/AwsEksNamespaceSnapshotProperties.js';
export * from '../models/AwsFsxResource.js';
export * from '../models/AwsKeyspacesDestination.js';
export * from '../models/AwsKeyspacesResource.js';
export * from '../models/AwsNativePitrBackupPolicyPlan.js';
export * from '../models/AwsNativePitrBackupResourceType.js';
export * from '../models/AwsNativePitrConfig.js';
export * from '../models/AwsNativeStandardBackupPolicyPlan.js';
export * from '../models/AwsNativeStandardBackupScheduleConfig.js';
export * from '../models/AwsNativeStandardBackupSchedules.js';
export * from '../models/AwsNativeStandardIntervalConfig.js';
export * from '../models/AwsNeptuneResource.js';
export * from '../models/AwsRdsEngine.js';
export * from '../models/AwsRdsResource.js';
export * from '../models/AwsRdsResourceAurora.js';
export * from '../models/AwsRdsResourceStorageSettings.js';
export * from '../models/AwsRdsSnapshotProperties.js';
export * from '../models/AwsRestoreAccountAttributes.js';
export * from '../models/AwsRestoreAccountAttributesInput.js';
export * from '../models/AwsRestoreAccountConnectivityConfig.js';
export * from '../models/AwsRestoreServerNetworkParams.js';
export * from '../models/AwsSourceAccountAttributes.js';
export * from '../models/AwsSourceAccountAttributesInput.js';
export * from '../models/AwsVaultConfig.js';
export * from '../models/AwsVaultConfigInput.js';
export * from '../models/AwsVpcConnectivityConfig.js';
export * from '../models/AzureAccountConfigInput.js';
export * from '../models/AzureAksNamespaceResource.js';
export * from '../models/AzureAppRegistrationOption.js';
export * from '../models/AzureBackupApplicationsResponse.js';
export * from '../models/AzureCmkEligibleApp.js';
export * from '../models/AzureConsentUrlResponse.js';
export * from '../models/AzureDisk.js';
export * from '../models/AzureDiskRestoreData.js';
export * from '../models/AzureDiskRestoreDestination.js';
export * from '../models/AzureDiskRestoreResult.js';
export * from '../models/AzureDiskSettings.js';
export * from '../models/AzureDiskTarget.js';
export * from '../models/AzureEonApplication.js';
export * from '../models/AzureFileShareRestoreFileSpec.js';
export * from '../models/AzureFilesBackupPolicyPlan.js';
export * from '../models/AzureFilesBackupSchedules.js';
export * from '../models/AzureFilesStorageAccountSelection.js';
export * from '../models/AzureListResourceGroupsResponse.js';
export * from '../models/AzureListSubscriptionsResponse.js';
export * from '../models/AzureManagementGroup.js';
export * from '../models/AzureManagementGroups.js';
export * from '../models/AzureMarketplaceWebhookInput.js';
export * from '../models/AzureMarketplaceWebhookInputSubscription.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionTerm.js';
export * from '../models/AzureMssqlSnapshotProperties.js';
export * from '../models/AzureOnboardedTenantsResponse.js';
export * from '../models/AzureOnboardingStatus.js';
export * from '../models/AzureOptionalCapabilities.js';
export * from '../models/AzurePostgresDatabaseRestoreDestination.js';
export * from '../models/AzurePostgresDatabaseRestoreTarget.js';
export * from '../models/AzureResourceGroup.js';
export * from '../models/AzureResourceGroups.js';
export * from '../models/AzureRestoreAccountAttributes.js';
export * from '../models/AzureRestoreAccountAttributesInput.js';
export * from '../models/AzureRestoreAccountConnectivityConfig.js';
export * from '../models/AzureRestorePointData.js';
export * from '../models/AzureRestorePointSpec.js';
export * from '../models/AzureSapHanaResource.js';
export * from '../models/AzureScanningAccountSetupStatus200Response.js';
export * from '../models/AzureSourceAccountAttributes.js';
export * from '../models/AzureSourceAccountAttributesInput.js';
export * from '../models/AzureSqlDatabaseNativePitrBackupPolicyPlan.js';
export * from '../models/AzureSqlDatabaseNativePitrBackupResourceType.js';
export * from '../models/AzureSqlDatabaseNativePitrConfig.js';
export * from '../models/AzureSqlDatabaseRestoreDestination.js';
export * from '../models/AzureSqlDatabaseRestoreTarget.js';
export * from '../models/AzureSqlRestoreTargetServers.js';
export * from '../models/AzureSqlServer.js';
export * from '../models/AzureStorageAccount.js';
export * from '../models/AzureStorageAccounts.js';
export * from '../models/AzureSubscription.js';
export * from '../models/AzureTenant.js';
export * from '../models/AzureVaultConfig.js';
export * from '../models/AzureVaultConfigInput.js';
export * from '../models/AzureVaultType.js';
export * from '../models/AzureVmInstanceRestoreDestination.js';
export * from '../models/AzureVmInstanceRestoreResult.js';
export * from '../models/AzureVmInstanceRestoreTarget.js';
export * from '../models/AzureVmResource.js';
export * from '../models/AzureVmSnapshotProperties.js';
export * from '../models/AzureVnetConnectivityConfig.js';
export * from '../models/BackedByCategory.js';
export * from '../models/BackedUpByResourceType.js';
export * from '../models/BackedUpByResourceTypeDataInner.js';
export * from '../models/BackedUpStorageDateHistogram.js';
export * from '../models/BackupControlViolations.js';
export * from '../models/BackupJob.js';
export * from '../models/BackupJobResponse.js';
export * from '../models/BackupJobSortField.js';
export * from '../models/BackupJobType.js';
export * from '../models/BackupJobTypeFilters.js';
export * from '../models/BackupJobsFilterConditions.js';
export * from '../models/BackupPoliciesFilters.js';
export * from '../models/BackupPoliciesLimits.js';
export * from '../models/BackupPoliciesSecurityConfig.js';
export * from '../models/BackupPolicy.js';
export * from '../models/BackupPolicyAppliesNotificationArguments.js';
export * from '../models/BackupPolicyConfig.js';
export * from '../models/BackupPolicyExpression.js';
export * from '../models/BackupPolicyGroupCondition.js';
export * from '../models/BackupPolicyNotificationArguments.js';
export * from '../models/BackupPolicyPlan.js';
export * from '../models/BackupPolicyResourceSelector.js';
export * from '../models/BackupPolicySecurityConfig.js';
export * from '../models/BackupPolicyType.js';
export * from '../models/BackupRegionsFilters.js';
export * from '../models/BackupSchedule.js';
export * from '../models/BackupScope.js';
export * from '../models/BackupScopeSummary.js';
export * from '../models/BackupStatus.js';
export * from '../models/BackupStatusFilters.js';
export * from '../models/BackupVault.js';
export * from '../models/BackupZeroEtlAccessConfiguration.js';
export * from '../models/BackupZeroEtlAwsAccessConfiguration.js';
export * from '../models/BackupZeroEtlAwsGlueCatalogConfiguration.js';
export * from '../models/BackupZeroEtlCatalogConfiguration.js';
export * from '../models/BackupZeroEtlFilters.js';
export * from '../models/BackupZeroEtlIcebergPartitionSpec.js';
export * from '../models/BackupZeroEtlIcebergPartitionTransform.js';
export * from '../models/BackupZeroEtlIcebergTransformType.js';
export * from '../models/BackupZeroEtlIdentityColumnField.js';
export * from '../models/BackupZeroEtlIdentityColumnSpec.js';
export * from '../models/BackupZeroEtlMultiResourceRoutingPolicy.js';
export * from '../models/BackupZeroEtlPolicy.js';
export * from '../models/BackupZeroEtlPolicyScope.js';
export * from '../models/BackupZeroEtlResourceSelector.js';
export * from '../models/BackupZeroEtlRoutingMode.js';
export * from '../models/BackupZeroEtlSingleResourcePartitionConfig.js';
export * from '../models/BackupZeroEtlSingleResourceRoutingPolicy.js';
export * from '../models/BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams.js';
export * from '../models/BackupZeroEtlSingleResourceTableMappingMode.js';
export * from '../models/BackupZeroEtlStorageConfiguration.js';
export * from '../models/BackupZeroEtlTableFilter.js';
export * from '../models/BatchApplicationOverrides.js';
export * from '../models/BatchOperationResponse.js';
export * from '../models/BatchResourceValidationResult.js';
export * from '../models/BatchUpdateLlgPoliciesRequest.js';
export * from '../models/BatchUpdateLlgPolicyItem.js';
export * from '../models/BatchValidateResourceConfigurationRequest.js';
export * from '../models/BatchValidateResourceConfigurationResponse.js';
export * from '../models/BigQueryDatasetDestination.js';
export * from '../models/BigQueryIntegrationConfig.js';
export * from '../models/BigQueryNativePitrBackupPolicyPlan.js';
export * from '../models/BigQueryNativePitrBackupResourceType.js';
export * from '../models/BigQueryNativePitrConfig.js';
export * from '../models/BigQueryNativePitrDestination.js';
export * from '../models/BillingPeriod.js';
export * from '../models/BillingProvider.js';
export * from '../models/BillingTransactionHistory.js';
export * from '../models/BooleanFilters.js';
export * from '../models/BulkAttachRestoreTemplateRequest.js';
export * from '../models/BulkDetachRestoreTemplateRequest.js';
export * from '../models/BulkRestoreItem.js';
export * from '../models/BulkRestoreItemStatus.js';
export * from '../models/BulkRestoreRequest.js';
export * from '../models/BulkRestoreResponse.js';
export * from '../models/BulkRestoreResponseItemsInner.js';
export * from '../models/BulkRestoreResponseJobsInner.js';
export * from '../models/BulkRestoreValidateRequest.js';
export * from '../models/BulkRestoreValidateResponse.js';
export * from '../models/BulkRestoreValidateResponseItemsInner.js';
export * from '../models/BulkSelectSnapshotStatus.js';
export * from '../models/BulkSelectSnapshotsForResourcesRequest.js';
export * from '../models/BulkSelectSnapshotsForResourcesResponse.js';
export * from '../models/BulkSelectSnapshotsForResourcesResponseItemsInner.js';
export * from '../models/CancelExclusionFromBackupResponse.js';
export * from '../models/CancelMyMPARequestResponse.js';
export * from '../models/CassandraClusterResource.js';
export * from '../models/CdcBackupModeCheckResult.js';
export * from '../models/CheckAzureVMNameExists200Response.js';
export * from '../models/CheckAzureVMNameExistsRequest.js';
export * from '../models/CheckCdcPrerequisitesResponse.js';
export * from '../models/ClassificationCategory.js';
export * from '../models/ClassificationPolicy.js';
export * from '../models/ClassificationPolicySchedule.js';
export * from '../models/Classifications.js';
export * from '../models/CloudAccountIdFilters.js';
export * from '../models/CloudAccountNotificationArguments.js';
export * from '../models/CloudAccountType.js';
export * from '../models/CloudProviderCondition.js';
export * from '../models/CloudProviderFilters.js';
export * from '../models/CloudRegion.js';
export * from '../models/CloudResourceAttachmentEvent.js';
export * from '../models/CloudResourceAttachmentEventType.js';
export * from '../models/CloudResourceConfiguration.js';
export * from '../models/CloudResourceConfigurationCdcBackup.js';
export * from '../models/CloudResourceConfigurationInventoryBackup.js';
export * from '../models/CloudResourceSecurityProperties.js';
export * from '../models/CloudSnapshotsPerVolume.js';
export * from '../models/ClusterNameFilters.js';
export * from '../models/CognitoExchangeRequest.js';
export * from '../models/CognitoExchangeResponse.js';
export * from '../models/ColumnMetadata.js';
export * from '../models/CompanyContact.js';
export * from '../models/ComplianceControlTrends.js';
export * from '../models/ComplianceSummary.js';
export * from '../models/ComplianceTrend.js';
export * from '../models/Condition.js';
export * from '../models/ConditionOperatorEnum.js';
export * from '../models/ConnectAtlasOrganizationRequest.js';
export * from '../models/ConnectAtlasOrganizationResponse.js';
export * from '../models/ConnectAzureBackupAccountRequest.js';
export * from '../models/ConnectAzureBackupApplicationsRequest.js';
export * from '../models/ConnectAzureRestoreAccountRequest.js';
export * from '../models/ConnectAzureSourceAccountRequest.js';
export * from '../models/ConnectAzureVaultAccountRequest.js';
export * from '../models/ConnectBYOApps200Response.js';
export * from '../models/ConnectBYOAppsRequest.js';
export * from '../models/ConnectBYOAzureBackupApplicationsRequest.js';
export * from '../models/ConnectCustomerVaultAccountRequest.js';
export * from '../models/ConnectCustomerVaultAccountResponse.js';
export * from '../models/ConnectGcpFolderRequest.js';
export * from '../models/ConnectGcpFolderResponse.js';
export * from '../models/ConnectGcpOrganizationRequest.js';
export * from '../models/ConnectGcpOrganizationResponse.js';
export * from '../models/ConnectRestoreAccountRequest.js';
export * from '../models/ConnectRestoreAccountResponse.js';
export * from '../models/ConnectRestoreAwsOrganizationalUnitRequest.js';
export * from '../models/ConnectRestoreAwsOrganizationalUnitResponse.js';
export * from '../models/ConnectSourceAccountRequest.js';
export * from '../models/ConnectSourceAccountResponse.js';
export * from '../models/ConnectSourceAwsOrganizationalUnitRequest.js';
export * from '../models/ConnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/Control.js';
export * from '../models/ControlComplianceEntry.js';
export * from '../models/ControlFailureCount.js';
export * from '../models/ControlPlaneConfig.js';
export * from '../models/ControlRules.js';
export * from '../models/ControlTrendEntry.js';
export * from '../models/ControlViolation.js';
export * from '../models/ControlViolations.js';
export * from '../models/ControlViolationsPerSeverity.js';
export * from '../models/ControlViolationsPerSeverityViolatedControlsInner.js';
export * from '../models/ControlsFilters.js';
export * from '../models/ConvertEbsSnapshotConfig.js';
export * from '../models/ConvertEc2ImageConfig.js';
export * from '../models/ConvertOtherSnapshotsOnDemandRequest.js';
export * from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.js';
export * from '../models/ConvertResourceSnapshotsRequest.js';
export * from '../models/ConvertResourceSnapshotsResponse.js';
export * from '../models/Cost.js';
export * from '../models/CostDataFilters.js';
export * from '../models/CostDataGroupBy.js';
export * from '../models/CostDataRecord.js';
export * from '../models/CostDataRecordCost.js';
export * from '../models/CostDataRecordDimensions.js';
export * from '../models/CostGranularity.js';
export * from '../models/CostProduct.js';
export * from '../models/CostProductFilters.js';
export * from '../models/CostRecordMetadata.js';
export * from '../models/CostRecordMetadataDataTransfer.js';
export * from '../models/CostRecordMetadataType.js';
export * from '../models/CostUnit.js';
export * from '../models/CreateAccountInput.js';
export * from '../models/CreateApiCredentialsRequest.js';
export * from '../models/CreateApiCredentialsResponse.js';
export * from '../models/CreateBackupPolicyRequest.js';
export * from '../models/CreateBackupPolicyResponse.js';
export * from '../models/CreateBackupZeroEtlPolicyInput.js';
export * from '../models/CreateClassificationPolicyRequest.js';
export * from '../models/CreateClassificationPolicyResponse.js';
export * from '../models/CreateDlsgPolicyRequest.js';
export * from '../models/CreateDlsgPolicyResponse.js';
export * from '../models/CreateFabricTableShortcutDemoRequest.js';
export * from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner.js';
export * from '../models/CreateFabricTableShortcutDemoResponse.js';
export * from '../models/CreateFabricTableShortcutDemoResponseResultsInner.js';
export * from '../models/CreateFindingExclusionPatternInput.js';
export * from '../models/CreateIdpGroupRequest.js';
export * from '../models/CreateIdpGroupResponse.js';
export * from '../models/CreateIntegrationRequest.js';
export * from '../models/CreateIntegrationResponse.js';
export * from '../models/CreateMPAPolicyRequest.js';
export * from '../models/CreateMPAPolicyResponse.js';
export * from '../models/CreateMPARequestReviewRequest.js';
export * from '../models/CreateMPARequestReviewResponse.js';
export * from '../models/CreateOAuthAppRequest.js';
export * from '../models/CreateOAuthAppResponse.js';
export * from '../models/CreateOrganizationIdpRequest.js';
export * from '../models/CreateOrganizationIdpResponse.js';
export * from '../models/CreatePolicyInput.js';
export * from '../models/CreatePolicyScheduleInput.js';
export * from '../models/CreateProjectInput.js';
export * from '../models/CreatePulumiConfigurationRequest.js';
export * from '../models/CreateRestoreTemplateRequest.js';
export * from '../models/CreateRestoreTemplateResponse.js';
export * from '../models/CreateRoleRequest.js';
export * from '../models/CreateRoleResponse.js';
export * from '../models/CreateSamlIdentityProviderConfigInput.js';
export * from '../models/CreateScanJobInput.js';
export * from '../models/CreateScanJobResponse.js';
export * from '../models/CreateSessionRequest.js';
export * from '../models/CreateThreatHuntingScanRequestRequest.js';
export * from '../models/CreateThreatHuntingScanRequestResponse.js';
export * from '../models/CreateUserInput.js';
export * from '../models/CreateVaultRequest.js';
export * from '../models/CreateVaultResponse.js';
export * from '../models/CredentialFinding.js';
export * from '../models/CreditsMonthlyUsageNotificationArguments.js';
export * from '../models/CreditsNotificationArguments.js';
export * from '../models/CrossResourceQueryRequest.js';
export * from '../models/CrossResourceQueryRequestResourcesInner.js';
export * from '../models/CustomTagsInner.js';
export * from '../models/CustomerVaultAccount.js';
export * from '../models/DBResourceMetadata.js';
export * from '../models/DBServerRecord.js';
export * from '../models/DBSnapshotMetadata.js';
export * from '../models/DBSnapshotType.js';
export * from '../models/DailyConfig.js';
export * from '../models/DailySnapshotData.js';
export * from '../models/DailyStorageSummaries.js';
export * from '../models/DailyStorageSummary.js';
export * from '../models/DataClassEntitiesFilters.js';
export * from '../models/DataClassesCondition.js';
export * from '../models/DataClassesDetails.js';
export * from '../models/DataClassesFilters.js';
export * from '../models/DataClassificationEntity.js';
export * from '../models/DataClassificationEntityOption.js';
export * from '../models/DataShareIntegrationConfig.js';
export * from '../models/DataTransferOperationType.js';
export * from '../models/DatabaseDestination.js';
export * from '../models/DatabaseRecord.js';
export * from '../models/DatabricksIntegrationConfig.js';
export * from '../models/DayOfWeek.js';
export * from '../models/DeactivateAccountRequest.js';
export * from '../models/DeactivateAccountResponse.js';
export * from '../models/DeactivateAtlasOrganizationResponse.js';
export * from '../models/DeactivateGcpFolderResponse.js';
export * from '../models/DeactivateGcpOrganizationResponse.js';
export * from '../models/DeleteGdsgObjectsRequest.js';
export * from '../models/DeleteGdsgObjectsResponse.js';
export * from '../models/DestinationDetails.js';
export * from '../models/DestinationProviderAttributes.js';
export * from '../models/DestinationProviderAttributesAzure.js';
export * from '../models/DestinationRestoreTypeAttributes.js';
export * from '../models/DetectorSummary.js';
export * from '../models/DetectorType.js';
export * from '../models/DetectorTypeFilters.js';
export * from '../models/DirectoryEntityRecord.js';
export * from '../models/DirectoryEntityType.js';
export * from '../models/DirectorySearchFilter.js';
export * from '../models/DisableResourceOverrideLimitsResponse.js';
export * from '../models/DisconnectCustomerVaultAccountResponse.js';
export * from '../models/DisconnectRestoreAccountResponse.js';
export * from '../models/DisconnectRestoreAwsOrganizationalUnitResponse.js';
export * from '../models/DisconnectSourceAccountResponse.js';
export * from '../models/DisconnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/DiscoveryInvokeParams.js';
export * from '../models/DiscoveryJob.js';
export * from '../models/DiscoveryStatusResponse.js';
export * from '../models/DlsgPolicy.js';
export * from '../models/DlsgPolicyConfig.js';
export * from '../models/DlsgPolicyFilters.js';
export * from '../models/DlsgPolicyPlan.js';
export * from '../models/DlsgSettings.js';
export * from '../models/DocumentDBRestoreDestination.js';
export * from '../models/DocumentDbClusterParameterGroup.js';
export * from '../models/DocumentDbClusterParameterGroups.js';
export * from '../models/DocumentDbSnapshotProperties.js';
export * from '../models/DownloadGdsgObjectsRequest.js';
export * from '../models/DriftProtectionPolicy.js';
export * from '../models/DriftProtectionSummary.js';
export * from '../models/DriftProtectionTimePoint.js';
export * from '../models/DsgBucketFilters.js';
export * from '../models/DsgEnvironmentFilters.js';
export * from '../models/DsgRegionFilters.js';
export * from '../models/DsgRequestType.js';
export * from '../models/DsgRequestTypeFilters.js';
export * from '../models/DsgStorageTier.js';
export * from '../models/DsgStorageTierFilters.js';
export * from '../models/DynamoDBAdvancedIndexConfig.js';
export * from '../models/DynamoDBRestoreMethodAvailabilityRequest.js';
export * from '../models/DynamoDBRestoreMethodAvailabilityResponse.js';
export * from '../models/DynamoDBRestoreToS3OutputFormat.js';
export * from '../models/DynamoDbBackupConfig.js';
export * from '../models/DynamoDbBackupConfigApplication.js';
export * from '../models/DynamoDbBillingMode.js';
export * from '../models/DynamodbTableRestoreDestination.js';
export * from '../models/EFSRestoreDestination.js';
export * from '../models/EbsRestoreDestination.js';
export * from '../models/EbsSnapshotRestoreDestination.js';
export * from '../models/EbsSnapshotTarget.js';
export * from '../models/EbsTarget.js';
export * from '../models/Ec2TemplateParams.js';
export * from '../models/Ec2TemplateParamsAdditionalTagsInner.js';
export * from '../models/EfsSnapshotProperties.js';
export * from '../models/EksCluster.js';
export * from '../models/EksClusterStatus.js';
export * from '../models/EksNamespaceRestoreDestination.js';
export * from '../models/EksNamespaceRestoreResult.js';
export * from '../models/EksVolumeRestoreResult.js';
export * from '../models/EmailSearchFilter.js';
export * from '../models/EmrIntegrationConfig.js';
export * from '../models/EnableFromLimitExceededResponse.js';
export * from '../models/EnableResourceOverrideLimitsResponse.js';
export * from '../models/EnableRestoreAccountMetricsConfigRequest.js';
export * from '../models/EnableRestoreAccountMetricsConfigResponse.js';
export * from '../models/EnableSourceAccountMetricsConfigRequest.js';
export * from '../models/EnableSourceAccountMetricsConfigResponse.js';
export * from '../models/EncryptionKey.js';
export * from '../models/EncryptionKeys.js';
export * from '../models/EncryptionType.js';
export * from '../models/EncryptionTypeCondition.js';
export * from '../models/EncryptionTypeFilters.js';
export * from '../models/EndTimeDateFilters.js';
export * from '../models/Environment.js';
export * from '../models/EnvironmentCondition.js';
export * from '../models/EnvironmentDetails.js';
export * from '../models/EnvironmentFilters.js';
export * from '../models/EonAccount.js';
export * from '../models/EonAccountIdFilters.js';
export * from '../models/EonAccountStatus.js';
export * from '../models/EonAccountType.js';
export * from '../models/EonOrganization.js';
export * from '../models/EonOrganizationSummary.js';
export * from '../models/ErrorCode.js';
export * from '../models/EvaluateRestoreTemplateResponse.js';
export * from '../models/EvidenceTypeFilters.js';
export * from '../models/ExcludeFromBackupResponse.js';
export * from '../models/ExclusionPatternFilterConditions.js';
export * from '../models/ExclusionPatternResourceFilter.js';
export * from '../models/ExportAccessDeniedItemsRequest.js';
export * from '../models/ExportComplianceReportRequest.js';
export * from '../models/ExportComplianceReportResponse.js';
export * from '../models/ExportCostData400Response.js';
export * from '../models/ExportCostDataRequest.js';
export * from '../models/FSxRestoreDestination.js';
export * from '../models/FSxRestoreDestinationOntapRestoreOptions.js';
export * from '../models/FeatureFlagOverrideGet200Response.js';
export * from '../models/FieldStatus.js';
export * from '../models/FileExplorerCountPathFilesResponse.js';
export * from '../models/FileExplorerCountSecurityAlertsInResourceResponse.js';
export * from '../models/FileExplorerCountWorkspaceEntitiesResponse.js';
export * from '../models/FileExplorerResponse.js';
export * from '../models/FilePath.js';
export * from '../models/FileRestoreData.js';
export * from '../models/FileSearchRecord.js';
export * from '../models/FileSnapshot.js';
export * from '../models/FindingCountEntry.js';
export * from '../models/FindingEntry.js';
export * from '../models/FindingExclusionPattern.js';
export * from '../models/FindingObjectType.js';
export * from '../models/FindingObjectTypeFilters.js';
export * from '../models/FindingResourceFilters.js';
export * from '../models/ForceDeleteSnapshotsRequest.js';
export * from '../models/FreeTextFilters.js';
export * from '../models/FsxOntapVolume.js';
export * from '../models/FsxSnapshotProperties.js';
export * from '../models/FsxVolumeBackupInfo.js';
export * from '../models/GCSBucket.js';
export * from '../models/GCSBuckets.js';
export * from '../models/GCSRestoreDestination.js';
export * from '../models/GCSRestoreTarget.js';
export * from '../models/GcpAccountConfigInput.js';
export * from '../models/GcpBigQueryDatasetRestoreResult.js';
export * from '../models/GcpBigQueryResource.js';
export * from '../models/GcpBigQueryResourceMaterializedViewsInner.js';
export * from '../models/GcpBigQueryResourceRoutinesInner.js';
export * from '../models/GcpBigQueryResourceTablesInner.js';
export * from '../models/GcpBigQueryResourceViewsInner.js';
export * from '../models/GcpCloudSqlResource.js';
export * from '../models/GcpCloudSqlResourceStorageSettings.js';
export * from '../models/GcpCloudSqlRestoreDestination.js';
export * from '../models/GcpCloudSqlSnapshotProperties.js';
export * from '../models/GcpCloudSqlTarget.js';
export * from '../models/GcpDiskResource.js';
export * from '../models/GcpDiskRestoreData.js';
export * from '../models/GcpDiskRestoreDestination.js';
export * from '../models/GcpDiskSettings.js';
export * from '../models/GcpDiskSnapshotProperties.js';
export * from '../models/GcpDiskTarget.js';
export * from '../models/GcpDiskTypesResponse.js';
export * from '../models/GcpEncryptionKey.js';
export * from '../models/GcpEncryptionKeys.js';
export * from '../models/GcpGcsResource.js';
export * from '../models/GcpGkeNamespaceResource.js';
export * from '../models/GcpLabelFilter.js';
export * from '../models/GcpMachineTypesResponse.js';
export * from '../models/GcpNetworkConnectivityConfig.js';
export * from '../models/GcpNetworkType.js';
export * from '../models/GcpOrganization.js';
export * from '../models/GcpRestoreAccountAttributes.js';
export * from '../models/GcpRestoreAccountAttributesInput.js';
export * from '../models/GcpRestoreAccountConnectivityConfig.js';
export * from '../models/GcpSapHanaResource.js';
export * from '../models/GcpSourceAccountAttributes.js';
export * from '../models/GcpSourceAccountAttributesInput.js';
export * from '../models/GcpSubnet.js';
export * from '../models/GcpSubnetPerRegion.js';
export * from '../models/GcpTagFilter.js';
export * from '../models/GcpVaultConfig.js';
export * from '../models/GcpVaultConfigInput.js';
export * from '../models/GcpVmInstanceRestoreDestination.js';
export * from '../models/GcpVmInstanceRestoreResult.js';
export * from '../models/GcpVmInstanceRestoreTarget.js';
export * from '../models/GcpVmResource.js';
export * from '../models/GcpVmSnapshotProperties.js';
export * from '../models/GcsLocationType.js';
export * from '../models/GdsgActiveBatchJobs.js';
export * from '../models/GdsgBigtableClusterStats.js';
export * from '../models/GdsgBigtableStorageTypeBytes.js';
export * from '../models/GdsgBigtableTableCpu.js';
export * from '../models/GdsgBigtableTableStorage.js';
export * from '../models/GdsgBucketStats.js';
export * from '../models/GdsgDeleteResult.js';
export * from '../models/GdsgDevStats.js';
export * from '../models/GdsgEnvironment.js';
export * from '../models/GdsgEnvironmentRegion.js';
export * from '../models/GdsgObjectEntry.js';
export * from '../models/GdsgOperationalNotificationArguments.js';
export * from '../models/GdsgOperationalWarning.js';
export * from '../models/GdsgQueueLagStats.js';
export * from '../models/GdsgRegionStats.js';
export * from '../models/GdsgRegionStatsPoint.js';
export * from '../models/GdsgStorageBreakdownEntry.js';
export * from '../models/GdsgStorageByBucketEntry.js';
export * from '../models/GdsgStorageByTierEntry.js';
export * from '../models/GdsgWorkerHeartbeatStats.js';
export * from '../models/GdsgWorkerHeartbeats.js';
export * from '../models/GenericSnapshotData.js';
export * from '../models/GetAWSStackDetailsResponse.js';
export * from '../models/GetActionApprovalSummaryResponse.js';
export * from '../models/GetAdditionalAzureAppsOnboardingStatus200Response.js';
export * from '../models/GetAgreementsResponse.js';
export * from '../models/GetAwsPrivateLinkStatusResponse.js';
export * from '../models/GetAzureQueryExportStorage200Response.js';
export * from '../models/GetBackupJobResponse.js';
export * from '../models/GetBackupPolicyResponse.js';
export * from '../models/GetBillingPeriodsResponse.js';
export * from '../models/GetBulkRestoreSnapshotHistogramRequest.js';
export * from '../models/GetBulkRestoreSnapshotHistogramResponse.js';
export * from '../models/GetClassificationPolicyResponse.js';
export * from '../models/GetCloudResourceSecurityPropertiesResponse.js';
export * from '../models/GetCredits400Response.js';
export * from '../models/GetCreditsResponse.js';
export * from '../models/GetDlsgPolicyResponse.js';
export * from '../models/GetGcsServiceAgentResponse.js';
export * from '../models/GetGdsgDevStatsResponse.js';
export * from '../models/GetGdsgRegionStatsResponse.js';
export * from '../models/GetIdpGroupResponse.js';
export * from '../models/GetIntegrationResponse.js';
export * from '../models/GetJobProgressStepsResponse.js';
export * from '../models/GetLimitsResponseValue.js';
export * from '../models/GetMPAPolicyResponse.js';
export * from '../models/GetMPARequestResponse.js';
export * from '../models/GetObjectStoreScanMethodResponse.js';
export * from '../models/GetProjectConfigurationKeyResponse.js';
export * from '../models/GetProjectConfigurationKeysResponse.js';
export * from '../models/GetResourceResponse.js';
export * from '../models/GetRestoreAccountCanDelete200Response.js';
export * from '../models/GetRestoreAccountConnectivityConfigResponse.js';
export * from '../models/GetRestoreAccountMetricsConfigResponse.js';
export * from '../models/GetRestoreAccountResponse.js';
export * from '../models/GetRestoreJobResponse.js';
export * from '../models/GetRestoreTemplateResponse.js';
export * from '../models/GetRoleResponse.js';
export * from '../models/GetScanJobResponse.js';
export * from '../models/GetSnapshotResponse.js';
export * from '../models/GetSourceAccountCanDelete200Response.js';
export * from '../models/GetSourceAccountMetricsConfigResponse.js';
export * from '../models/GetSourceAccountResponse.js';
export * from '../models/GetSqlVmNetworkInfoRequest.js';
export * from '../models/GetSqlVmNetworkInfoResponse.js';
export * from '../models/GetVaultResponse.js';
export * from '../models/GlobalClusterIdentifierCondition.js';
export * from '../models/GoogleWorkspaceBackupPolicyPlan.js';
export * from '../models/GoogleWorkspaceConnectionInfo.js';
export * from '../models/GoogleWorkspaceGroup.js';
export * from '../models/GoogleWorkspaceOrgUnit.js';
export * from '../models/GoogleWorkspaceResource.js';
export * from '../models/GoogleWorkspaceRestoreAccountAttributes.js';
export * from '../models/GoogleWorkspaceRestoreAccountAttributesInput.js';
export * from '../models/GoogleWorkspaceServiceAccountInfo.js';
export * from '../models/GoogleWorkspaceSharedDrive.js';
export * from '../models/GoogleWorkspaceSnapshotProperties.js';
export * from '../models/GoogleWorkspaceSourceAccountAttributes.js';
export * from '../models/GoogleWorkspaceSourceAccountAttributesInput.js';
export * from '../models/GoogleWorkspaceUser.js';
export * from '../models/GoogleWorkspaceWithPolicyStatus.js';
export * from '../models/GroupBreakdown.js';
export * from '../models/GroupBreakdownEntry.js';
export * from '../models/HighFrequencyBackupPolicyPlan.js';
export * from '../models/HighFrequencyBackupResourceType.js';
export * from '../models/HighFrequencyBackupScheduleConfig.js';
export * from '../models/HighFrequencyBackupScheduleFrequency.js';
export * from '../models/HighFrequencyBackupSchedules.js';
export * from '../models/HighFrequencyIntervalConfig.js';
export * from '../models/HoldSnapshotRequest.js';
export * from '../models/IDs.js';
export * from '../models/IdFilters.js';
export * from '../models/Identifier.js';
export * from '../models/IdentityProvidersNames.js';
export * from '../models/Idp.js';
export * from '../models/IdpGroup.js';
export * from '../models/ImportDlsgCertificateRequest.js';
export * from '../models/IndexRestoreMode.js';
export * from '../models/InfectedDataByClassification.js';
export * from '../models/InfectedDataClassificationSize.js';
export * from '../models/InfectedDataOverTime.js';
export * from '../models/InfectedDateSize.js';
export * from '../models/InfectedResourcesCountResponse.js';
export * from '../models/InitAuthInput.js';
export * from '../models/Initiator.js';
export * from '../models/InitiatorIdentity.js';
export * from '../models/InitiatorNameFilters.js';
export * from '../models/InitiatorType.js';
export * from '../models/IntegConfig.js';
export * from '../models/IntegType.js';
export * from '../models/IntegrationConfig.js';
export * from '../models/IntrospectRequest.js';
export * from '../models/IntrospectResponse.js';
export * from '../models/InventoryAzureDisk.js';
export * from '../models/InventoryBackupPolicy.js';
export * from '../models/InventoryClassificationPolicy.js';
export * from '../models/InventoryFilterConditions.js';
export * from '../models/InventoryGcpDisk.js';
export * from '../models/InventoryResource.js';
export * from '../models/InventoryResourceMetadata.js';
export * from '../models/InventorySnapshotVolume.js';
export * from '../models/InventoryVault.js';
export * from '../models/InventoryVolume.js';
export * from '../models/IsVaultDeletableResponse.js';
export * from '../models/IssueMutedNotificationArguments.js';
export * from '../models/IssueType.js';
export * from '../models/IssuesFilters.js';
export * from '../models/JobExecutionDetails.js';
export * from '../models/JobFailedNotificationArguments.js';
export * from '../models/JobIdFilters.js';
export * from '../models/JobInitiationResponse.js';
export * from '../models/JobMetricsReportFailedArguments.js';
export * from '../models/JobProgressStep.js';
export * from '../models/JobProgressStepBucketDataBackupData.js';
export * from '../models/JobProgressStepBucketDataBackupDataCoverage.js';
export * from '../models/JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner.js';
export * from '../models/JobProgressStepBucketDataRestorationData.js';
export * from '../models/JobProgressStepConnectingToRestoreServerData.js';
export * from '../models/JobProgressStepCreateInstanceData.js';
export * from '../models/JobProgressStepDatabaseClusterCreationData.js';
export * from '../models/JobProgressStepDatabaseDataRestorationData.js';
export * from '../models/JobProgressStepKind.js';
export * from '../models/JobProgressStepRestoreVolumeData.js';
export * from '../models/JobProgressStepRestoreWorkerData.js';
export * from '../models/JobProgressStepScanningBucketData.js';
export * from '../models/JobProgressStepScanningBucketDataTierByClassInner.js';
export * from '../models/JobProgressStepStatus.js';
export * from '../models/JobProgressStepVolumeCreationData.js';
export * from '../models/JobSnapshotDetails.js';
export * from '../models/JobStatus.js';
export * from '../models/JobStatusFilters.js';
export * from '../models/JobStep.js';
export * from '../models/JobStepName.js';
export * from '../models/JobStepStatus.js';
export * from '../models/JobSucceededNotificationArguments.js';
export * from '../models/KeyspacesBackupConfig.js';
export * from '../models/KeyspacesBackupConfigApplication.js';
export * from '../models/KeyspacesTableRestoreDestination.js';
export * from '../models/KubeAccessStatus.js';
export * from '../models/KubernetesAccessMode.js';
export * from '../models/LimitData.js';
export * from '../models/ListAccessibleAccountsResponse.js';
export * from '../models/ListAccountsResponse.js';
export * from '../models/ListAllRegionsResponse.js';
export * from '../models/ListAllRegionsResponseRegions.js';
export * from '../models/ListApiCredentialsResponse.js';
export * from '../models/ListApplicationOverrideResponse.js';
export * from '../models/ListAtlasOrganizationsResponse.js';
export * from '../models/ListAuditLogRequest.js';
export * from '../models/ListAuditLogResponse.js';
export * from '../models/ListAuditLogsResponse.js';
export * from '../models/ListAwsVpcsResponse.js';
export * from '../models/ListAwsVpcsResponseVpcsInner.js';
export * from '../models/ListAzureAppRegistrationsResponse.js';
export * from '../models/ListAzureCmkEligibleAppsResponse.js';
export * from '../models/ListAzureFileShares200Response.js';
export * from '../models/ListAzureFileShares200ResponseFileSharesInner.js';
export * from '../models/ListAzureFileSharesRequest.js';
export * from '../models/ListAzureRegions200Response.js';
export * from '../models/ListAzureSKUs200Response.js';
export * from '../models/ListAzureSKUs200ResponseSkusInner.js';
export * from '../models/ListAzureSKUsRequest.js';
export * from '../models/ListAzureStorageAccountContainers200Response.js';
export * from '../models/ListAzureStorageAccountContainersRequest.js';
export * from '../models/ListAzureSubnets200Response.js';
export * from '../models/ListAzureSubnets200ResponseSubnetsInner.js';
export * from '../models/ListAzureSubnetsRequest.js';
export * from '../models/ListAzureUnassignedNetworkInterfaces200Response.js';
export * from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.js';
export * from '../models/ListAzureUnassignedNetworkInterfacesRequest.js';
export * from '../models/ListAzureVirtualNetworks200Response.js';
export * from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner.js';
export * from '../models/ListAzureVirtualNetworksRequest.js';
export * from '../models/ListBackupJobTypesResponse.js';
export * from '../models/ListBackupJobsInternal200Response.js';
export * from '../models/ListBackupJobsRequest.js';
export * from '../models/ListBackupJobsResponse.js';
export * from '../models/ListBackupPoliciesResponse.js';
export * from '../models/ListBackupPolicyResponse.js';
export * from '../models/ListBackupVaultResponse.js';
export * from '../models/ListBackupZeroEtlPoliciesResponse.js';
export * from '../models/ListBillingTransactionHistoryRequest.js';
export * from '../models/ListBillingTransactionHistoryResponse.js';
export * from '../models/ListClassificationCategoriesResponse.js';
export * from '../models/ListClassificationPoliciesResponse.js';
export * from '../models/ListCloudSnapshotsResponse.js';
export * from '../models/ListComplianceResourcesResponse.js';
export * from '../models/ListControlViolationsResponse.js';
export * from '../models/ListControlsResponse.js';
export * from '../models/ListCredentialFindingsResponse.js';
export * from '../models/ListDailySnapshotsResponse.js';
export * from '../models/ListDataClassificationEntitiesResponse.js';
export * from '../models/ListDatabaseSnapshotsResponse.js';
export * from '../models/ListDlsgPoliciesResponse.js';
export * from '../models/ListDynamoDbBackupConfigsResponse.js';
export * from '../models/ListEksClustersResponse.js';
export * from '../models/ListExclusionPatternResourcesResponse.js';
export * from '../models/ListFindingExclusionPatternsRequest.js';
export * from '../models/ListFindingExclusionPatternsResponse.js';
export * from '../models/ListFindingsResponse.js';
export * from '../models/ListGcpFoldersResponse.js';
export * from '../models/ListGcpNetworksResponse.js';
export * from '../models/ListGcpNetworksResponseNetworksInner.js';
export * from '../models/ListGcpOrganizationsResponse.js';
export * from '../models/ListGcpSubnetsResponse.js';
export * from '../models/ListGdsgEnvironmentsResponse.js';
export * from '../models/ListGdsgObjectsResponse.js';
export * from '../models/ListGoogleWorkspaceGroups200Response.js';
export * from '../models/ListGoogleWorkspaceOrgUnits200Response.js';
export * from '../models/ListGoogleWorkspaceSharedDrives200Response.js';
export * from '../models/ListGoogleWorkspaceUsers200Response.js';
export * from '../models/ListGoogleWorkspacesWithPolicyStatusResponse.js';
export * from '../models/ListGroupConversationsRequest.js';
export * from '../models/ListIdpGroupsResponse.js';
export * from '../models/ListIdpsResponse.js';
export * from '../models/ListInfectedSnapshotsResponse.js';
export * from '../models/ListInitiatorsResponse.js';
export * from '../models/ListInstanceProfilesResponse.js';
export * from '../models/ListInstanceTypesResponse.js';
export * from '../models/ListIntegrationsResponse.js';
export * from '../models/ListInventoryAppsResponse.js';
export * from '../models/ListInventoryBackupRegionsResponse.js';
export * from '../models/ListInventoryClassificationEntitiesResponse.js';
export * from '../models/ListInventoryEnvironmentsResponse.js';
export * from '../models/ListInventoryGlobalDatabasesResponse.js';
export * from '../models/ListInventoryItemSnapshotsResponse.js';
export * from '../models/ListInventoryNetworksResponse.js';
export * from '../models/ListInventoryRequest.js';
export * from '../models/ListInventoryResourceGroupsResponse.js';
export * from '../models/ListInventoryResourceIdentifiersResponse.js';
export * from '../models/ListInventoryResourceTypesResponse.js';
export * from '../models/ListInventoryResourcesResponse.js';
export * from '../models/ListInventorySensitivityAnnotationValuesResponse.js';
export * from '../models/ListInventorySnapshotsRequest.js';
export * from '../models/ListInventorySnapshotsResponse.js';
export * from '../models/ListInventorySourceRegionsResponse.js';
export * from '../models/ListInventorySubnetsResponse.js';
export * from '../models/ListInventoryTagsResponse.js';
export * from '../models/ListJobErrorCodesResponse.js';
export * from '../models/ListKeyspacesBackupConfigsResponse.js';
export * from '../models/ListKnownAppsResponse.js';
export * from '../models/ListLogSourcesPoliciesResponse.js';
export * from '../models/ListLogSourcesResponse.js';
export * from '../models/ListMPAOperationsResponse.js';
export * from '../models/ListMPAPoliciesResponse.js';
export * from '../models/ListMPARequestsRequest.js';
export * from '../models/ListMPARequestsRequestFilters.js';
export * from '../models/ListMPARequestsResponse.js';
export * from '../models/ListMPARequestsSort.js';
export * from '../models/ListMicrosoft365GroupMembers200Response.js';
export * from '../models/ListMicrosoft365Groups200Response.js';
export * from '../models/ListMicrosoft365GroupsRequest.js';
export * from '../models/ListMicrosoft365SharePointSites200Response.js';
export * from '../models/ListMicrosoft365SharePointSitesRequest.js';
export * from '../models/ListMicrosoft365Users200Response.js';
export * from '../models/ListMicrosoft365UsersRequest.js';
export * from '../models/ListMongoAtlasPrivateLinks200Response.js';
export * from '../models/ListMongoDbBackupConfigsResponse.js';
export * from '../models/ListMyMPARequestsRequest.js';
export * from '../models/ListMyMPARequestsRequestFilters.js';
export * from '../models/ListMyMPARequestsResponse.js';
export * from '../models/ListNotificationPoliciesResponse.js';
export * from '../models/ListNotificationsResponse.js';
export * from '../models/ListOAuthAppsResponse.js';
export * from '../models/ListObjectStoreExclusionRulesResponse.js';
export * from '../models/ListOperators.js';
export * from '../models/ListOrganizationAccountsResponse.js';
export * from '../models/ListOrganizationIdpsResponse.js';
export * from '../models/ListPermissionsResponse.js';
export * from '../models/ListProjectsResponse.js';
export * from '../models/ListResourceAttachmentEventsResponse.js';
export * from '../models/ListResourcesResponse.js';
export * from '../models/ListRestoreAccountsRequest.js';
export * from '../models/ListRestoreAccountsResponse.js';
export * from '../models/ListRestoreAwsOrganizationalUnitsResponse.js';
export * from '../models/ListRestoreJobTypesResponse.js';
export * from '../models/ListRestoreJobsInternal200Response.js';
export * from '../models/ListRestoreJobsRequest.js';
export * from '../models/ListRestoreJobsResponse.js';
export * from '../models/ListRestoreTemplatesRequest.js';
export * from '../models/ListRestoreTemplatesResponse.js';
export * from '../models/ListRestoreTemplatesResponsePagination.js';
export * from '../models/ListRolesResponse.js';
export * from '../models/ListScanJobTypesResponse.js';
export * from '../models/ListScanJobsInternal200Response.js';
export * from '../models/ListScanJobsRequest.js';
export * from '../models/ListScanJobsResponse.js';
export * from '../models/ListSecurityFindingsRequest.js';
export * from '../models/ListSensitivityAnnotationsResponse.js';
export * from '../models/ListSourceAccountsRequest.js';
export * from '../models/ListSourceAccountsResponse.js';
export * from '../models/ListSourceAwsOrganizationalUnitsResponse.js';
export * from '../models/ListStorageGatewaysResponse.js';
export * from '../models/ListSubnetsResponse.js';
export * from '../models/ListSubnetsResponseV2.js';
export * from '../models/ListSubnetsResponseV2SubnetsInner.js';
export * from '../models/ListThreatHuntingResultsRequest.js';
export * from '../models/ListThreatHuntingResultsResponse.js';
export * from '../models/ListThreatHuntingScanRequestsRequest.js';
export * from '../models/ListThreatHuntingScanRequestsResponse.js';
export * from '../models/ListUsersResponse.js';
export * from '../models/LlgLocationResource.js';
export * from '../models/LlgLocationWithResources.js';
export * from '../models/LlgResourcePolicy.js';
export * from '../models/LogRecord.js';
export * from '../models/LogSource.js';
export * from '../models/LogSourceLocation.js';
export * from '../models/LogSourceLocationCloudTrail.js';
export * from '../models/LogSourceLocationCloudWatchLogs.js';
export * from '../models/LogSourceLocationDatadog.js';
export * from '../models/LogSourceLocationGcpCloudLogging.js';
export * from '../models/LogSourceLocationSplunkDdss.js';
export * from '../models/LogSourceWithPolicy.js';
export * from '../models/LogicalOperator.js';
export * from '../models/LogsHistogramDataPoint.js';
export * from '../models/LogsSchema.js';
export * from '../models/LogsSchemaColumn.js';
export * from '../models/LogsSchemaEntry.js';
export * from '../models/LogsSchemasResponse.js';
export * from '../models/LuceneQueryInput.js';
export * from '../models/MPADecision.js';
export * from '../models/MPAEntityType.js';
export * from '../models/MPAInterceptedResponse.js';
export * from '../models/MPAInterceptedResponseMpaPolicies.js';
export * from '../models/MPAListRequestSortField.js';
export * from '../models/MPAOperationInfo.js';
export * from '../models/MPAOperationScope.js';
export * from '../models/MPAOperationType.js';
export * from '../models/MPAPolicy.js';
export * from '../models/MPAPolicyExpression.js';
export * from '../models/MPAPolicyGroupCondition.js';
export * from '../models/MPARequest.js';
export * from '../models/MPARequestDetail.js';
export * from '../models/MPARequestListPerspective.js';
export * from '../models/MPARequestNotificationArguments.js';
export * from '../models/MPARequestPolicyDetail.js';
export * from '../models/MPARequestStatus.js';
export * from '../models/MPAResourceSelector.js';
export * from '../models/MPAReview.js';
export * from '../models/MPAReviewNotificationArguments.js';
export * from '../models/MPAReviewSubmitDecision.js';
export * from '../models/MPASubmitAction.js';
export * from '../models/MaxRetentionDaysLimit.js';
export * from '../models/MaxRetentionRule.js';
export * from '../models/Message.js';
export * from '../models/MeteringDimension.js';
export * from '../models/Microsoft365ConnectionInfo.js';
export * from '../models/Microsoft365EntitySelection.js';
export * from '../models/Microsoft365GraphPermission.js';
export * from '../models/Microsoft365Group.js';
export * from '../models/Microsoft365PolicyConfig.js';
export * from '../models/Microsoft365Resource.js';
export * from '../models/Microsoft365RestoreAccountAttributesInput.js';
export * from '../models/Microsoft365SelectionMode.js';
export * from '../models/Microsoft365SharePointSite.js';
export * from '../models/Microsoft365SourceAccountAttributesInput.js';
export * from '../models/Microsoft365User.js';
export * from '../models/MicrosoftFabricIntegrationConfig.js';
export * from '../models/MinRetentionRule.js';
export * from '../models/ModelError.js';
export * from '../models/MongoAtlasClusterResource.js';
export * from '../models/MongoAtlasPrivateLinkEntry.js';
export * from '../models/MongoAtlasRestoreAccountAttributes.js';
export * from '../models/MongoAtlasRestoreAccountAttributesInput.js';
export * from '../models/MongoAtlasSourceAccountAttributes.js';
export * from '../models/MongoAtlasSourceAccountAttributesInput.js';
export * from '../models/MongoDbBackupConfig.js';
export * from '../models/MonthlyConfig.js';
export * from '../models/MonthlySnapshotData.js';
export * from '../models/MsaAcceptanceResponse.js';
export * from '../models/MultiResourceBackupZeroEtlConfiguration.js';
export * from '../models/NativeStandardConfig.js';
export * from '../models/NeptuneClusterParameterGroup.js';
export * from '../models/NeptuneClusterParameterGroups.js';
export * from '../models/NeptuneRestoreDestination.js';
export * from '../models/NeptuneSnapshotProperties.js';
export * from '../models/NetworkClassification.js';
export * from '../models/NetworkClassificationCondition.js';
export * from '../models/NetworkClassificationDetails.js';
export * from '../models/NetworkClassificationFilters.js';
export * from '../models/NetworkInterfaceConfig.js';
export * from '../models/Notification.js';
export * from '../models/NotificationArguments.js';
export * from '../models/NotificationPolicy.js';
export * from '../models/NotificationPolicyConfig.js';
export * from '../models/NotificationPolicyConfigDatadog.js';
export * from '../models/NotificationPolicyConfigEmail.js';
export * from '../models/NotificationPolicyConfigServiceNow.js';
export * from '../models/NotificationPolicyConfigSlack.js';
export * from '../models/NotificationPolicyConfigSns.js';
export * from '../models/NotificationPolicyConfigSplunk.js';
export * from '../models/NotificationPolicyConfigWebhook.js';
export * from '../models/NotificationStatus.js';
export * from '../models/NotificationType.js';
export * from '../models/NumberOfCopiesRule.js';
export * from '../models/OAuthApp.js';
export * from '../models/Oauth2TokenResponse.js';
export * from '../models/ObjectStorageDestination.js';
export * from '../models/ObjectStoreCoverageBreakdown.js';
export * from '../models/ObjectStoreCoverageReason.js';
export * from '../models/ObjectStoreCoverageReasonEntry.js';
export * from '../models/ObjectStoreExclusionRule.js';
export * from '../models/ObjectStoreScanMethod.js';
export * from '../models/ObjectStoreScanMethodSetting.js';
export * from '../models/ObjectStoreTierClass.js';
export * from '../models/OnboardAdditionalAzureApps200Response.js';
export * from '../models/OnboardAdditionalAzureAppsRequest.js';
export * from '../models/OnboardRdsCdcRequest.js';
export * from '../models/OnboardRdsCdcResponse.js';
export * from '../models/OnboardingAzureResourceGroup.js';
export * from '../models/OperatingSystem.js';
export * from '../models/OperationIdFilters.js';
export * from '../models/OrganizationAccount.js';
export * from '../models/OrganizationAccountRole.js';
export * from '../models/OrganizationIdp.js';
export * from '../models/OrganizationSamlServiceProviderDetails.js';
export * from '../models/OverrideDataClassificationsRequest.js';
export * from '../models/OverrideDataClassificationsResponse.js';
export * from '../models/OverrideEnvironmentRequest.js';
export * from '../models/OverrideEnvironmentResponse.js';
export * from '../models/OverrideNetworkClassificationRequest.js';
export * from '../models/OverrideNetworkClassificationResponse.js';
export * from '../models/OverrideSensitivityAnnotationsRequest.js';
export * from '../models/Pagination.js';
export * from '../models/ParameterCheckResult.js';
export * from '../models/ParentIdFilters.js';
export * from '../models/PartialRestoreData.js';
export * from '../models/PartialRestoreType.js';
export * from '../models/Path.js';
export * from '../models/PathSnapshotsRequest.js';
export * from '../models/PathSnapshotsResponse.js';
export * from '../models/PathType.js';
export * from '../models/Permission.js';
export * from '../models/PermissionCategory.js';
export * from '../models/PermissionGrant.js';
export * from '../models/PermissionGrantInput.js';
export * from '../models/PermissionType.js';
export * from '../models/PersistentVolumeClaimProperties.js';
export * from '../models/PitrBackupPolicyPlan.js';
export * from '../models/PitrBackupResourceType.js';
export * from '../models/PitrBackupSchedules.js';
export * from '../models/PitrIntervalConfig.js';
export * from '../models/PitrRestoreVaultWindows.js';
export * from '../models/PitrRestoreWindow.js';
export * from '../models/PitrRestoreWindowsResponse.js';
export * from '../models/Preferences.js';
export * from '../models/PrivateLinkCheckResult.js';
export * from '../models/PrivateLinkFormatInstructions.js';
export * from '../models/PrivateLinkInstructionStep.js';
export * from '../models/Project.js';
export * from '../models/ProjectConfigurationKeyEnum.js';
export * from '../models/ProjectIdFilters.js';
export * from '../models/Provider.js';
export * from '../models/ProviderAccountIdFilters.js';
export * from '../models/ProviderCategory.js';
export * from '../models/ProviderCategoryFilters.js';
export * from '../models/ProviderParentIdFilters.js';
export * from '../models/ProviderRestoreAccountConnectivityConfig.js';
export * from '../models/PulumiConfiguration.js';
export * from '../models/PulumiConfigurations.js';
export * from '../models/PulumiConfigurationsFilterConditions.js';
export * from '../models/PulumiConfigurationsRequest.js';
export * from '../models/QueryCostData400Response.js';
export * from '../models/QueryCostDataRequest.js';
export * from '../models/QueryCostDataResponse.js';
export * from '../models/QueryDBRequest.js';
export * from '../models/QueryDBResponse.js';
export * from '../models/QueryDBRestoreDestination.js';
export * from '../models/QueryDBRestoreDestinationType.js';
export * from '../models/QueryDBResultResponse.js';
export * from '../models/QueryDBStatus.js';
export * from '../models/QueryDBStatusResponse.js';
export * from '../models/QuotaStatus.js';
export * from '../models/QuotaStatusFilters.js';
export * from '../models/RamShareCheckResult.js';
export * from '../models/RansomwareResourceNotificationArguments.js';
export * from '../models/RdsNativePitrAdvancedConfig.js';
export * from '../models/RdsNativePitrClusterAdvancedConfig.js';
export * from '../models/RdsNativePitrNetworkConfig.js';
export * from '../models/RdsNativePitrWindow.js';
export * from '../models/RdsPasswordConfig.js';
export * from '../models/RdsSecurityGroup.js';
export * from '../models/ReactivateAccountRequest.js';
export * from '../models/ReassessActionRequiredRequest.js';
export * from '../models/ReassessActionRequiredResponse.js';
export * from '../models/ReconnectCustomerVaultAccountResponse.js';
export * from '../models/ReconnectRestoreAccountResponse.js';
export * from '../models/ReconnectRestoreAwsOrganizationalUnitResponse.js';
export * from '../models/ReconnectSourceAccountResponse.js';
export * from '../models/ReconnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/RecordRestoreResult.js';
export * from '../models/RecoveryPointData.js';
export * from '../models/RegionCondition.js';
export * from '../models/RegisterInput.js';
export * from '../models/RegisterInputBillingToken.js';
export * from '../models/RegisterResponse.js';
export * from '../models/RelatedGlobalDbCluster.js';
export * from '../models/RequestDetails.js';
export * from '../models/ResourceBackupSettings.js';
export * from '../models/ResourceBlockerDetail.js';
export * from '../models/ResourceBlockerType.js';
export * from '../models/ResourceComplianceRow.js';
export * from '../models/ResourceDetails.js';
export * from '../models/ResourceGroupNameCondition.js';
export * from '../models/ResourceIdCondition.js';
export * from '../models/ResourceIdFilters.js';
export * from '../models/ResourceIdentifiers.js';
export * from '../models/ResourceNameCondition.js';
export * from '../models/ResourceNameFilters.js';
export * from '../models/ResourceProperties.js';
export * from '../models/ResourceQuota.js';
export * from '../models/ResourceReference.js';
export * from '../models/ResourceSelectorMode.js';
export * from '../models/ResourceSnapshot.js';
export * from '../models/ResourceSnapshotProperties.js';
export * from '../models/ResourceSortField.js';
export * from '../models/ResourceTag.js';
export * from '../models/ResourceType.js';
export * from '../models/ResourceTypeCondition.js';
export * from '../models/ResourceTypeFilters.js';
export * from '../models/ResourceTypeToSecurityGroup.js';
export * from '../models/ResourceValidationError.js';
export * from '../models/RestoreAccount.js';
export * from '../models/RestoreAccountAttributesInput.js';
export * from '../models/RestoreAccountCloudAttributes.js';
export * from '../models/RestoreAccountConnectivityConfig.js';
export * from '../models/RestoreAccountMetricsConfig.js';
export * from '../models/RestoreAccountRegions.js';
export * from '../models/RestoreAccountSortField.js';
export * from '../models/RestoreAccountsFilterConditions.js';
export * from '../models/RestoreAtlasClusterInput.js';
export * from '../models/RestoreAvailabilityZones.js';
export * from '../models/RestoreAwsCassandraClusterRequest.js';
export * from '../models/RestoreAwsEc2InstanceRequest.js';
export * from '../models/RestoreAwsOrganizationalUnit.js';
export * from '../models/RestoreAzureDiskConfig.js';
export * from '../models/RestoreAzureDiskRequest.js';
export * from '../models/RestoreAzureFileShareRequest.js';
export * from '../models/RestoreAzureInstanceDiskInput.js';
export * from '../models/RestoreAzurePostgresDatabaseRequest.js';
export * from '../models/RestoreAzureSqlDatabaseNativePitrRequest.js';
export * from '../models/RestoreAzureSqlDatabaseRequest.js';
export * from '../models/RestoreAzureSqlVmPitrRequest.js';
export * from '../models/RestoreAzureVMInstanceConfig.js';
export * from '../models/RestoreAzureVmInstanceRequest.js';
export * from '../models/RestoreBigQueryDatasetRequest.js';
export * from '../models/RestoreBigQueryNativePitrRequest.js';
export * from '../models/RestoreBucketRequest.js';
export * from '../models/RestoreDbToRdsInstanceRequest.js';
export * from '../models/RestoreDbToRdsSnapshotRequest.js';
export * from '../models/RestoreDestinationLimits.js';
export * from '../models/RestoreDocumentDBRequest.js';
export * from '../models/RestoreDynamoDBTableRequest.js';
export * from '../models/RestoreDynamoDBToExistingTableRequest.js';
export * from '../models/RestoreDynamoDBToS3Request.js';
export * from '../models/RestoreDynamoDbTableConfig.js';
export * from '../models/RestoreEFSRequest.js';
export * from '../models/RestoreEbsVolumeConfig.js';
export * from '../models/RestoreEc2InstanceConfig.js';
export * from '../models/RestoreEksNamespaceConfig.js';
export * from '../models/RestoreEksNamespaceInput.js';
export * from '../models/RestoreEksNamespaceVolumeInput.js';
export * from '../models/RestoreFSxRequest.js';
export * from '../models/RestoreFilesRequest.js';
export * from '../models/RestoreGceDiskConfig.js';
export * from '../models/RestoreGceInstanceConfig.js';
export * from '../models/RestoreGcpCloudSqlDatabaseConfig.js';
export * from '../models/RestoreGcpCloudSqlRequest.js';
export * from '../models/RestoreGcpDiskRequest.js';
export * from '../models/RestoreGcpInstanceDiskInput.js';
export * from '../models/RestoreGcpVmInstanceRequest.js';
export * from '../models/RestoreGoogleWorkspaceRequest.js';
export * from '../models/RestoreImageImageDeviceInput.js';
export * from '../models/RestoreImageImageInput.js';
export * from '../models/RestoreImageInput.js';
export * from '../models/RestoreImageVolumeInput.js';
export * from '../models/RestoreInstanceImageDeviceInput.js';
export * from '../models/RestoreInstanceImageInput.js';
export * from '../models/RestoreInstanceVolumeInput.js';
export * from '../models/RestoreJob.js';
export * from '../models/RestoreJobConfiguration.js';
export * from '../models/RestoreJobInitiationResponse.js';
export * from '../models/RestoreJobSortField.js';
export * from '../models/RestoreJobType.js';
export * from '../models/RestoreJobTypeFilters.js';
export * from '../models/RestoreJobsFilterConditions.js';
export * from '../models/RestoreKeyspacesTableRequest.js';
export * from '../models/RestoreMethod.js';
export * from '../models/RestoreMethodAvailabilityReason.js';
export * from '../models/RestoreMicrosoft365Request.js';
export * from '../models/RestoreNeptuneRequest.js';
export * from '../models/RestoreObfuscationConfig.js';
export * from '../models/RestoreRdsInstanceClasses.js';
export * from '../models/RestoreRdsInstanceConfig.js';
export * from '../models/RestoreRdsNativePitrRequest.js';
export * from '../models/RestoreRdsSubnetGroups.js';
export * from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner.js';
export * from '../models/RestoreResult.js';
export * from '../models/RestoreSecurityGroups.js';
export * from '../models/RestoreSecurityGroupsSecurityGroupsInner.js';
export * from '../models/RestoreTemplate.js';
export * from '../models/RestoreTemplateFilterConditions.js';
export * from '../models/RestoreTemplateIdFilters.js';
export * from '../models/RestoreTemplateResourceType.js';
export * from '../models/RestoreTemplateResourceTypeFilters.js';
export * from '../models/RestoreVolumeToEbsRequest.js';
export * from '../models/RestoreVolumeToEbsSnapshotRequest.js';
export * from '../models/RevalidateRestoreTemplateRequest.js';
export * from '../models/RevalidateRestoreTemplateResponse.js';
export * from '../models/RevalidationReport.js';
export * from '../models/RevalidationStatus.js';
export * from '../models/Role.js';
export * from '../models/RoleAccessGroupCondition.js';
export * from '../models/RoleInstallationMethod.js';
export * from '../models/RoleUsage.js';
export * from '../models/RuleComponent.js';
export * from '../models/RuleOutcome.js';
export * from '../models/RuleOutcomeList.js';
export * from '../models/S3Bucket.js';
export * from '../models/S3Buckets.js';
export * from '../models/S3RestoreDestination.js';
export * from '../models/S3RestoreTarget.js';
export * from '../models/S3TemplateParams.js';
export * from '../models/SAMLCallback400Response.js';
export * from '../models/SAMLCallback401Response.js';
export * from '../models/SAMLCallback500Response.js';
export * from '../models/SameSourceAccountRestoreLimits.js';
export * from '../models/SamlIdentityProvider.js';
export * from '../models/SamlIdentityProviderConfigsResponse.js';
export * from '../models/SapHanaInstance.js';
export * from '../models/SapHanaRestoreProperties.js';
export * from '../models/SaveCloudResourceSecurityPropertiesRequest.js';
export * from '../models/ScalarOperators.js';
export * from '../models/ScanJob.js';
export * from '../models/ScanJobType.js';
export * from '../models/ScheduleMode.js';
export * from '../models/ScheduleTimezone.js';
export * from '../models/ScheduleType.js';
export * from '../models/SchemaRecord.js';
export * from '../models/SearchDBResponse.js';
export * from '../models/SearchDirectoryEntitiesRequest.js';
export * from '../models/SearchDirectoryEntitiesResponse.js';
export * from '../models/SearchFilesResponse.js';
export * from '../models/SearchInput.js';
export * from '../models/SearchLogsHistogramInput.js';
export * from '../models/SearchLogsHistogramResponse.js';
export * from '../models/SearchLogsInput.js';
export * from '../models/SearchLogsResponse.js';
export * from '../models/SearchResources200Response.js';
export * from '../models/SearchResources200ResponseTablesInner.js';
export * from '../models/SearchResources200ResponseTablesInnerResource.js';
export * from '../models/SearchResources200ResponseTablesInnerSnapshots.js';
export * from '../models/SearchResources200ResponseTablesInnerSource.js';
export * from '../models/SearchResources200ResponseTablesInnerTablesInner.js';
export * from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner.js';
export * from '../models/SearchResourcesRequest.js';
export * from '../models/SecurityAssignmentStatus.js';
export * from '../models/SecurityFindingsFilterConditions.js';
export * from '../models/SecurityInformation.js';
export * from '../models/SecurityPlan.js';
export * from '../models/SecurityPlanEnabledResponse.js';
export * from '../models/SecurityResourceNotificationArguments.js';
export * from '../models/SecurityScan.js';
export * from '../models/SecurityScanConclusion.js';
export * from '../models/SecurityScanConclusionCondition.js';
export * from '../models/SecurityScanConclusionFilters.js';
export * from '../models/SecurityScanNotificationData.js';
export * from '../models/SecurityScanResult.js';
export * from '../models/SecurityScansSummaryResponse.js';
export * from '../models/SecuritySnapshotNotificationArguments.js';
export * from '../models/SecuritySummary.js';
export * from '../models/SendA2AMessageRequest.js';
export * from '../models/SendMessageToAI400Response.js';
export * from '../models/SendMessageToAIRequest.js';
export * from '../models/SensitivityAnnotation.js';
export * from '../models/SensitivityAnnotationsCondition.js';
export * from '../models/SensitivityLabelsDetails.js';
export * from '../models/SensitivityLabelsFilters.js';
export * from '../models/SensitivityLevel.js';
export * from '../models/ServiceProviderDetails.js';
export * from '../models/Session.js';
export * from '../models/SessionScope.js';
export * from '../models/SetupAwsPrivateLinkRequest.js';
export * from '../models/SetupAwsPrivateLinkResponse.js';
export * from '../models/SetupMongoAtlasPrivateLinkRequest.js';
export * from '../models/SetupMongoAtlasPrivateLinkResponse.js';
export * from '../models/Severity.js';
export * from '../models/SeverityFilterValue.js';
export * from '../models/SeverityFilters.js';
export * from '../models/SingleResourceBackupZeroEtlConfiguration.js';
export * from '../models/Snapshot.js';
export * from '../models/SnapshotAccessDeniedNotificationArguments.js';
export * from '../models/SnapshotCoverage.js';
export * from '../models/SnapshotCoverageAvailability.js';
export * from '../models/SnapshotDateFilters.js';
export * from '../models/SnapshotFilterConditions.js';
export * from '../models/SnapshotFindingCountsResponse.js';
export * from '../models/SnapshotHistogramBucket.js';
export * from '../models/SnapshotIdFilters.js';
export * from '../models/SnapshotLocation.js';
export * from '../models/SnapshotRangePick.js';
export * from '../models/SnapshotReference.js';
export * from '../models/SnapshotSortField.js';
export * from '../models/SnapshotStatus.js';
export * from '../models/SnapshotStorage.js';
export * from '../models/SnapshotTimeFilters.js';
export * from '../models/SnapshotsSummaryResponse.js';
export * from '../models/SnowflakeIntegrationConfig.js';
export * from '../models/SortBackupJobBy.js';
export * from '../models/SortLogsBy.js';
export * from '../models/SortOrder.js';
export * from '../models/SortResourceBy.js';
export * from '../models/SortRestoreAccountsBy.js';
export * from '../models/SortRestoreJobBy.js';
export * from '../models/SortSnapshotsBy.js';
export * from '../models/SortSourceAccountsBy.js';
export * from '../models/SourceAccount.js';
export * from '../models/SourceAccountAttributesInput.js';
export * from '../models/SourceAccountCloudAttributes.js';
export * from '../models/SourceAccountMetricsConfig.js';
export * from '../models/SourceAccountProviderIdFilters.js';
export * from '../models/SourceAccountSortField.js';
export * from '../models/SourceAccountsFilterConditions.js';
export * from '../models/SourceAwsOrganizationalUnit.js';
export * from '../models/SourceRegionFilters.js';
export * from '../models/SourceSizeCheckResult.js';
export * from '../models/SourceStorage.js';
export * from '../models/SourceStorageBackupStatus.js';
export * from '../models/SqlInstructions.js';
export * from '../models/SqlVmNetworkInfo.js';
export * from '../models/SsoIntegrationSettings.js';
export * from '../models/StackNameFilters.js';
export * from '../models/StandardBackupPolicyPlan.js';
export * from '../models/StandardBackupScheduleConfig.js';
export * from '../models/StandardBackupScheduleFrequency.js';
export * from '../models/StandardBackupSchedules.js';
export * from '../models/StandardIntervalConfig.js';
export * from '../models/StartTimeDateFilters.js';
export * from '../models/StatusCodeFilters.js';
export * from '../models/StatusProperties.js';
export * from '../models/StepProgressMetric.js';
export * from '../models/StepProgressUnit.js';
export * from '../models/StepProgressView.js';
export * from '../models/StorageAccountContainerRestoreDestination.js';
export * from '../models/StorageAccountRestoreTarget.js';
export * from '../models/StorageGateway.js';
export * from '../models/StorageGatewayDetails.js';
export * from '../models/StorageGatewayStatus.js';
export * from '../models/StringOperators.js';
export * from '../models/SubmitMyMPARequestRequest.js';
export * from '../models/SubmitMyMPARequestResponse.js';
export * from '../models/SubnetConfig.js';
export * from '../models/SubnetFilters.js';
export * from '../models/SubnetPerAvailabilityZone.js';
export * from '../models/SubnetsCondition.js';
export * from '../models/SupportedProviders.js';
export * from '../models/TableRecord.js';
export * from '../models/TagKeyValue.js';
export * from '../models/TagKeyValuesCondition.js';
export * from '../models/TagKeyValuesFilters.js';
export * from '../models/TagKeysCondition.js';
export * from '../models/TagKeysFilters.js';
export * from '../models/TakeNativeSnapshotRequest.js';
export * from '../models/TakeSnapshotRequest.js';
export * from '../models/TakeSnapshotResponse.js';
export * from '../models/TeardownAwsPrivateLinkResponse.js';
export * from '../models/TeardownMongoAtlasPrivateLinkResponse.js';
export * from '../models/ThreatDetectionFilters.js';
export * from '../models/ThreatHuntingResult.js';
export * from '../models/ThreatHuntingScanRequest.js';
export * from '../models/ThreatHuntingStatus.js';
export * from '../models/TimeFrame.js';
export * from '../models/TimeOfDay.js';
export * from '../models/TimeOfYear.js';
export * from '../models/TokenResponse.js';
export * from '../models/TotalSourceStorageSizeRequest.js';
export * from '../models/TotalSourceStorageSizeResponse.js';
export * from '../models/TrendPoint.js';
export * from '../models/TriggerKeyspacesScheduledDump200Response.js';
export * from '../models/UnifiedDBRecord.js';
export * from '../models/UnifiedDBServerRecord.js';
export * from '../models/UnifiedDatabaseRecord.js';
export * from '../models/UnifiedSchemaRecord.js';
export * from '../models/UnifiedTableRecord.js';
export * from '../models/UpPulumiStacksResponse.js';
export * from '../models/UpdateAccountCompanyContactsRequest.js';
export * from '../models/UpdateAccountLabelsRequest.js';
export * from '../models/UpdateAccountProfileResponse.js';
export * from '../models/UpdateApiCredentialsRequest.js';
export * from '../models/UpdateAwsRestoreAccountAttributes.js';
export * from '../models/UpdateAwsSourceAccountAttributes.js';
export * from '../models/UpdateBackupPolicyRequest.js';
export * from '../models/UpdateBackupPolicyResponse.js';
export * from '../models/UpdateBackupZeroEtlPolicyInput.js';
export * from '../models/UpdateClassificationPolicyRequest.js';
export * from '../models/UpdateClassificationPolicyResponse.js';
export * from '../models/UpdateCloudResourceConfigurationRequest.js';
export * from '../models/UpdateCloudResourceConfigurationRequestCdcBackup.js';
export * from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup.js';
export * from '../models/UpdateControlViolationInput.js';
export * from '../models/UpdateDlsgPolicyRequest.js';
export * from '../models/UpdateDlsgPolicyResponse.js';
export * from '../models/UpdateGcpRestoreAccountAttributes.js';
export * from '../models/UpdateGcpSourceAccountAttributes.js';
export * from '../models/UpdateIdpGroupRequest.js';
export * from '../models/UpdateIdpGroupResponse.js';
export * from '../models/UpdateIntegrationRequest.js';
export * from '../models/UpdateIntegrationResponse.js';
export * from '../models/UpdateMPAPolicyRequest.js';
export * from '../models/UpdateMPAPolicyResponse.js';
export * from '../models/UpdateObjectStoreScanMethodRequest.js';
export * from '../models/UpdateObjectStoreScanMethodResponse.js';
export * from '../models/UpdateOrganizationIdpRequest.js';
export * from '../models/UpdateOrganizationIdpResponse.js';
export * from '../models/UpdateProjectConfigurationKeyRequest.js';
export * from '../models/UpdatePulumiConfigurationRequest.js';
export * from '../models/UpdateResourceSecurityScansExclusionRequest.js';
export * from '../models/UpdateRestoreAccountAttributesInput.js';
export * from '../models/UpdateRestoreAccountConnectivityConfigRequest.js';
export * from '../models/UpdateRestoreAccountConnectivityConfigResponse.js';
export * from '../models/UpdateRestoreAccountRequest.js';
export * from '../models/UpdateRestoreAccountResponse.js';
export * from '../models/UpdateRestoreTemplateRequest.js';
export * from '../models/UpdateRestoreTemplateResponse.js';
export * from '../models/UpdateRoleRequest.js';
export * from '../models/UpdateRoleResponse.js';
export * from '../models/UpdateSamlIdentityProviderInput.js';
export * from '../models/UpdateSessionRequest.js';
export * from '../models/UpdateShouldFullBackupResourceRequest.js';
export * from '../models/UpdateSourceAccountAttributesInput.js';
export * from '../models/UpdateSourceAccountRequest.js';
export * from '../models/UpdateSourceAccountResponse.js';
export * from '../models/UpdateThreatHuntingScanRequestRequest.js';
export * from '../models/UpdateUserInput.js';
export * from '../models/UpdateVaultRequest.js';
export * from '../models/UpdateVaultResponse.js';
export * from '../models/UpdateViewerRoleRequest.js';
export * from '../models/Usage.js';
export * from '../models/UsageType.js';
export * from '../models/UsageTypeFilters.js';
export * from '../models/UsageUnit.js';
export * from '../models/User.js';
export * from '../models/UserIdFilters.js';
export * from '../models/VNetConfig.js';
export * from '../models/ValidateResourceConfigurationRequest.js';
export * from '../models/ValidateResourceConfigurationResponse.js';
export * from '../models/VaultFilters.js';
export * from '../models/VaultMetadataReplicationConfig.js';
export * from '../models/VaultNotificationArguments.js';
export * from '../models/VaultProtectionMode.js';
export * from '../models/VaultProviderAttributes.js';
export * from '../models/VaultProviderAttributesInput.js';
export * from '../models/VaultSnapshotCount.js';
export * from '../models/VaultStatus.js';
export * from '../models/VaultTieringPolicy.js';
export * from '../models/VaultTieringPolicyType.js';
export * from '../models/VerifyMongoAtlasPrivateLinkResponse.js';
export * from '../models/Viewer.js';
export * from '../models/ViolationsDetectionNotificationArguments.js';
export * from '../models/VirtualMachineRestoreDestination.js';
export * from '../models/VisualizationHistogramSeries.js';
export * from '../models/VisualizationHistogramTimePoint.js';
export * from '../models/VisualizationLabel.js';
export * from '../models/VolumeSettings.js';
export * from '../models/VpcCondition.js';
export * from '../models/VpcPropertyFilters.js';
export * from '../models/WeeklyConfig.js';
export * from '../models/WorkspaceRestoreMode.js';
export * from '../models/YearlySnapshotDistribution.js';
import { AccessCondition } from '../models/AccessCondition.js';
import { AccessConditionalExpression } from '../models/AccessConditionalExpression.js';
import { AccessibleOrganizationAccount } from '../models/AccessibleOrganizationAccount.js';
import { Account } from '../models/Account.js';
import { AccountConfigInput } from '../models/AccountConfigInput.js';
import { AccountDisplayNameFilters } from '../models/AccountDisplayNameFilters.js';
import { AccountIdCondition } from '../models/AccountIdCondition.js';
import { AccountIdFilters } from '../models/AccountIdFilters.js';
import { AccountMetricsDestination } from '../models/AccountMetricsDestination.js';
import { AccountNameFilters } from '../models/AccountNameFilters.js';
import { AccountStatusFilters } from '../models/AccountStatusFilters.js';
import { AccountUpdateInput } from '../models/AccountUpdateInput.js';
import { AccountVersion } from '../models/AccountVersion.js';
import { ActionFilters } from '../models/ActionFilters.js';
import { ActivateAtlasOrganizationResponse } from '../models/ActivateAtlasOrganizationResponse.js';
import { ActivateGcpFolderResponse } from '../models/ActivateGcpFolderResponse.js';
import { ActivateGcpOrganizationResponse } from '../models/ActivateGcpOrganizationResponse.js';
import { AddRestoreAtlasPrivateLinkRequest } from '../models/AddRestoreAtlasPrivateLinkRequest.js';
import { AdeRestoreEncryptionConfig } from '../models/AdeRestoreEncryptionConfig.js';
import { AgreementWithCredits } from '../models/AgreementWithCredits.js';
import { Ami } from '../models/Ami.js';
import { AmiBlockDevice } from '../models/AmiBlockDevice.js';
import { AnnuallyConfig } from '../models/AnnuallyConfig.js';
import { AnomalyDataPoint } from '../models/AnomalyDataPoint.js';
import { AnomalyGraphData } from '../models/AnomalyGraphData.js';
import { ApiCredentials } from '../models/ApiCredentials.js';
import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties.js';
import { App } from '../models/App.js';
import { AppFilters } from '../models/AppFilters.js';
import { ApplicationOverride } from '../models/ApplicationOverride.js';
import { AppsCondition } from '../models/AppsCondition.js';
import { AppsDetails } from '../models/AppsDetails.js';
import { AtlasCluster } from '../models/AtlasCluster.js';
import { AtlasClusters } from '../models/AtlasClusters.js';
import { AtlasOrganization } from '../models/AtlasOrganization.js';
import { AtlasProject } from '../models/AtlasProject.js';
import { AtlasProjects } from '../models/AtlasProjects.js';
import { AuditLog } from '../models/AuditLog.js';
import { AuditLogCloudContext } from '../models/AuditLogCloudContext.js';
import { AuditLogEntitiesInner } from '../models/AuditLogEntitiesInner.js';
import { AuditLogExtendedData } from '../models/AuditLogExtendedData.js';
import { AuditLogExtendedDataAuth } from '../models/AuditLogExtendedDataAuth.js';
import { AuditLogExtendedDataMpa } from '../models/AuditLogExtendedDataMpa.js';
import { AuditLogFilterConditions } from '../models/AuditLogFilterConditions.js';
import { AuditLogSecurityContext } from '../models/AuditLogSecurityContext.js';
import { AuditLogStateSnapshot } from '../models/AuditLogStateSnapshot.js';
import { AuthResponse } from '../models/AuthResponse.js';
import { AuthV2AssociateSoftwareTokenRequest } from '../models/AuthV2AssociateSoftwareTokenRequest.js';
import { AuthV2AssociateSoftwareTokenResponse } from '../models/AuthV2AssociateSoftwareTokenResponse.js';
import { AuthV2ConfirmForgotPasswordRequest } from '../models/AuthV2ConfirmForgotPasswordRequest.js';
import { AuthV2ForgotPasswordRequest } from '../models/AuthV2ForgotPasswordRequest.js';
import { AuthV2ForgotPasswordResponse } from '../models/AuthV2ForgotPasswordResponse.js';
import { AuthV2LoginRequest } from '../models/AuthV2LoginRequest.js';
import { AuthV2RespondChallengeRequest } from '../models/AuthV2RespondChallengeRequest.js';
import { AuthV2VerifySoftwareTokenRequest } from '../models/AuthV2VerifySoftwareTokenRequest.js';
import { AuthV2VerifySoftwareTokenResponse } from '../models/AuthV2VerifySoftwareTokenResponse.js';
import { AwsAccountConfigInput } from '../models/AwsAccountConfigInput.js';
import { AwsAccountMetricsDestination } from '../models/AwsAccountMetricsDestination.js';
import { AwsCassandraClusterRestoreDestination } from '../models/AwsCassandraClusterRestoreDestination.js';
import { AwsCassandraClusterRestoreTarget } from '../models/AwsCassandraClusterRestoreTarget.js';
import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination.js';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination.js';
import { AwsDynamoDbResource } from '../models/AwsDynamoDbResource.js';
import { AwsDynamoDbSnapshotProperties } from '../models/AwsDynamoDbSnapshotProperties.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.js';
import { AwsEbsSnapshotConvertResult } from '../models/AwsEbsSnapshotConvertResult.js';
import { AwsEbsVolumeResource } from '../models/AwsEbsVolumeResource.js';
import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData.js';
import { AwsEbsVolumeRestoreResult } from '../models/AwsEbsVolumeRestoreResult.js';
import { AwsEbsVolumeSnapshotProperties } from '../models/AwsEbsVolumeSnapshotProperties.js';
import { AwsEc2AmiConvertResult } from '../models/AwsEc2AmiConvertResult.js';
import { AwsEc2InstanceRestoreDestination } from '../models/AwsEc2InstanceRestoreDestination.js';
import { AwsEc2InstanceRestoreResult } from '../models/AwsEc2InstanceRestoreResult.js';
import { AwsEc2InstanceRestoreTarget } from '../models/AwsEc2InstanceRestoreTarget.js';
import { AwsEc2Resource } from '../models/AwsEc2Resource.js';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties.js';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource.js';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties.js';
import { AwsFsxResource } from '../models/AwsFsxResource.js';
import { AwsKeyspacesDestination } from '../models/AwsKeyspacesDestination.js';
import { AwsKeyspacesResource } from '../models/AwsKeyspacesResource.js';
import { AwsNativePitrBackupPolicyPlan } from '../models/AwsNativePitrBackupPolicyPlan.js';
import { AwsNativePitrBackupResourceType } from '../models/AwsNativePitrBackupResourceType.js';
import { AwsNativePitrConfig } from '../models/AwsNativePitrConfig.js';
import { AwsNativeStandardBackupPolicyPlan } from '../models/AwsNativeStandardBackupPolicyPlan.js';
import { AwsNativeStandardBackupScheduleConfig } from '../models/AwsNativeStandardBackupScheduleConfig.js';
import { AwsNativeStandardBackupSchedules } from '../models/AwsNativeStandardBackupSchedules.js';
import { AwsNativeStandardIntervalConfig } from '../models/AwsNativeStandardIntervalConfig.js';
import { AwsNeptuneResource } from '../models/AwsNeptuneResource.js';
import { AwsRdsResource } from '../models/AwsRdsResource.js';
import { AwsRdsResourceAurora } from '../models/AwsRdsResourceAurora.js';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings.js';
import { AwsRdsSnapshotProperties } from '../models/AwsRdsSnapshotProperties.js';
import { AwsRestoreAccountAttributes } from '../models/AwsRestoreAccountAttributes.js';
import { AwsRestoreAccountAttributesInput } from '../models/AwsRestoreAccountAttributesInput.js';
import { AwsRestoreAccountConnectivityConfig } from '../models/AwsRestoreAccountConnectivityConfig.js';
import { AwsRestoreServerNetworkParams } from '../models/AwsRestoreServerNetworkParams.js';
import { AwsSourceAccountAttributes } from '../models/AwsSourceAccountAttributes.js';
import { AwsSourceAccountAttributesInput } from '../models/AwsSourceAccountAttributesInput.js';
import { AwsVaultConfig } from '../models/AwsVaultConfig.js';
import { AwsVaultConfigInput } from '../models/AwsVaultConfigInput.js';
import { AwsVpcConnectivityConfig } from '../models/AwsVpcConnectivityConfig.js';
import { AzureAccountConfigInput } from '../models/AzureAccountConfigInput.js';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource.js';
import { AzureAppRegistrationOption } from '../models/AzureAppRegistrationOption.js';
import { AzureBackupApplicationsResponse } from '../models/AzureBackupApplicationsResponse.js';
import { AzureCmkEligibleApp } from '../models/AzureCmkEligibleApp.js';
import { AzureConsentUrlResponse } from '../models/AzureConsentUrlResponse.js';
import { AzureDisk } from '../models/AzureDisk.js';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData.js';
import { AzureDiskRestoreDestination } from '../models/AzureDiskRestoreDestination.js';
import { AzureDiskRestoreResult } from '../models/AzureDiskRestoreResult.js';
import { AzureDiskSettings } from '../models/AzureDiskSettings.js';
import { AzureDiskTarget } from '../models/AzureDiskTarget.js';
import { AzureEonApplication } from '../models/AzureEonApplication.js';
import { AzureFileShareRestoreFileSpec } from '../models/AzureFileShareRestoreFileSpec.js';
import { AzureFilesBackupPolicyPlan } from '../models/AzureFilesBackupPolicyPlan.js';
import { AzureFilesBackupSchedules } from '../models/AzureFilesBackupSchedules.js';
import { AzureFilesStorageAccountSelection } from '../models/AzureFilesStorageAccountSelection.js';
import { AzureListResourceGroupsResponse } from '../models/AzureListResourceGroupsResponse.js';
import { AzureListSubscriptionsResponse } from '../models/AzureListSubscriptionsResponse.js';
import { AzureManagementGroup } from '../models/AzureManagementGroup.js';
import { AzureManagementGroups } from '../models/AzureManagementGroups.js';
import { AzureMarketplaceWebhookInput } from '../models/AzureMarketplaceWebhookInput.js';
import { AzureMarketplaceWebhookInputSubscription } from '../models/AzureMarketplaceWebhookInputSubscription.js';
import { AzureMarketplaceWebhookInputSubscriptionBeneficiary } from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary.js';
import { AzureMarketplaceWebhookInputSubscriptionPurchaser } from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser.js';
import { AzureMarketplaceWebhookInputSubscriptionTerm } from '../models/AzureMarketplaceWebhookInputSubscriptionTerm.js';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties.js';
import { AzureOnboardedTenantsResponse } from '../models/AzureOnboardedTenantsResponse.js';
import { AzureOnboardingStatus } from '../models/AzureOnboardingStatus.js';
import { AzureOptionalCapabilities } from '../models/AzureOptionalCapabilities.js';
import { AzurePostgresDatabaseRestoreDestination } from '../models/AzurePostgresDatabaseRestoreDestination.js';
import { AzurePostgresDatabaseRestoreTarget } from '../models/AzurePostgresDatabaseRestoreTarget.js';
import { AzureResourceGroup } from '../models/AzureResourceGroup.js';
import { AzureResourceGroups } from '../models/AzureResourceGroups.js';
import { AzureRestoreAccountAttributes } from '../models/AzureRestoreAccountAttributes.js';
import { AzureRestoreAccountAttributesInput } from '../models/AzureRestoreAccountAttributesInput.js';
import { AzureRestoreAccountConnectivityConfig } from '../models/AzureRestoreAccountConnectivityConfig.js';
import { AzureRestorePointData } from '../models/AzureRestorePointData.js';
import { AzureRestorePointSpec } from '../models/AzureRestorePointSpec.js';
import { AzureSapHanaResource } from '../models/AzureSapHanaResource.js';
import { AzureScanningAccountSetupStatus200Response } from '../models/AzureScanningAccountSetupStatus200Response.js';
import { AzureSourceAccountAttributes } from '../models/AzureSourceAccountAttributes.js';
import { AzureSourceAccountAttributesInput } from '../models/AzureSourceAccountAttributesInput.js';
import { AzureSqlDatabaseNativePitrBackupPolicyPlan } from '../models/AzureSqlDatabaseNativePitrBackupPolicyPlan.js';
import { AzureSqlDatabaseNativePitrBackupResourceType } from '../models/AzureSqlDatabaseNativePitrBackupResourceType.js';
import { AzureSqlDatabaseNativePitrConfig } from '../models/AzureSqlDatabaseNativePitrConfig.js';
import { AzureSqlDatabaseRestoreDestination } from '../models/AzureSqlDatabaseRestoreDestination.js';
import { AzureSqlDatabaseRestoreTarget } from '../models/AzureSqlDatabaseRestoreTarget.js';
import { AzureSqlRestoreTargetServers } from '../models/AzureSqlRestoreTargetServers.js';
import { AzureSqlServer } from '../models/AzureSqlServer.js';
import { AzureStorageAccount } from '../models/AzureStorageAccount.js';
import { AzureStorageAccounts } from '../models/AzureStorageAccounts.js';
import { AzureSubscription } from '../models/AzureSubscription.js';
import { AzureTenant } from '../models/AzureTenant.js';
import { AzureVaultConfig } from '../models/AzureVaultConfig.js';
import { AzureVaultConfigInput } from '../models/AzureVaultConfigInput.js';
import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination.js';
import { AzureVmInstanceRestoreResult } from '../models/AzureVmInstanceRestoreResult.js';
import { AzureVmInstanceRestoreTarget } from '../models/AzureVmInstanceRestoreTarget.js';
import { AzureVmResource } from '../models/AzureVmResource.js';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties.js';
import { AzureVnetConnectivityConfig } from '../models/AzureVnetConnectivityConfig.js';
import { BackedUpByResourceType } from '../models/BackedUpByResourceType.js';
import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner.js';
import { BackedUpStorageDateHistogram } from '../models/BackedUpStorageDateHistogram.js';
import { BackupControlViolations } from '../models/BackupControlViolations.js';
import { BackupJob } from '../models/BackupJob.js';
import { BackupJobResponse } from '../models/BackupJobResponse.js';
import { BackupJobTypeFilters } from '../models/BackupJobTypeFilters.js';
import { BackupJobsFilterConditions } from '../models/BackupJobsFilterConditions.js';
import { BackupPoliciesFilters } from '../models/BackupPoliciesFilters.js';
import { BackupPoliciesLimits } from '../models/BackupPoliciesLimits.js';
import { BackupPoliciesSecurityConfig } from '../models/BackupPoliciesSecurityConfig.js';
import { BackupPolicy } from '../models/BackupPolicy.js';
import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments.js';
import { BackupPolicyConfig } from '../models/BackupPolicyConfig.js';
import { BackupPolicyExpression } from '../models/BackupPolicyExpression.js';
import { BackupPolicyGroupCondition } from '../models/BackupPolicyGroupCondition.js';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments.js';
import { BackupPolicyPlan } from '../models/BackupPolicyPlan.js';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector.js';
import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig.js';
import { BackupRegionsFilters } from '../models/BackupRegionsFilters.js';
import { BackupSchedule } from '../models/BackupSchedule.js';
import { BackupScope } from '../models/BackupScope.js';
import { BackupScopeSummary } from '../models/BackupScopeSummary.js';
import { BackupStatusFilters } from '../models/BackupStatusFilters.js';
import { BackupVault } from '../models/BackupVault.js';
import { BackupZeroEtlAccessConfiguration } from '../models/BackupZeroEtlAccessConfiguration.js';
import { BackupZeroEtlAwsAccessConfiguration } from '../models/BackupZeroEtlAwsAccessConfiguration.js';
import { BackupZeroEtlAwsGlueCatalogConfiguration } from '../models/BackupZeroEtlAwsGlueCatalogConfiguration.js';
import { BackupZeroEtlCatalogConfiguration } from '../models/BackupZeroEtlCatalogConfiguration.js';
import { BackupZeroEtlFilters } from '../models/BackupZeroEtlFilters.js';
import { BackupZeroEtlIcebergPartitionSpec } from '../models/BackupZeroEtlIcebergPartitionSpec.js';
import { BackupZeroEtlIcebergPartitionTransform } from '../models/BackupZeroEtlIcebergPartitionTransform.js';
import { BackupZeroEtlIdentityColumnSpec } from '../models/BackupZeroEtlIdentityColumnSpec.js';
import { BackupZeroEtlMultiResourceRoutingPolicy } from '../models/BackupZeroEtlMultiResourceRoutingPolicy.js';
import { BackupZeroEtlPolicy } from '../models/BackupZeroEtlPolicy.js';
import { BackupZeroEtlResourceSelector } from '../models/BackupZeroEtlResourceSelector.js';
import { BackupZeroEtlSingleResourcePartitionConfig } from '../models/BackupZeroEtlSingleResourcePartitionConfig.js';
import { BackupZeroEtlSingleResourceRoutingPolicy } from '../models/BackupZeroEtlSingleResourceRoutingPolicy.js';
import { BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams } from '../models/BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams.js';
import { BackupZeroEtlStorageConfiguration } from '../models/BackupZeroEtlStorageConfiguration.js';
import { BackupZeroEtlTableFilter } from '../models/BackupZeroEtlTableFilter.js';
import { BatchApplicationOverrides } from '../models/BatchApplicationOverrides.js';
import { BatchOperationResponse } from '../models/BatchOperationResponse.js';
import { BatchResourceValidationResult } from '../models/BatchResourceValidationResult.js';
import { BatchUpdateLlgPoliciesRequest } from '../models/BatchUpdateLlgPoliciesRequest.js';
import { BatchUpdateLlgPolicyItem } from '../models/BatchUpdateLlgPolicyItem.js';
import { BatchValidateResourceConfigurationRequest } from '../models/BatchValidateResourceConfigurationRequest.js';
import { BatchValidateResourceConfigurationResponse } from '../models/BatchValidateResourceConfigurationResponse.js';
import { BigQueryDatasetDestination } from '../models/BigQueryDatasetDestination.js';
import { BigQueryIntegrationConfig } from '../models/BigQueryIntegrationConfig.js';
import { BigQueryNativePitrBackupPolicyPlan } from '../models/BigQueryNativePitrBackupPolicyPlan.js';
import { BigQueryNativePitrBackupResourceType } from '../models/BigQueryNativePitrBackupResourceType.js';
import { BigQueryNativePitrConfig } from '../models/BigQueryNativePitrConfig.js';
import { BigQueryNativePitrDestination } from '../models/BigQueryNativePitrDestination.js';
import { BillingPeriod } from '../models/BillingPeriod.js';
import { BillingTransactionHistory } from '../models/BillingTransactionHistory.js';
import { BooleanFilters } from '../models/BooleanFilters.js';
import { BulkAttachRestoreTemplateRequest } from '../models/BulkAttachRestoreTemplateRequest.js';
import { BulkDetachRestoreTemplateRequest } from '../models/BulkDetachRestoreTemplateRequest.js';
import { BulkRestoreItem } from '../models/BulkRestoreItem.js';
import { BulkRestoreRequest } from '../models/BulkRestoreRequest.js';
import { BulkRestoreResponse } from '../models/BulkRestoreResponse.js';
import { BulkRestoreResponseItemsInner } from '../models/BulkRestoreResponseItemsInner.js';
import { BulkRestoreResponseJobsInner } from '../models/BulkRestoreResponseJobsInner.js';
import { BulkRestoreValidateRequest } from '../models/BulkRestoreValidateRequest.js';
import { BulkRestoreValidateResponse } from '../models/BulkRestoreValidateResponse.js';
import { BulkRestoreValidateResponseItemsInner } from '../models/BulkRestoreValidateResponseItemsInner.js';
import { BulkSelectSnapshotsForResourcesRequest } from '../models/BulkSelectSnapshotsForResourcesRequest.js';
import { BulkSelectSnapshotsForResourcesResponse } from '../models/BulkSelectSnapshotsForResourcesResponse.js';
import { BulkSelectSnapshotsForResourcesResponseItemsInner } from '../models/BulkSelectSnapshotsForResourcesResponseItemsInner.js';
import { CancelExclusionFromBackupResponse } from '../models/CancelExclusionFromBackupResponse.js';
import { CancelMyMPARequestResponse } from '../models/CancelMyMPARequestResponse.js';
import { CassandraClusterResource } from '../models/CassandraClusterResource.js';
import { CdcBackupModeCheckResult } from '../models/CdcBackupModeCheckResult.js';
import { CheckAzureVMNameExists200Response } from '../models/CheckAzureVMNameExists200Response.js';
import { CheckAzureVMNameExistsRequest } from '../models/CheckAzureVMNameExistsRequest.js';
import { CheckCdcPrerequisitesResponse } from '../models/CheckCdcPrerequisitesResponse.js';
import { ClassificationCategory } from '../models/ClassificationCategory.js';
import { ClassificationPolicy } from '../models/ClassificationPolicy.js';
import { ClassificationPolicySchedule } from '../models/ClassificationPolicySchedule.js';
import { Classifications } from '../models/Classifications.js';
import { CloudAccountIdFilters } from '../models/CloudAccountIdFilters.js';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments.js';
import { CloudProviderCondition } from '../models/CloudProviderCondition.js';
import { CloudProviderFilters } from '../models/CloudProviderFilters.js';
import { CloudRegion } from '../models/CloudRegion.js';
import { CloudResourceAttachmentEvent } from '../models/CloudResourceAttachmentEvent.js';
import { CloudResourceConfiguration } from '../models/CloudResourceConfiguration.js';
import { CloudResourceConfigurationCdcBackup } from '../models/CloudResourceConfigurationCdcBackup.js';
import { CloudResourceConfigurationInventoryBackup } from '../models/CloudResourceConfigurationInventoryBackup.js';
import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties.js';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume.js';
import { ClusterNameFilters } from '../models/ClusterNameFilters.js';
import { CognitoExchangeRequest } from '../models/CognitoExchangeRequest.js';
import { CognitoExchangeResponse } from '../models/CognitoExchangeResponse.js';
import { ColumnMetadata } from '../models/ColumnMetadata.js';
import { CompanyContact } from '../models/CompanyContact.js';
import { ComplianceControlTrends } from '../models/ComplianceControlTrends.js';
import { ComplianceSummary } from '../models/ComplianceSummary.js';
import { ComplianceTrend } from '../models/ComplianceTrend.js';
import { Condition } from '../models/Condition.js';
import { ConnectAtlasOrganizationRequest } from '../models/ConnectAtlasOrganizationRequest.js';
import { ConnectAtlasOrganizationResponse } from '../models/ConnectAtlasOrganizationResponse.js';
import { ConnectAzureBackupAccountRequest } from '../models/ConnectAzureBackupAccountRequest.js';
import { ConnectAzureBackupApplicationsRequest } from '../models/ConnectAzureBackupApplicationsRequest.js';
import { ConnectAzureRestoreAccountRequest } from '../models/ConnectAzureRestoreAccountRequest.js';
import { ConnectAzureSourceAccountRequest } from '../models/ConnectAzureSourceAccountRequest.js';
import { ConnectAzureVaultAccountRequest } from '../models/ConnectAzureVaultAccountRequest.js';
import { ConnectBYOApps200Response } from '../models/ConnectBYOApps200Response.js';
import { ConnectBYOAppsRequest } from '../models/ConnectBYOAppsRequest.js';
import { ConnectBYOAzureBackupApplicationsRequest } from '../models/ConnectBYOAzureBackupApplicationsRequest.js';
import { ConnectCustomerVaultAccountRequest } from '../models/ConnectCustomerVaultAccountRequest.js';
import { ConnectCustomerVaultAccountResponse } from '../models/ConnectCustomerVaultAccountResponse.js';
import { ConnectGcpFolderRequest } from '../models/ConnectGcpFolderRequest.js';
import { ConnectGcpFolderResponse } from '../models/ConnectGcpFolderResponse.js';
import { ConnectGcpOrganizationRequest } from '../models/ConnectGcpOrganizationRequest.js';
import { ConnectGcpOrganizationResponse } from '../models/ConnectGcpOrganizationResponse.js';
import { ConnectRestoreAccountRequest } from '../models/ConnectRestoreAccountRequest.js';
import { ConnectRestoreAccountResponse } from '../models/ConnectRestoreAccountResponse.js';
import { ConnectRestoreAwsOrganizationalUnitRequest } from '../models/ConnectRestoreAwsOrganizationalUnitRequest.js';
import { ConnectRestoreAwsOrganizationalUnitResponse } from '../models/ConnectRestoreAwsOrganizationalUnitResponse.js';
import { ConnectSourceAccountRequest } from '../models/ConnectSourceAccountRequest.js';
import { ConnectSourceAccountResponse } from '../models/ConnectSourceAccountResponse.js';
import { ConnectSourceAwsOrganizationalUnitRequest } from '../models/ConnectSourceAwsOrganizationalUnitRequest.js';
import { ConnectSourceAwsOrganizationalUnitResponse } from '../models/ConnectSourceAwsOrganizationalUnitResponse.js';
import { Control } from '../models/Control.js';
import { ControlComplianceEntry } from '../models/ControlComplianceEntry.js';
import { ControlFailureCount } from '../models/ControlFailureCount.js';
import { ControlPlaneConfig } from '../models/ControlPlaneConfig.js';
import { ControlRules } from '../models/ControlRules.js';
import { ControlTrendEntry } from '../models/ControlTrendEntry.js';
import { ControlViolation } from '../models/ControlViolation.js';
import { ControlViolations } from '../models/ControlViolations.js';
import { ControlViolationsPerSeverity } from '../models/ControlViolationsPerSeverity.js';
import { ControlViolationsPerSeverityViolatedControlsInner } from '../models/ControlViolationsPerSeverityViolatedControlsInner.js';
import { ControlsFilters } from '../models/ControlsFilters.js';
import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig.js';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig.js';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest.js';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.js';
import { ConvertResourceSnapshotsRequest } from '../models/ConvertResourceSnapshotsRequest.js';
import { ConvertResourceSnapshotsResponse } from '../models/ConvertResourceSnapshotsResponse.js';
import { Cost } from '../models/Cost.js';
import { CostDataFilters } from '../models/CostDataFilters.js';
import { CostDataRecord } from '../models/CostDataRecord.js';
import { CostDataRecordCost } from '../models/CostDataRecordCost.js';
import { CostDataRecordDimensions } from '../models/CostDataRecordDimensions.js';
import { CostProductFilters } from '../models/CostProductFilters.js';
import { CostRecordMetadata } from '../models/CostRecordMetadata.js';
import { CostRecordMetadataDataTransfer } from '../models/CostRecordMetadataDataTransfer.js';
import { CreateAccountInput } from '../models/CreateAccountInput.js';
import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest.js';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse.js';
import { CreateBackupPolicyRequest } from '../models/CreateBackupPolicyRequest.js';
import { CreateBackupPolicyResponse } from '../models/CreateBackupPolicyResponse.js';
import { CreateBackupZeroEtlPolicyInput } from '../models/CreateBackupZeroEtlPolicyInput.js';
import { CreateClassificationPolicyRequest } from '../models/CreateClassificationPolicyRequest.js';
import { CreateClassificationPolicyResponse } from '../models/CreateClassificationPolicyResponse.js';
import { CreateDlsgPolicyRequest } from '../models/CreateDlsgPolicyRequest.js';
import { CreateDlsgPolicyResponse } from '../models/CreateDlsgPolicyResponse.js';
import { CreateFabricTableShortcutDemoRequest } from '../models/CreateFabricTableShortcutDemoRequest.js';
import { CreateFabricTableShortcutDemoRequestShortcutsInner } from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner.js';
import { CreateFabricTableShortcutDemoResponse } from '../models/CreateFabricTableShortcutDemoResponse.js';
import { CreateFabricTableShortcutDemoResponseResultsInner } from '../models/CreateFabricTableShortcutDemoResponseResultsInner.js';
import { CreateFindingExclusionPatternInput } from '../models/CreateFindingExclusionPatternInput.js';
import { CreateIdpGroupRequest } from '../models/CreateIdpGroupRequest.js';
import { CreateIdpGroupResponse } from '../models/CreateIdpGroupResponse.js';
import { CreateIntegrationRequest } from '../models/CreateIntegrationRequest.js';
import { CreateIntegrationResponse } from '../models/CreateIntegrationResponse.js';
import { CreateMPAPolicyRequest } from '../models/CreateMPAPolicyRequest.js';
import { CreateMPAPolicyResponse } from '../models/CreateMPAPolicyResponse.js';
import { CreateMPARequestReviewRequest } from '../models/CreateMPARequestReviewRequest.js';
import { CreateMPARequestReviewResponse } from '../models/CreateMPARequestReviewResponse.js';
import { CreateOAuthAppRequest } from '../models/CreateOAuthAppRequest.js';
import { CreateOAuthAppResponse } from '../models/CreateOAuthAppResponse.js';
import { CreateOrganizationIdpRequest } from '../models/CreateOrganizationIdpRequest.js';
import { CreateOrganizationIdpResponse } from '../models/CreateOrganizationIdpResponse.js';
import { CreatePolicyInput } from '../models/CreatePolicyInput.js';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput.js';
import { CreateProjectInput } from '../models/CreateProjectInput.js';
import { CreatePulumiConfigurationRequest } from '../models/CreatePulumiConfigurationRequest.js';
import { CreateRestoreTemplateRequest } from '../models/CreateRestoreTemplateRequest.js';
import { CreateRestoreTemplateResponse } from '../models/CreateRestoreTemplateResponse.js';
import { CreateRoleRequest } from '../models/CreateRoleRequest.js';
import { CreateRoleResponse } from '../models/CreateRoleResponse.js';
import { CreateSamlIdentityProviderConfigInput } from '../models/CreateSamlIdentityProviderConfigInput.js';
import { CreateScanJobInput } from '../models/CreateScanJobInput.js';
import { CreateScanJobResponse } from '../models/CreateScanJobResponse.js';
import { CreateSessionRequest } from '../models/CreateSessionRequest.js';
import { CreateThreatHuntingScanRequestRequest } from '../models/CreateThreatHuntingScanRequestRequest.js';
import { CreateThreatHuntingScanRequestResponse } from '../models/CreateThreatHuntingScanRequestResponse.js';
import { CreateUserInput } from '../models/CreateUserInput.js';
import { CreateVaultRequest } from '../models/CreateVaultRequest.js';
import { CreateVaultResponse } from '../models/CreateVaultResponse.js';
import { CredentialFinding } from '../models/CredentialFinding.js';
import { CreditsMonthlyUsageNotificationArguments } from '../models/CreditsMonthlyUsageNotificationArguments.js';
import { CreditsNotificationArguments } from '../models/CreditsNotificationArguments.js';
import { CrossResourceQueryRequest } from '../models/CrossResourceQueryRequest.js';
import { CrossResourceQueryRequestResourcesInner } from '../models/CrossResourceQueryRequestResourcesInner.js';
import { CustomTagsInner } from '../models/CustomTagsInner.js';
import { CustomerVaultAccount } from '../models/CustomerVaultAccount.js';
import { DBResourceMetadata } from '../models/DBResourceMetadata.js';
import { DBServerRecord } from '../models/DBServerRecord.js';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata.js';
import { DailyConfig } from '../models/DailyConfig.js';
import { DailySnapshotData } from '../models/DailySnapshotData.js';
import { DailyStorageSummaries } from '../models/DailyStorageSummaries.js';
import { DailyStorageSummary } from '../models/DailyStorageSummary.js';
import { DataClassEntitiesFilters } from '../models/DataClassEntitiesFilters.js';
import { DataClassesCondition } from '../models/DataClassesCondition.js';
import { DataClassesDetails } from '../models/DataClassesDetails.js';
import { DataClassesFilters } from '../models/DataClassesFilters.js';
import { DataClassificationEntity } from '../models/DataClassificationEntity.js';
import { DataClassificationEntityOption } from '../models/DataClassificationEntityOption.js';
import { DataShareIntegrationConfig } from '../models/DataShareIntegrationConfig.js';
import { DatabaseDestination } from '../models/DatabaseDestination.js';
import { DatabaseRecord } from '../models/DatabaseRecord.js';
import { DatabricksIntegrationConfig } from '../models/DatabricksIntegrationConfig.js';
import { DeactivateAccountRequest } from '../models/DeactivateAccountRequest.js';
import { DeactivateAccountResponse } from '../models/DeactivateAccountResponse.js';
import { DeactivateAtlasOrganizationResponse } from '../models/DeactivateAtlasOrganizationResponse.js';
import { DeactivateGcpFolderResponse } from '../models/DeactivateGcpFolderResponse.js';
import { DeactivateGcpOrganizationResponse } from '../models/DeactivateGcpOrganizationResponse.js';
import { DeleteGdsgObjectsRequest } from '../models/DeleteGdsgObjectsRequest.js';
import { DeleteGdsgObjectsResponse } from '../models/DeleteGdsgObjectsResponse.js';
import { DestinationDetails } from '../models/DestinationDetails.js';
import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes.js';
import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure.js';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes.js';
import { DetectorSummary } from '../models/DetectorSummary.js';
import { DetectorTypeFilters } from '../models/DetectorTypeFilters.js';
import { DirectoryEntityRecord } from '../models/DirectoryEntityRecord.js';
import { DirectorySearchFilter } from '../models/DirectorySearchFilter.js';
import { DisableResourceOverrideLimitsResponse } from '../models/DisableResourceOverrideLimitsResponse.js';
import { DisconnectCustomerVaultAccountResponse } from '../models/DisconnectCustomerVaultAccountResponse.js';
import { DisconnectRestoreAccountResponse } from '../models/DisconnectRestoreAccountResponse.js';
import { DisconnectRestoreAwsOrganizationalUnitResponse } from '../models/DisconnectRestoreAwsOrganizationalUnitResponse.js';
import { DisconnectSourceAccountResponse } from '../models/DisconnectSourceAccountResponse.js';
import { DisconnectSourceAwsOrganizationalUnitResponse } from '../models/DisconnectSourceAwsOrganizationalUnitResponse.js';
import { DiscoveryInvokeParams } from '../models/DiscoveryInvokeParams.js';
import { DiscoveryJob } from '../models/DiscoveryJob.js';
import { DiscoveryStatusResponse } from '../models/DiscoveryStatusResponse.js';
import { DlsgPolicy } from '../models/DlsgPolicy.js';
import { DlsgPolicyConfig } from '../models/DlsgPolicyConfig.js';
import { DlsgPolicyFilters } from '../models/DlsgPolicyFilters.js';
import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan.js';
import { DlsgSettings } from '../models/DlsgSettings.js';
import { DocumentDBRestoreDestination } from '../models/DocumentDBRestoreDestination.js';
import { DocumentDbClusterParameterGroup } from '../models/DocumentDbClusterParameterGroup.js';
import { DocumentDbClusterParameterGroups } from '../models/DocumentDbClusterParameterGroups.js';
import { DocumentDbSnapshotProperties } from '../models/DocumentDbSnapshotProperties.js';
import { DownloadGdsgObjectsRequest } from '../models/DownloadGdsgObjectsRequest.js';
import { DriftProtectionPolicy } from '../models/DriftProtectionPolicy.js';
import { DriftProtectionSummary } from '../models/DriftProtectionSummary.js';
import { DriftProtectionTimePoint } from '../models/DriftProtectionTimePoint.js';
import { DsgBucketFilters } from '../models/DsgBucketFilters.js';
import { DsgEnvironmentFilters } from '../models/DsgEnvironmentFilters.js';
import { DsgRegionFilters } from '../models/DsgRegionFilters.js';
import { DsgRequestTypeFilters } from '../models/DsgRequestTypeFilters.js';
import { DsgStorageTierFilters } from '../models/DsgStorageTierFilters.js';
import { DynamoDBAdvancedIndexConfig } from '../models/DynamoDBAdvancedIndexConfig.js';
import { DynamoDBRestoreMethodAvailabilityRequest } from '../models/DynamoDBRestoreMethodAvailabilityRequest.js';
import { DynamoDBRestoreMethodAvailabilityResponse } from '../models/DynamoDBRestoreMethodAvailabilityResponse.js';
import { DynamoDbBackupConfig } from '../models/DynamoDbBackupConfig.js';
import { DynamoDbBackupConfigApplication } from '../models/DynamoDbBackupConfigApplication.js';
import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination.js';
import { EFSRestoreDestination } from '../models/EFSRestoreDestination.js';
import { EbsRestoreDestination } from '../models/EbsRestoreDestination.js';
import { EbsSnapshotRestoreDestination } from '../models/EbsSnapshotRestoreDestination.js';
import { EbsSnapshotTarget } from '../models/EbsSnapshotTarget.js';
import { EbsTarget } from '../models/EbsTarget.js';
import { Ec2TemplateParams } from '../models/Ec2TemplateParams.js';
import { Ec2TemplateParamsAdditionalTagsInner } from '../models/Ec2TemplateParamsAdditionalTagsInner.js';
import { EfsSnapshotProperties } from '../models/EfsSnapshotProperties.js';
import { EksCluster } from '../models/EksCluster.js';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination.js';
import { EksNamespaceRestoreResult } from '../models/EksNamespaceRestoreResult.js';
import { EksVolumeRestoreResult } from '../models/EksVolumeRestoreResult.js';
import { EmailSearchFilter } from '../models/EmailSearchFilter.js';
import { EmrIntegrationConfig } from '../models/EmrIntegrationConfig.js';
import { EnableFromLimitExceededResponse } from '../models/EnableFromLimitExceededResponse.js';
import { EnableResourceOverrideLimitsResponse } from '../models/EnableResourceOverrideLimitsResponse.js';
import { EnableRestoreAccountMetricsConfigRequest } from '../models/EnableRestoreAccountMetricsConfigRequest.js';
import { EnableRestoreAccountMetricsConfigResponse } from '../models/EnableRestoreAccountMetricsConfigResponse.js';
import { EnableSourceAccountMetricsConfigRequest } from '../models/EnableSourceAccountMetricsConfigRequest.js';
import { EnableSourceAccountMetricsConfigResponse } from '../models/EnableSourceAccountMetricsConfigResponse.js';
import { EncryptionKey } from '../models/EncryptionKey.js';
import { EncryptionKeys } from '../models/EncryptionKeys.js';
import { EncryptionTypeCondition } from '../models/EncryptionTypeCondition.js';
import { EncryptionTypeFilters } from '../models/EncryptionTypeFilters.js';
import { EndTimeDateFilters } from '../models/EndTimeDateFilters.js';
import { EnvironmentCondition } from '../models/EnvironmentCondition.js';
import { EnvironmentDetails } from '../models/EnvironmentDetails.js';
import { EnvironmentFilters } from '../models/EnvironmentFilters.js';
import { EonAccount } from '../models/EonAccount.js';
import { EonAccountIdFilters } from '../models/EonAccountIdFilters.js';
import { EonOrganization } from '../models/EonOrganization.js';
import { EonOrganizationSummary } from '../models/EonOrganizationSummary.js';
import { EvaluateRestoreTemplateResponse } from '../models/EvaluateRestoreTemplateResponse.js';
import { EvidenceTypeFilters } from '../models/EvidenceTypeFilters.js';
import { ExcludeFromBackupResponse } from '../models/ExcludeFromBackupResponse.js';
import { ExclusionPatternFilterConditions } from '../models/ExclusionPatternFilterConditions.js';
import { ExclusionPatternResourceFilter } from '../models/ExclusionPatternResourceFilter.js';
import { ExportAccessDeniedItemsRequest } from '../models/ExportAccessDeniedItemsRequest.js';
import { ExportComplianceReportRequest } from '../models/ExportComplianceReportRequest.js';
import { ExportComplianceReportResponse } from '../models/ExportComplianceReportResponse.js';
import { ExportCostData400Response } from '../models/ExportCostData400Response.js';
import { ExportCostDataRequest } from '../models/ExportCostDataRequest.js';
import { FSxRestoreDestination } from '../models/FSxRestoreDestination.js';
import { FSxRestoreDestinationOntapRestoreOptions } from '../models/FSxRestoreDestinationOntapRestoreOptions.js';
import { FeatureFlagOverrideGet200Response } from '../models/FeatureFlagOverrideGet200Response.js';
import { FieldStatus } from '../models/FieldStatus.js';
import { FileExplorerCountPathFilesResponse } from '../models/FileExplorerCountPathFilesResponse.js';
import { FileExplorerCountSecurityAlertsInResourceResponse } from '../models/FileExplorerCountSecurityAlertsInResourceResponse.js';
import { FileExplorerCountWorkspaceEntitiesResponse } from '../models/FileExplorerCountWorkspaceEntitiesResponse.js';
import { FileExplorerResponse } from '../models/FileExplorerResponse.js';
import { FilePath } from '../models/FilePath.js';
import { FileRestoreData } from '../models/FileRestoreData.js';
import { FileSearchRecord } from '../models/FileSearchRecord.js';
import { FileSnapshot } from '../models/FileSnapshot.js';
import { FindingCountEntry } from '../models/FindingCountEntry.js';
import { FindingEntry } from '../models/FindingEntry.js';
import { FindingExclusionPattern } from '../models/FindingExclusionPattern.js';
import { FindingObjectTypeFilters } from '../models/FindingObjectTypeFilters.js';
import { FindingResourceFilters } from '../models/FindingResourceFilters.js';
import { ForceDeleteSnapshotsRequest } from '../models/ForceDeleteSnapshotsRequest.js';
import { FreeTextFilters } from '../models/FreeTextFilters.js';
import { FsxOntapVolume } from '../models/FsxOntapVolume.js';
import { FsxSnapshotProperties } from '../models/FsxSnapshotProperties.js';
import { FsxVolumeBackupInfo } from '../models/FsxVolumeBackupInfo.js';
import { GCSBucket } from '../models/GCSBucket.js';
import { GCSBuckets } from '../models/GCSBuckets.js';
import { GCSRestoreDestination } from '../models/GCSRestoreDestination.js';
import { GCSRestoreTarget } from '../models/GCSRestoreTarget.js';
import { GcpAccountConfigInput } from '../models/GcpAccountConfigInput.js';
import { GcpBigQueryDatasetRestoreResult } from '../models/GcpBigQueryDatasetRestoreResult.js';
import { GcpBigQueryResource } from '../models/GcpBigQueryResource.js';
import { GcpBigQueryResourceMaterializedViewsInner } from '../models/GcpBigQueryResourceMaterializedViewsInner.js';
import { GcpBigQueryResourceRoutinesInner } from '../models/GcpBigQueryResourceRoutinesInner.js';
import { GcpBigQueryResourceTablesInner } from '../models/GcpBigQueryResourceTablesInner.js';
import { GcpBigQueryResourceViewsInner } from '../models/GcpBigQueryResourceViewsInner.js';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource.js';
import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings.js';
import { GcpCloudSqlRestoreDestination } from '../models/GcpCloudSqlRestoreDestination.js';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties.js';
import { GcpCloudSqlTarget } from '../models/GcpCloudSqlTarget.js';
import { GcpDiskResource } from '../models/GcpDiskResource.js';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData.js';
import { GcpDiskRestoreDestination } from '../models/GcpDiskRestoreDestination.js';
import { GcpDiskSettings } from '../models/GcpDiskSettings.js';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties.js';
import { GcpDiskTarget } from '../models/GcpDiskTarget.js';
import { GcpDiskTypesResponse } from '../models/GcpDiskTypesResponse.js';
import { GcpEncryptionKey } from '../models/GcpEncryptionKey.js';
import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys.js';
import { GcpGcsResource } from '../models/GcpGcsResource.js';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource.js';
import { GcpLabelFilter } from '../models/GcpLabelFilter.js';
import { GcpMachineTypesResponse } from '../models/GcpMachineTypesResponse.js';
import { GcpNetworkConnectivityConfig } from '../models/GcpNetworkConnectivityConfig.js';
import { GcpOrganization } from '../models/GcpOrganization.js';
import { GcpRestoreAccountAttributes } from '../models/GcpRestoreAccountAttributes.js';
import { GcpRestoreAccountAttributesInput } from '../models/GcpRestoreAccountAttributesInput.js';
import { GcpRestoreAccountConnectivityConfig } from '../models/GcpRestoreAccountConnectivityConfig.js';
import { GcpSapHanaResource } from '../models/GcpSapHanaResource.js';
import { GcpSourceAccountAttributes } from '../models/GcpSourceAccountAttributes.js';
import { GcpSourceAccountAttributesInput } from '../models/GcpSourceAccountAttributesInput.js';
import { GcpSubnet } from '../models/GcpSubnet.js';
import { GcpSubnetPerRegion } from '../models/GcpSubnetPerRegion.js';
import { GcpTagFilter } from '../models/GcpTagFilter.js';
import { GcpVaultConfig } from '../models/GcpVaultConfig.js';
import { GcpVaultConfigInput } from '../models/GcpVaultConfigInput.js';
import { GcpVmInstanceRestoreDestination } from '../models/GcpVmInstanceRestoreDestination.js';
import { GcpVmInstanceRestoreResult } from '../models/GcpVmInstanceRestoreResult.js';
import { GcpVmInstanceRestoreTarget } from '../models/GcpVmInstanceRestoreTarget.js';
import { GcpVmResource } from '../models/GcpVmResource.js';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties.js';
import { GdsgActiveBatchJobs } from '../models/GdsgActiveBatchJobs.js';
import { GdsgBigtableClusterStats } from '../models/GdsgBigtableClusterStats.js';
import { GdsgBigtableStorageTypeBytes } from '../models/GdsgBigtableStorageTypeBytes.js';
import { GdsgBigtableTableCpu } from '../models/GdsgBigtableTableCpu.js';
import { GdsgBigtableTableStorage } from '../models/GdsgBigtableTableStorage.js';
import { GdsgBucketStats } from '../models/GdsgBucketStats.js';
import { GdsgDeleteResult } from '../models/GdsgDeleteResult.js';
import { GdsgDevStats } from '../models/GdsgDevStats.js';
import { GdsgEnvironment } from '../models/GdsgEnvironment.js';
import { GdsgEnvironmentRegion } from '../models/GdsgEnvironmentRegion.js';
import { GdsgObjectEntry } from '../models/GdsgObjectEntry.js';
import { GdsgOperationalNotificationArguments } from '../models/GdsgOperationalNotificationArguments.js';
import { GdsgOperationalWarning } from '../models/GdsgOperationalWarning.js';
import { GdsgQueueLagStats } from '../models/GdsgQueueLagStats.js';
import { GdsgRegionStats } from '../models/GdsgRegionStats.js';
import { GdsgRegionStatsPoint } from '../models/GdsgRegionStatsPoint.js';
import { GdsgStorageBreakdownEntry } from '../models/GdsgStorageBreakdownEntry.js';
import { GdsgStorageByBucketEntry } from '../models/GdsgStorageByBucketEntry.js';
import { GdsgStorageByTierEntry } from '../models/GdsgStorageByTierEntry.js';
import { GdsgWorkerHeartbeatStats } from '../models/GdsgWorkerHeartbeatStats.js';
import { GdsgWorkerHeartbeats } from '../models/GdsgWorkerHeartbeats.js';
import { GenericSnapshotData } from '../models/GenericSnapshotData.js';
import { GetAWSStackDetailsResponse } from '../models/GetAWSStackDetailsResponse.js';
import { GetActionApprovalSummaryResponse } from '../models/GetActionApprovalSummaryResponse.js';
import { GetAdditionalAzureAppsOnboardingStatus200Response } from '../models/GetAdditionalAzureAppsOnboardingStatus200Response.js';
import { GetAgreementsResponse } from '../models/GetAgreementsResponse.js';
import { GetAwsPrivateLinkStatusResponse } from '../models/GetAwsPrivateLinkStatusResponse.js';
import { GetAzureQueryExportStorage200Response } from '../models/GetAzureQueryExportStorage200Response.js';
import { GetBackupJobResponse } from '../models/GetBackupJobResponse.js';
import { GetBackupPolicyResponse } from '../models/GetBackupPolicyResponse.js';
import { GetBillingPeriodsResponse } from '../models/GetBillingPeriodsResponse.js';
import { GetBulkRestoreSnapshotHistogramRequest } from '../models/GetBulkRestoreSnapshotHistogramRequest.js';
import { GetBulkRestoreSnapshotHistogramResponse } from '../models/GetBulkRestoreSnapshotHistogramResponse.js';
import { GetClassificationPolicyResponse } from '../models/GetClassificationPolicyResponse.js';
import { GetCloudResourceSecurityPropertiesResponse } from '../models/GetCloudResourceSecurityPropertiesResponse.js';
import { GetCredits400Response } from '../models/GetCredits400Response.js';
import { GetCreditsResponse } from '../models/GetCreditsResponse.js';
import { GetDlsgPolicyResponse } from '../models/GetDlsgPolicyResponse.js';
import { GetGcsServiceAgentResponse } from '../models/GetGcsServiceAgentResponse.js';
import { GetGdsgDevStatsResponse } from '../models/GetGdsgDevStatsResponse.js';
import { GetGdsgRegionStatsResponse } from '../models/GetGdsgRegionStatsResponse.js';
import { GetIdpGroupResponse } from '../models/GetIdpGroupResponse.js';
import { GetIntegrationResponse } from '../models/GetIntegrationResponse.js';
import { GetJobProgressStepsResponse } from '../models/GetJobProgressStepsResponse.js';
import { GetLimitsResponseValue } from '../models/GetLimitsResponseValue.js';
import { GetMPAPolicyResponse } from '../models/GetMPAPolicyResponse.js';
import { GetMPARequestResponse } from '../models/GetMPARequestResponse.js';
import { GetObjectStoreScanMethodResponse } from '../models/GetObjectStoreScanMethodResponse.js';
import { GetProjectConfigurationKeyResponse } from '../models/GetProjectConfigurationKeyResponse.js';
import { GetProjectConfigurationKeysResponse } from '../models/GetProjectConfigurationKeysResponse.js';
import { GetResourceResponse } from '../models/GetResourceResponse.js';
import { GetRestoreAccountCanDelete200Response } from '../models/GetRestoreAccountCanDelete200Response.js';
import { GetRestoreAccountConnectivityConfigResponse } from '../models/GetRestoreAccountConnectivityConfigResponse.js';
import { GetRestoreAccountMetricsConfigResponse } from '../models/GetRestoreAccountMetricsConfigResponse.js';
import { GetRestoreAccountResponse } from '../models/GetRestoreAccountResponse.js';
import { GetRestoreJobResponse } from '../models/GetRestoreJobResponse.js';
import { GetRestoreTemplateResponse } from '../models/GetRestoreTemplateResponse.js';
import { GetRoleResponse } from '../models/GetRoleResponse.js';
import { GetScanJobResponse } from '../models/GetScanJobResponse.js';
import { GetSnapshotResponse } from '../models/GetSnapshotResponse.js';
import { GetSourceAccountCanDelete200Response } from '../models/GetSourceAccountCanDelete200Response.js';
import { GetSourceAccountMetricsConfigResponse } from '../models/GetSourceAccountMetricsConfigResponse.js';
import { GetSourceAccountResponse } from '../models/GetSourceAccountResponse.js';
import { GetSqlVmNetworkInfoRequest } from '../models/GetSqlVmNetworkInfoRequest.js';
import { GetSqlVmNetworkInfoResponse } from '../models/GetSqlVmNetworkInfoResponse.js';
import { GetVaultResponse } from '../models/GetVaultResponse.js';
import { GlobalClusterIdentifierCondition } from '../models/GlobalClusterIdentifierCondition.js';
import { GoogleWorkspaceBackupPolicyPlan } from '../models/GoogleWorkspaceBackupPolicyPlan.js';
import { GoogleWorkspaceConnectionInfo } from '../models/GoogleWorkspaceConnectionInfo.js';
import { GoogleWorkspaceGroup } from '../models/GoogleWorkspaceGroup.js';
import { GoogleWorkspaceOrgUnit } from '../models/GoogleWorkspaceOrgUnit.js';
import { GoogleWorkspaceResource } from '../models/GoogleWorkspaceResource.js';
import { GoogleWorkspaceRestoreAccountAttributes } from '../models/GoogleWorkspaceRestoreAccountAttributes.js';
import { GoogleWorkspaceRestoreAccountAttributesInput } from '../models/GoogleWorkspaceRestoreAccountAttributesInput.js';
import { GoogleWorkspaceServiceAccountInfo } from '../models/GoogleWorkspaceServiceAccountInfo.js';
import { GoogleWorkspaceSharedDrive } from '../models/GoogleWorkspaceSharedDrive.js';
import { GoogleWorkspaceSnapshotProperties } from '../models/GoogleWorkspaceSnapshotProperties.js';
import { GoogleWorkspaceSourceAccountAttributes } from '../models/GoogleWorkspaceSourceAccountAttributes.js';
import { GoogleWorkspaceSourceAccountAttributesInput } from '../models/GoogleWorkspaceSourceAccountAttributesInput.js';
import { GoogleWorkspaceUser } from '../models/GoogleWorkspaceUser.js';
import { GoogleWorkspaceWithPolicyStatus } from '../models/GoogleWorkspaceWithPolicyStatus.js';
import { GroupBreakdown } from '../models/GroupBreakdown.js';
import { GroupBreakdownEntry } from '../models/GroupBreakdownEntry.js';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan.js';
import { HighFrequencyBackupResourceType } from '../models/HighFrequencyBackupResourceType.js';
import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig.js';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules.js';
import { HighFrequencyIntervalConfig } from '../models/HighFrequencyIntervalConfig.js';
import { HoldSnapshotRequest } from '../models/HoldSnapshotRequest.js';
import { IDs } from '../models/IDs.js';
import { IdFilters } from '../models/IdFilters.js';
import { Identifier } from '../models/Identifier.js';
import { IdentityProvidersNames } from '../models/IdentityProvidersNames.js';
import { Idp } from '../models/Idp.js';
import { IdpGroup } from '../models/IdpGroup.js';
import { ImportDlsgCertificateRequest } from '../models/ImportDlsgCertificateRequest.js';
import { InfectedDataByClassification } from '../models/InfectedDataByClassification.js';
import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize.js';
import { InfectedDataOverTime } from '../models/InfectedDataOverTime.js';
import { InfectedDateSize } from '../models/InfectedDateSize.js';
import { InfectedResourcesCountResponse } from '../models/InfectedResourcesCountResponse.js';
import { InitAuthInput } from '../models/InitAuthInput.js';
import { Initiator } from '../models/Initiator.js';
import { InitiatorIdentity } from '../models/InitiatorIdentity.js';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters.js';
import { IntegConfig } from '../models/IntegConfig.js';
import { IntegrationConfig } from '../models/IntegrationConfig.js';
import { IntrospectRequest } from '../models/IntrospectRequest.js';
import { IntrospectResponse } from '../models/IntrospectResponse.js';
import { InventoryAzureDisk } from '../models/InventoryAzureDisk.js';
import { InventoryBackupPolicy } from '../models/InventoryBackupPolicy.js';
import { InventoryClassificationPolicy } from '../models/InventoryClassificationPolicy.js';
import { InventoryFilterConditions } from '../models/InventoryFilterConditions.js';
import { InventoryGcpDisk } from '../models/InventoryGcpDisk.js';
import { InventoryResource } from '../models/InventoryResource.js';
import { InventoryResourceMetadata } from '../models/InventoryResourceMetadata.js';
import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume.js';
import { InventoryVault } from '../models/InventoryVault.js';
import { InventoryVolume } from '../models/InventoryVolume.js';
import { IsVaultDeletableResponse } from '../models/IsVaultDeletableResponse.js';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments.js';
import { IssuesFilters } from '../models/IssuesFilters.js';
import { JobExecutionDetails } from '../models/JobExecutionDetails.js';
import { JobFailedNotificationArguments } from '../models/JobFailedNotificationArguments.js';
import { JobIdFilters } from '../models/JobIdFilters.js';
import { JobInitiationResponse } from '../models/JobInitiationResponse.js';
import { JobMetricsReportFailedArguments } from '../models/JobMetricsReportFailedArguments.js';
import { JobProgressStep } from '../models/JobProgressStep.js';
import { JobProgressStepBucketDataBackupData } from '../models/JobProgressStepBucketDataBackupData.js';
import { JobProgressStepBucketDataBackupDataCoverage } from '../models/JobProgressStepBucketDataBackupDataCoverage.js';
import { JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner } from '../models/JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner.js';
import { JobProgressStepBucketDataRestorationData } from '../models/JobProgressStepBucketDataRestorationData.js';
import { JobProgressStepConnectingToRestoreServerData } from '../models/JobProgressStepConnectingToRestoreServerData.js';
import { JobProgressStepCreateInstanceData } from '../models/JobProgressStepCreateInstanceData.js';
import { JobProgressStepDatabaseClusterCreationData } from '../models/JobProgressStepDatabaseClusterCreationData.js';
import { JobProgressStepDatabaseDataRestorationData } from '../models/JobProgressStepDatabaseDataRestorationData.js';
import { JobProgressStepRestoreVolumeData } from '../models/JobProgressStepRestoreVolumeData.js';
import { JobProgressStepRestoreWorkerData } from '../models/JobProgressStepRestoreWorkerData.js';
import { JobProgressStepScanningBucketData } from '../models/JobProgressStepScanningBucketData.js';
import { JobProgressStepScanningBucketDataTierByClassInner } from '../models/JobProgressStepScanningBucketDataTierByClassInner.js';
import { JobProgressStepVolumeCreationData } from '../models/JobProgressStepVolumeCreationData.js';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails.js';
import { JobStatusFilters } from '../models/JobStatusFilters.js';
import { JobStep } from '../models/JobStep.js';
import { JobSucceededNotificationArguments } from '../models/JobSucceededNotificationArguments.js';
import { KeyspacesBackupConfig } from '../models/KeyspacesBackupConfig.js';
import { KeyspacesBackupConfigApplication } from '../models/KeyspacesBackupConfigApplication.js';
import { KeyspacesTableRestoreDestination } from '../models/KeyspacesTableRestoreDestination.js';
import { LimitData } from '../models/LimitData.js';
import { ListAccessibleAccountsResponse } from '../models/ListAccessibleAccountsResponse.js';
import { ListAccountsResponse } from '../models/ListAccountsResponse.js';
import { ListAllRegionsResponse } from '../models/ListAllRegionsResponse.js';
import { ListAllRegionsResponseRegions } from '../models/ListAllRegionsResponseRegions.js';
import { ListApiCredentialsResponse } from '../models/ListApiCredentialsResponse.js';
import { ListApplicationOverrideResponse } from '../models/ListApplicationOverrideResponse.js';
import { ListAtlasOrganizationsResponse } from '../models/ListAtlasOrganizationsResponse.js';
import { ListAuditLogRequest } from '../models/ListAuditLogRequest.js';
import { ListAuditLogResponse } from '../models/ListAuditLogResponse.js';
import { ListAuditLogsResponse } from '../models/ListAuditLogsResponse.js';
import { ListAwsVpcsResponse } from '../models/ListAwsVpcsResponse.js';
import { ListAwsVpcsResponseVpcsInner } from '../models/ListAwsVpcsResponseVpcsInner.js';
import { ListAzureAppRegistrationsResponse } from '../models/ListAzureAppRegistrationsResponse.js';
import { ListAzureCmkEligibleAppsResponse } from '../models/ListAzureCmkEligibleAppsResponse.js';
import { ListAzureFileShares200Response } from '../models/ListAzureFileShares200Response.js';
import { ListAzureFileShares200ResponseFileSharesInner } from '../models/ListAzureFileShares200ResponseFileSharesInner.js';
import { ListAzureFileSharesRequest } from '../models/ListAzureFileSharesRequest.js';
import { ListAzureRegions200Response } from '../models/ListAzureRegions200Response.js';
import { ListAzureSKUs200Response } from '../models/ListAzureSKUs200Response.js';
import { ListAzureSKUs200ResponseSkusInner } from '../models/ListAzureSKUs200ResponseSkusInner.js';
import { ListAzureSKUsRequest } from '../models/ListAzureSKUsRequest.js';
import { ListAzureStorageAccountContainers200Response } from '../models/ListAzureStorageAccountContainers200Response.js';
import { ListAzureStorageAccountContainersRequest } from '../models/ListAzureStorageAccountContainersRequest.js';
import { ListAzureSubnets200Response } from '../models/ListAzureSubnets200Response.js';
import { ListAzureSubnets200ResponseSubnetsInner } from '../models/ListAzureSubnets200ResponseSubnetsInner.js';
import { ListAzureSubnetsRequest } from '../models/ListAzureSubnetsRequest.js';
import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response.js';
import { ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner } from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.js';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest.js';
import { ListAzureVirtualNetworks200Response } from '../models/ListAzureVirtualNetworks200Response.js';
import { ListAzureVirtualNetworks200ResponseVirtualNetworksInner } from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner.js';
import { ListAzureVirtualNetworksRequest } from '../models/ListAzureVirtualNetworksRequest.js';
import { ListBackupJobTypesResponse } from '../models/ListBackupJobTypesResponse.js';
import { ListBackupJobsInternal200Response } from '../models/ListBackupJobsInternal200Response.js';
import { ListBackupJobsRequest } from '../models/ListBackupJobsRequest.js';
import { ListBackupJobsResponse } from '../models/ListBackupJobsResponse.js';
import { ListBackupPoliciesResponse } from '../models/ListBackupPoliciesResponse.js';
import { ListBackupPolicyResponse } from '../models/ListBackupPolicyResponse.js';
import { ListBackupVaultResponse } from '../models/ListBackupVaultResponse.js';
import { ListBackupZeroEtlPoliciesResponse } from '../models/ListBackupZeroEtlPoliciesResponse.js';
import { ListBillingTransactionHistoryRequest } from '../models/ListBillingTransactionHistoryRequest.js';
import { ListBillingTransactionHistoryResponse } from '../models/ListBillingTransactionHistoryResponse.js';
import { ListClassificationCategoriesResponse } from '../models/ListClassificationCategoriesResponse.js';
import { ListClassificationPoliciesResponse } from '../models/ListClassificationPoliciesResponse.js';
import { ListCloudSnapshotsResponse } from '../models/ListCloudSnapshotsResponse.js';
import { ListComplianceResourcesResponse } from '../models/ListComplianceResourcesResponse.js';
import { ListControlViolationsResponse } from '../models/ListControlViolationsResponse.js';
import { ListControlsResponse } from '../models/ListControlsResponse.js';
import { ListCredentialFindingsResponse } from '../models/ListCredentialFindingsResponse.js';
import { ListDailySnapshotsResponse } from '../models/ListDailySnapshotsResponse.js';
import { ListDataClassificationEntitiesResponse } from '../models/ListDataClassificationEntitiesResponse.js';
import { ListDatabaseSnapshotsResponse } from '../models/ListDatabaseSnapshotsResponse.js';
import { ListDlsgPoliciesResponse } from '../models/ListDlsgPoliciesResponse.js';
import { ListDynamoDbBackupConfigsResponse } from '../models/ListDynamoDbBackupConfigsResponse.js';
import { ListEksClustersResponse } from '../models/ListEksClustersResponse.js';
import { ListExclusionPatternResourcesResponse } from '../models/ListExclusionPatternResourcesResponse.js';
import { ListFindingExclusionPatternsRequest } from '../models/ListFindingExclusionPatternsRequest.js';
import { ListFindingExclusionPatternsResponse } from '../models/ListFindingExclusionPatternsResponse.js';
import { ListFindingsResponse } from '../models/ListFindingsResponse.js';
import { ListGcpFoldersResponse } from '../models/ListGcpFoldersResponse.js';
import { ListGcpNetworksResponse } from '../models/ListGcpNetworksResponse.js';
import { ListGcpNetworksResponseNetworksInner } from '../models/ListGcpNetworksResponseNetworksInner.js';
import { ListGcpOrganizationsResponse } from '../models/ListGcpOrganizationsResponse.js';
import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse.js';
import { ListGdsgEnvironmentsResponse } from '../models/ListGdsgEnvironmentsResponse.js';
import { ListGdsgObjectsResponse } from '../models/ListGdsgObjectsResponse.js';
import { ListGoogleWorkspaceGroups200Response } from '../models/ListGoogleWorkspaceGroups200Response.js';
import { ListGoogleWorkspaceOrgUnits200Response } from '../models/ListGoogleWorkspaceOrgUnits200Response.js';
import { ListGoogleWorkspaceSharedDrives200Response } from '../models/ListGoogleWorkspaceSharedDrives200Response.js';
import { ListGoogleWorkspaceUsers200Response } from '../models/ListGoogleWorkspaceUsers200Response.js';
import { ListGoogleWorkspacesWithPolicyStatusResponse } from '../models/ListGoogleWorkspacesWithPolicyStatusResponse.js';
import { ListGroupConversationsRequest } from '../models/ListGroupConversationsRequest.js';
import { ListIdpGroupsResponse } from '../models/ListIdpGroupsResponse.js';
import { ListIdpsResponse } from '../models/ListIdpsResponse.js';
import { ListInfectedSnapshotsResponse } from '../models/ListInfectedSnapshotsResponse.js';
import { ListInitiatorsResponse } from '../models/ListInitiatorsResponse.js';
import { ListInstanceProfilesResponse } from '../models/ListInstanceProfilesResponse.js';
import { ListInstanceTypesResponse } from '../models/ListInstanceTypesResponse.js';
import { ListIntegrationsResponse } from '../models/ListIntegrationsResponse.js';
import { ListInventoryAppsResponse } from '../models/ListInventoryAppsResponse.js';
import { ListInventoryBackupRegionsResponse } from '../models/ListInventoryBackupRegionsResponse.js';
import { ListInventoryClassificationEntitiesResponse } from '../models/ListInventoryClassificationEntitiesResponse.js';
import { ListInventoryEnvironmentsResponse } from '../models/ListInventoryEnvironmentsResponse.js';
import { ListInventoryGlobalDatabasesResponse } from '../models/ListInventoryGlobalDatabasesResponse.js';
import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse.js';
import { ListInventoryNetworksResponse } from '../models/ListInventoryNetworksResponse.js';
import { ListInventoryRequest } from '../models/ListInventoryRequest.js';
import { ListInventoryResourceGroupsResponse } from '../models/ListInventoryResourceGroupsResponse.js';
import { ListInventoryResourceIdentifiersResponse } from '../models/ListInventoryResourceIdentifiersResponse.js';
import { ListInventoryResourceTypesResponse } from '../models/ListInventoryResourceTypesResponse.js';
import { ListInventoryResourcesResponse } from '../models/ListInventoryResourcesResponse.js';
import { ListInventorySensitivityAnnotationValuesResponse } from '../models/ListInventorySensitivityAnnotationValuesResponse.js';
import { ListInventorySnapshotsRequest } from '../models/ListInventorySnapshotsRequest.js';
import { ListInventorySnapshotsResponse } from '../models/ListInventorySnapshotsResponse.js';
import { ListInventorySourceRegionsResponse } from '../models/ListInventorySourceRegionsResponse.js';
import { ListInventorySubnetsResponse } from '../models/ListInventorySubnetsResponse.js';
import { ListInventoryTagsResponse } from '../models/ListInventoryTagsResponse.js';
import { ListJobErrorCodesResponse } from '../models/ListJobErrorCodesResponse.js';
import { ListKeyspacesBackupConfigsResponse } from '../models/ListKeyspacesBackupConfigsResponse.js';
import { ListKnownAppsResponse } from '../models/ListKnownAppsResponse.js';
import { ListLogSourcesPoliciesResponse } from '../models/ListLogSourcesPoliciesResponse.js';
import { ListLogSourcesResponse } from '../models/ListLogSourcesResponse.js';
import { ListMPAOperationsResponse } from '../models/ListMPAOperationsResponse.js';
import { ListMPAPoliciesResponse } from '../models/ListMPAPoliciesResponse.js';
import { ListMPARequestsRequest } from '../models/ListMPARequestsRequest.js';
import { ListMPARequestsRequestFilters } from '../models/ListMPARequestsRequestFilters.js';
import { ListMPARequestsResponse } from '../models/ListMPARequestsResponse.js';
import { ListMPARequestsSort } from '../models/ListMPARequestsSort.js';
import { ListMicrosoft365GroupMembers200Response } from '../models/ListMicrosoft365GroupMembers200Response.js';
import { ListMicrosoft365Groups200Response } from '../models/ListMicrosoft365Groups200Response.js';
import { ListMicrosoft365GroupsRequest } from '../models/ListMicrosoft365GroupsRequest.js';
import { ListMicrosoft365SharePointSites200Response } from '../models/ListMicrosoft365SharePointSites200Response.js';
import { ListMicrosoft365SharePointSitesRequest } from '../models/ListMicrosoft365SharePointSitesRequest.js';
import { ListMicrosoft365Users200Response } from '../models/ListMicrosoft365Users200Response.js';
import { ListMicrosoft365UsersRequest } from '../models/ListMicrosoft365UsersRequest.js';
import { ListMongoAtlasPrivateLinks200Response } from '../models/ListMongoAtlasPrivateLinks200Response.js';
import { ListMongoDbBackupConfigsResponse } from '../models/ListMongoDbBackupConfigsResponse.js';
import { ListMyMPARequestsRequest } from '../models/ListMyMPARequestsRequest.js';
import { ListMyMPARequestsRequestFilters } from '../models/ListMyMPARequestsRequestFilters.js';
import { ListMyMPARequestsResponse } from '../models/ListMyMPARequestsResponse.js';
import { ListNotificationPoliciesResponse } from '../models/ListNotificationPoliciesResponse.js';
import { ListNotificationsResponse } from '../models/ListNotificationsResponse.js';
import { ListOAuthAppsResponse } from '../models/ListOAuthAppsResponse.js';
import { ListObjectStoreExclusionRulesResponse } from '../models/ListObjectStoreExclusionRulesResponse.js';
import { ListOrganizationAccountsResponse } from '../models/ListOrganizationAccountsResponse.js';
import { ListOrganizationIdpsResponse } from '../models/ListOrganizationIdpsResponse.js';
import { ListPermissionsResponse } from '../models/ListPermissionsResponse.js';
import { ListProjectsResponse } from '../models/ListProjectsResponse.js';
import { ListResourceAttachmentEventsResponse } from '../models/ListResourceAttachmentEventsResponse.js';
import { ListResourcesResponse } from '../models/ListResourcesResponse.js';
import { ListRestoreAccountsRequest } from '../models/ListRestoreAccountsRequest.js';
import { ListRestoreAccountsResponse } from '../models/ListRestoreAccountsResponse.js';
import { ListRestoreAwsOrganizationalUnitsResponse } from '../models/ListRestoreAwsOrganizationalUnitsResponse.js';
import { ListRestoreJobTypesResponse } from '../models/ListRestoreJobTypesResponse.js';
import { ListRestoreJobsInternal200Response } from '../models/ListRestoreJobsInternal200Response.js';
import { ListRestoreJobsRequest } from '../models/ListRestoreJobsRequest.js';
import { ListRestoreJobsResponse } from '../models/ListRestoreJobsResponse.js';
import { ListRestoreTemplatesRequest } from '../models/ListRestoreTemplatesRequest.js';
import { ListRestoreTemplatesResponse } from '../models/ListRestoreTemplatesResponse.js';
import { ListRestoreTemplatesResponsePagination } from '../models/ListRestoreTemplatesResponsePagination.js';
import { ListRolesResponse } from '../models/ListRolesResponse.js';
import { ListScanJobTypesResponse } from '../models/ListScanJobTypesResponse.js';
import { ListScanJobsInternal200Response } from '../models/ListScanJobsInternal200Response.js';
import { ListScanJobsRequest } from '../models/ListScanJobsRequest.js';
import { ListScanJobsResponse } from '../models/ListScanJobsResponse.js';
import { ListSecurityFindingsRequest } from '../models/ListSecurityFindingsRequest.js';
import { ListSensitivityAnnotationsResponse } from '../models/ListSensitivityAnnotationsResponse.js';
import { ListSourceAccountsRequest } from '../models/ListSourceAccountsRequest.js';
import { ListSourceAccountsResponse } from '../models/ListSourceAccountsResponse.js';
import { ListSourceAwsOrganizationalUnitsResponse } from '../models/ListSourceAwsOrganizationalUnitsResponse.js';
import { ListStorageGatewaysResponse } from '../models/ListStorageGatewaysResponse.js';
import { ListSubnetsResponse } from '../models/ListSubnetsResponse.js';
import { ListSubnetsResponseV2 } from '../models/ListSubnetsResponseV2.js';
import { ListSubnetsResponseV2SubnetsInner } from '../models/ListSubnetsResponseV2SubnetsInner.js';
import { ListThreatHuntingResultsRequest } from '../models/ListThreatHuntingResultsRequest.js';
import { ListThreatHuntingResultsResponse } from '../models/ListThreatHuntingResultsResponse.js';
import { ListThreatHuntingScanRequestsRequest } from '../models/ListThreatHuntingScanRequestsRequest.js';
import { ListThreatHuntingScanRequestsResponse } from '../models/ListThreatHuntingScanRequestsResponse.js';
import { ListUsersResponse } from '../models/ListUsersResponse.js';
import { LlgLocationResource } from '../models/LlgLocationResource.js';
import { LlgLocationWithResources } from '../models/LlgLocationWithResources.js';
import { LlgResourcePolicy } from '../models/LlgResourcePolicy.js';
import { LogRecord } from '../models/LogRecord.js';
import { LogSource } from '../models/LogSource.js';
import { LogSourceLocation } from '../models/LogSourceLocation.js';
import { LogSourceLocationCloudTrail } from '../models/LogSourceLocationCloudTrail.js';
import { LogSourceLocationCloudWatchLogs } from '../models/LogSourceLocationCloudWatchLogs.js';
import { LogSourceLocationDatadog } from '../models/LogSourceLocationDatadog.js';
import { LogSourceLocationGcpCloudLogging } from '../models/LogSourceLocationGcpCloudLogging.js';
import { LogSourceLocationSplunkDdss } from '../models/LogSourceLocationSplunkDdss.js';
import { LogSourceWithPolicy } from '../models/LogSourceWithPolicy.js';
import { LogsHistogramDataPoint } from '../models/LogsHistogramDataPoint.js';
import { LogsSchema } from '../models/LogsSchema.js';
import { LogsSchemaColumn } from '../models/LogsSchemaColumn.js';
import { LogsSchemaEntry } from '../models/LogsSchemaEntry.js';
import { LogsSchemasResponse } from '../models/LogsSchemasResponse.js';
import { LuceneQueryInput } from '../models/LuceneQueryInput.js';
import { MPAInterceptedResponse } from '../models/MPAInterceptedResponse.js';
import { MPAInterceptedResponseMpaPolicies } from '../models/MPAInterceptedResponseMpaPolicies.js';
import { MPAOperationInfo } from '../models/MPAOperationInfo.js';
import { MPAPolicy } from '../models/MPAPolicy.js';
import { MPAPolicyExpression } from '../models/MPAPolicyExpression.js';
import { MPAPolicyGroupCondition } from '../models/MPAPolicyGroupCondition.js';
import { MPARequest } from '../models/MPARequest.js';
import { MPARequestDetail } from '../models/MPARequestDetail.js';
import { MPARequestNotificationArguments } from '../models/MPARequestNotificationArguments.js';
import { MPARequestPolicyDetail } from '../models/MPARequestPolicyDetail.js';
import { MPAResourceSelector } from '../models/MPAResourceSelector.js';
import { MPAReview } from '../models/MPAReview.js';
import { MPAReviewNotificationArguments } from '../models/MPAReviewNotificationArguments.js';
import { MaxRetentionDaysLimit } from '../models/MaxRetentionDaysLimit.js';
import { MaxRetentionRule } from '../models/MaxRetentionRule.js';
import { Message } from '../models/Message.js';
import { Microsoft365ConnectionInfo } from '../models/Microsoft365ConnectionInfo.js';
import { Microsoft365EntitySelection } from '../models/Microsoft365EntitySelection.js';
import { Microsoft365GraphPermission } from '../models/Microsoft365GraphPermission.js';
import { Microsoft365Group } from '../models/Microsoft365Group.js';
import { Microsoft365PolicyConfig } from '../models/Microsoft365PolicyConfig.js';
import { Microsoft365Resource } from '../models/Microsoft365Resource.js';
import { Microsoft365RestoreAccountAttributesInput } from '../models/Microsoft365RestoreAccountAttributesInput.js';
import { Microsoft365SharePointSite } from '../models/Microsoft365SharePointSite.js';
import { Microsoft365SourceAccountAttributesInput } from '../models/Microsoft365SourceAccountAttributesInput.js';
import { Microsoft365User } from '../models/Microsoft365User.js';
import { MicrosoftFabricIntegrationConfig } from '../models/MicrosoftFabricIntegrationConfig.js';
import { MinRetentionRule } from '../models/MinRetentionRule.js';
import { ModelError } from '../models/ModelError.js';
import { MongoAtlasClusterResource } from '../models/MongoAtlasClusterResource.js';
import { MongoAtlasPrivateLinkEntry } from '../models/MongoAtlasPrivateLinkEntry.js';
import { MongoAtlasRestoreAccountAttributes } from '../models/MongoAtlasRestoreAccountAttributes.js';
import { MongoAtlasRestoreAccountAttributesInput } from '../models/MongoAtlasRestoreAccountAttributesInput.js';
import { MongoAtlasSourceAccountAttributes } from '../models/MongoAtlasSourceAccountAttributes.js';
import { MongoAtlasSourceAccountAttributesInput } from '../models/MongoAtlasSourceAccountAttributesInput.js';
import { MongoDbBackupConfig } from '../models/MongoDbBackupConfig.js';
import { MonthlyConfig } from '../models/MonthlyConfig.js';
import { MonthlySnapshotData } from '../models/MonthlySnapshotData.js';
import { MsaAcceptanceResponse } from '../models/MsaAcceptanceResponse.js';
import { MultiResourceBackupZeroEtlConfiguration } from '../models/MultiResourceBackupZeroEtlConfiguration.js';
import { NativeStandardConfig } from '../models/NativeStandardConfig.js';
import { NeptuneClusterParameterGroup } from '../models/NeptuneClusterParameterGroup.js';
import { NeptuneClusterParameterGroups } from '../models/NeptuneClusterParameterGroups.js';
import { NeptuneRestoreDestination } from '../models/NeptuneRestoreDestination.js';
import { NeptuneSnapshotProperties } from '../models/NeptuneSnapshotProperties.js';
import { NetworkClassificationCondition } from '../models/NetworkClassificationCondition.js';
import { NetworkClassificationDetails } from '../models/NetworkClassificationDetails.js';
import { NetworkClassificationFilters } from '../models/NetworkClassificationFilters.js';
import { NetworkInterfaceConfig } from '../models/NetworkInterfaceConfig.js';
import { Notification } from '../models/Notification.js';
import { NotificationArguments } from '../models/NotificationArguments.js';
import { NotificationPolicy } from '../models/NotificationPolicy.js';
import { NotificationPolicyConfig } from '../models/NotificationPolicyConfig.js';
import { NotificationPolicyConfigDatadog } from '../models/NotificationPolicyConfigDatadog.js';
import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail.js';
import { NotificationPolicyConfigServiceNow } from '../models/NotificationPolicyConfigServiceNow.js';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack.js';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns.js';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk.js';
import { NotificationPolicyConfigWebhook } from '../models/NotificationPolicyConfigWebhook.js';
import { NumberOfCopiesRule } from '../models/NumberOfCopiesRule.js';
import { OAuthApp } from '../models/OAuthApp.js';
import { Oauth2TokenResponse } from '../models/Oauth2TokenResponse.js';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination.js';
import { ObjectStoreCoverageBreakdown } from '../models/ObjectStoreCoverageBreakdown.js';
import { ObjectStoreCoverageReasonEntry } from '../models/ObjectStoreCoverageReasonEntry.js';
import { ObjectStoreExclusionRule } from '../models/ObjectStoreExclusionRule.js';
import { ObjectStoreScanMethod } from '../models/ObjectStoreScanMethod.js';
import { ObjectStoreScanMethodSetting } from '../models/ObjectStoreScanMethodSetting.js';
import { ObjectStoreTierClass } from '../models/ObjectStoreTierClass.js';
import { OnboardAdditionalAzureApps200Response } from '../models/OnboardAdditionalAzureApps200Response.js';
import { OnboardAdditionalAzureAppsRequest } from '../models/OnboardAdditionalAzureAppsRequest.js';
import { OnboardRdsCdcRequest } from '../models/OnboardRdsCdcRequest.js';
import { OnboardRdsCdcResponse } from '../models/OnboardRdsCdcResponse.js';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup.js';
import { OperatingSystem } from '../models/OperatingSystem.js';
import { OperationIdFilters } from '../models/OperationIdFilters.js';
import { OrganizationAccount } from '../models/OrganizationAccount.js';
import { OrganizationAccountRole } from '../models/OrganizationAccountRole.js';
import { OrganizationIdp } from '../models/OrganizationIdp.js';
import { OrganizationSamlServiceProviderDetails } from '../models/OrganizationSamlServiceProviderDetails.js';
import { OverrideDataClassificationsRequest } from '../models/OverrideDataClassificationsRequest.js';
import { OverrideDataClassificationsResponse } from '../models/OverrideDataClassificationsResponse.js';
import { OverrideEnvironmentRequest } from '../models/OverrideEnvironmentRequest.js';
import { OverrideEnvironmentResponse } from '../models/OverrideEnvironmentResponse.js';
import { OverrideNetworkClassificationRequest } from '../models/OverrideNetworkClassificationRequest.js';
import { OverrideNetworkClassificationResponse } from '../models/OverrideNetworkClassificationResponse.js';
import { OverrideSensitivityAnnotationsRequest } from '../models/OverrideSensitivityAnnotationsRequest.js';
import { Pagination } from '../models/Pagination.js';
import { ParameterCheckResult } from '../models/ParameterCheckResult.js';
import { ParentIdFilters } from '../models/ParentIdFilters.js';
import { PartialRestoreData } from '../models/PartialRestoreData.js';
import { Path } from '../models/Path.js';
import { PathSnapshotsRequest } from '../models/PathSnapshotsRequest.js';
import { PathSnapshotsResponse } from '../models/PathSnapshotsResponse.js';
import { Permission } from '../models/Permission.js';
import { PermissionGrant } from '../models/PermissionGrant.js';
import { PermissionGrantInput } from '../models/PermissionGrantInput.js';
import { PersistentVolumeClaimProperties } from '../models/PersistentVolumeClaimProperties.js';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan.js';
import { PitrBackupResourceType } from '../models/PitrBackupResourceType.js';
import { PitrBackupSchedules } from '../models/PitrBackupSchedules.js';
import { PitrIntervalConfig } from '../models/PitrIntervalConfig.js';
import { PitrRestoreVaultWindows } from '../models/PitrRestoreVaultWindows.js';
import { PitrRestoreWindow } from '../models/PitrRestoreWindow.js';
import { PitrRestoreWindowsResponse } from '../models/PitrRestoreWindowsResponse.js';
import { Preferences } from '../models/Preferences.js';
import { PrivateLinkCheckResult } from '../models/PrivateLinkCheckResult.js';
import { PrivateLinkFormatInstructions } from '../models/PrivateLinkFormatInstructions.js';
import { PrivateLinkInstructionStep } from '../models/PrivateLinkInstructionStep.js';
import { Project } from '../models/Project.js';
import { ProjectIdFilters } from '../models/ProjectIdFilters.js';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters.js';
import { ProviderCategoryFilters } from '../models/ProviderCategoryFilters.js';
import { ProviderParentIdFilters } from '../models/ProviderParentIdFilters.js';
import { ProviderRestoreAccountConnectivityConfig } from '../models/ProviderRestoreAccountConnectivityConfig.js';
import { PulumiConfiguration } from '../models/PulumiConfiguration.js';
import { PulumiConfigurations } from '../models/PulumiConfigurations.js';
import { PulumiConfigurationsFilterConditions } from '../models/PulumiConfigurationsFilterConditions.js';
import { PulumiConfigurationsRequest } from '../models/PulumiConfigurationsRequest.js';
import { QueryCostData400Response } from '../models/QueryCostData400Response.js';
import { QueryCostDataRequest } from '../models/QueryCostDataRequest.js';
import { QueryCostDataResponse } from '../models/QueryCostDataResponse.js';
import { QueryDBRequest } from '../models/QueryDBRequest.js';
import { QueryDBResponse } from '../models/QueryDBResponse.js';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination.js';
import { QueryDBResultResponse } from '../models/QueryDBResultResponse.js';
import { QueryDBStatusResponse } from '../models/QueryDBStatusResponse.js';
import { QuotaStatusFilters } from '../models/QuotaStatusFilters.js';
import { RamShareCheckResult } from '../models/RamShareCheckResult.js';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments.js';
import { RdsNativePitrAdvancedConfig } from '../models/RdsNativePitrAdvancedConfig.js';
import { RdsNativePitrClusterAdvancedConfig } from '../models/RdsNativePitrClusterAdvancedConfig.js';
import { RdsNativePitrNetworkConfig } from '../models/RdsNativePitrNetworkConfig.js';
import { RdsNativePitrWindow } from '../models/RdsNativePitrWindow.js';
import { RdsPasswordConfig } from '../models/RdsPasswordConfig.js';
import { RdsSecurityGroup } from '../models/RdsSecurityGroup.js';
import { ReactivateAccountRequest } from '../models/ReactivateAccountRequest.js';
import { ReassessActionRequiredRequest } from '../models/ReassessActionRequiredRequest.js';
import { ReassessActionRequiredResponse } from '../models/ReassessActionRequiredResponse.js';
import { ReconnectCustomerVaultAccountResponse } from '../models/ReconnectCustomerVaultAccountResponse.js';
import { ReconnectRestoreAccountResponse } from '../models/ReconnectRestoreAccountResponse.js';
import { ReconnectRestoreAwsOrganizationalUnitResponse } from '../models/ReconnectRestoreAwsOrganizationalUnitResponse.js';
import { ReconnectSourceAccountResponse } from '../models/ReconnectSourceAccountResponse.js';
import { ReconnectSourceAwsOrganizationalUnitResponse } from '../models/ReconnectSourceAwsOrganizationalUnitResponse.js';
import { RecordRestoreResult } from '../models/RecordRestoreResult.js';
import { RecoveryPointData } from '../models/RecoveryPointData.js';
import { RegionCondition } from '../models/RegionCondition.js';
import { RegisterInput } from '../models/RegisterInput.js';
import { RegisterInputBillingToken } from '../models/RegisterInputBillingToken.js';
import { RegisterResponse } from '../models/RegisterResponse.js';
import { RelatedGlobalDbCluster } from '../models/RelatedGlobalDbCluster.js';
import { RequestDetails } from '../models/RequestDetails.js';
import { ResourceBackupSettings } from '../models/ResourceBackupSettings.js';
import { ResourceBlockerDetail } from '../models/ResourceBlockerDetail.js';
import { ResourceComplianceRow } from '../models/ResourceComplianceRow.js';
import { ResourceDetails } from '../models/ResourceDetails.js';
import { ResourceGroupNameCondition } from '../models/ResourceGroupNameCondition.js';
import { ResourceIdCondition } from '../models/ResourceIdCondition.js';
import { ResourceIdFilters } from '../models/ResourceIdFilters.js';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers.js';
import { ResourceNameCondition } from '../models/ResourceNameCondition.js';
import { ResourceNameFilters } from '../models/ResourceNameFilters.js';
import { ResourceProperties } from '../models/ResourceProperties.js';
import { ResourceQuota } from '../models/ResourceQuota.js';
import { ResourceReference } from '../models/ResourceReference.js';
import { ResourceSnapshot } from '../models/ResourceSnapshot.js';
import { ResourceSnapshotProperties } from '../models/ResourceSnapshotProperties.js';
import { ResourceTag } from '../models/ResourceTag.js';
import { ResourceTypeCondition } from '../models/ResourceTypeCondition.js';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters.js';
import { ResourceTypeToSecurityGroup } from '../models/ResourceTypeToSecurityGroup.js';
import { ResourceValidationError } from '../models/ResourceValidationError.js';
import { RestoreAccount } from '../models/RestoreAccount.js';
import { RestoreAccountAttributesInput } from '../models/RestoreAccountAttributesInput.js';
import { RestoreAccountCloudAttributes } from '../models/RestoreAccountCloudAttributes.js';
import { RestoreAccountConnectivityConfig } from '../models/RestoreAccountConnectivityConfig.js';
import { RestoreAccountMetricsConfig } from '../models/RestoreAccountMetricsConfig.js';
import { RestoreAccountRegions } from '../models/RestoreAccountRegions.js';
import { RestoreAccountsFilterConditions } from '../models/RestoreAccountsFilterConditions.js';
import { RestoreAtlasClusterInput } from '../models/RestoreAtlasClusterInput.js';
import { RestoreAvailabilityZones } from '../models/RestoreAvailabilityZones.js';
import { RestoreAwsCassandraClusterRequest } from '../models/RestoreAwsCassandraClusterRequest.js';
import { RestoreAwsEc2InstanceRequest } from '../models/RestoreAwsEc2InstanceRequest.js';
import { RestoreAwsOrganizationalUnit } from '../models/RestoreAwsOrganizationalUnit.js';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig.js';
import { RestoreAzureDiskRequest } from '../models/RestoreAzureDiskRequest.js';
import { RestoreAzureFileShareRequest } from '../models/RestoreAzureFileShareRequest.js';
import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput.js';
import { RestoreAzurePostgresDatabaseRequest } from '../models/RestoreAzurePostgresDatabaseRequest.js';
import { RestoreAzureSqlDatabaseNativePitrRequest } from '../models/RestoreAzureSqlDatabaseNativePitrRequest.js';
import { RestoreAzureSqlDatabaseRequest } from '../models/RestoreAzureSqlDatabaseRequest.js';
import { RestoreAzureSqlVmPitrRequest } from '../models/RestoreAzureSqlVmPitrRequest.js';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig.js';
import { RestoreAzureVmInstanceRequest } from '../models/RestoreAzureVmInstanceRequest.js';
import { RestoreBigQueryDatasetRequest } from '../models/RestoreBigQueryDatasetRequest.js';
import { RestoreBigQueryNativePitrRequest } from '../models/RestoreBigQueryNativePitrRequest.js';
import { RestoreBucketRequest } from '../models/RestoreBucketRequest.js';
import { RestoreDbToRdsInstanceRequest } from '../models/RestoreDbToRdsInstanceRequest.js';
import { RestoreDbToRdsSnapshotRequest } from '../models/RestoreDbToRdsSnapshotRequest.js';
import { RestoreDestinationLimits } from '../models/RestoreDestinationLimits.js';
import { RestoreDocumentDBRequest } from '../models/RestoreDocumentDBRequest.js';
import { RestoreDynamoDBTableRequest } from '../models/RestoreDynamoDBTableRequest.js';
import { RestoreDynamoDBToExistingTableRequest } from '../models/RestoreDynamoDBToExistingTableRequest.js';
import { RestoreDynamoDBToS3Request } from '../models/RestoreDynamoDBToS3Request.js';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig.js';
import { RestoreEFSRequest } from '../models/RestoreEFSRequest.js';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig.js';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig.js';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig.js';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput.js';
import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput.js';
import { RestoreFSxRequest } from '../models/RestoreFSxRequest.js';
import { RestoreFilesRequest } from '../models/RestoreFilesRequest.js';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig.js';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig.js';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig.js';
import { RestoreGcpCloudSqlRequest } from '../models/RestoreGcpCloudSqlRequest.js';
import { RestoreGcpDiskRequest } from '../models/RestoreGcpDiskRequest.js';
import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput.js';
import { RestoreGcpVmInstanceRequest } from '../models/RestoreGcpVmInstanceRequest.js';
import { RestoreGoogleWorkspaceRequest } from '../models/RestoreGoogleWorkspaceRequest.js';
import { RestoreImageImageDeviceInput } from '../models/RestoreImageImageDeviceInput.js';
import { RestoreImageImageInput } from '../models/RestoreImageImageInput.js';
import { RestoreImageInput } from '../models/RestoreImageInput.js';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput.js';
import { RestoreInstanceImageDeviceInput } from '../models/RestoreInstanceImageDeviceInput.js';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput.js';
import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput.js';
import { RestoreJob } from '../models/RestoreJob.js';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration.js';
import { RestoreJobInitiationResponse } from '../models/RestoreJobInitiationResponse.js';
import { RestoreJobTypeFilters } from '../models/RestoreJobTypeFilters.js';
import { RestoreJobsFilterConditions } from '../models/RestoreJobsFilterConditions.js';
import { RestoreKeyspacesTableRequest } from '../models/RestoreKeyspacesTableRequest.js';
import { RestoreMicrosoft365Request } from '../models/RestoreMicrosoft365Request.js';
import { RestoreNeptuneRequest } from '../models/RestoreNeptuneRequest.js';
import { RestoreObfuscationConfig } from '../models/RestoreObfuscationConfig.js';
import { RestoreRdsInstanceClasses } from '../models/RestoreRdsInstanceClasses.js';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig.js';
import { RestoreRdsNativePitrRequest } from '../models/RestoreRdsNativePitrRequest.js';
import { RestoreRdsSubnetGroups } from '../models/RestoreRdsSubnetGroups.js';
import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner.js';
import { RestoreResult } from '../models/RestoreResult.js';
import { RestoreSecurityGroups } from '../models/RestoreSecurityGroups.js';
import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner.js';
import { RestoreTemplate } from '../models/RestoreTemplate.js';
import { RestoreTemplateFilterConditions } from '../models/RestoreTemplateFilterConditions.js';
import { RestoreTemplateIdFilters } from '../models/RestoreTemplateIdFilters.js';
import { RestoreTemplateResourceTypeFilters } from '../models/RestoreTemplateResourceTypeFilters.js';
import { RestoreVolumeToEbsRequest } from '../models/RestoreVolumeToEbsRequest.js';
import { RestoreVolumeToEbsSnapshotRequest } from '../models/RestoreVolumeToEbsSnapshotRequest.js';
import { RevalidateRestoreTemplateRequest } from '../models/RevalidateRestoreTemplateRequest.js';
import { RevalidateRestoreTemplateResponse } from '../models/RevalidateRestoreTemplateResponse.js';
import { RevalidationReport } from '../models/RevalidationReport.js';
import { Role } from '../models/Role.js';
import { RoleAccessGroupCondition } from '../models/RoleAccessGroupCondition.js';
import { RoleUsage } from '../models/RoleUsage.js';
import { RuleOutcome } from '../models/RuleOutcome.js';
import { RuleOutcomeList } from '../models/RuleOutcomeList.js';
import { S3Bucket } from '../models/S3Bucket.js';
import { S3Buckets } from '../models/S3Buckets.js';
import { S3RestoreDestination } from '../models/S3RestoreDestination.js';
import { S3RestoreTarget } from '../models/S3RestoreTarget.js';
import { S3TemplateParams } from '../models/S3TemplateParams.js';
import { SAMLCallback400Response } from '../models/SAMLCallback400Response.js';
import { SAMLCallback401Response } from '../models/SAMLCallback401Response.js';
import { SAMLCallback500Response } from '../models/SAMLCallback500Response.js';
import { SameSourceAccountRestoreLimits } from '../models/SameSourceAccountRestoreLimits.js';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider.js';
import { SamlIdentityProviderConfigsResponse } from '../models/SamlIdentityProviderConfigsResponse.js';
import { SapHanaInstance } from '../models/SapHanaInstance.js';
import { SapHanaRestoreProperties } from '../models/SapHanaRestoreProperties.js';
import { SaveCloudResourceSecurityPropertiesRequest } from '../models/SaveCloudResourceSecurityPropertiesRequest.js';
import { ScanJob } from '../models/ScanJob.js';
import { SchemaRecord } from '../models/SchemaRecord.js';
import { SearchDBResponse } from '../models/SearchDBResponse.js';
import { SearchDirectoryEntitiesRequest } from '../models/SearchDirectoryEntitiesRequest.js';
import { SearchDirectoryEntitiesResponse } from '../models/SearchDirectoryEntitiesResponse.js';
import { SearchFilesResponse } from '../models/SearchFilesResponse.js';
import { SearchInput } from '../models/SearchInput.js';
import { SearchLogsHistogramInput } from '../models/SearchLogsHistogramInput.js';
import { SearchLogsHistogramResponse } from '../models/SearchLogsHistogramResponse.js';
import { SearchLogsInput } from '../models/SearchLogsInput.js';
import { SearchLogsResponse } from '../models/SearchLogsResponse.js';
import { SearchResources200Response } from '../models/SearchResources200Response.js';
import { SearchResources200ResponseTablesInner } from '../models/SearchResources200ResponseTablesInner.js';
import { SearchResources200ResponseTablesInnerResource } from '../models/SearchResources200ResponseTablesInnerResource.js';
import { SearchResources200ResponseTablesInnerSnapshots } from '../models/SearchResources200ResponseTablesInnerSnapshots.js';
import { SearchResources200ResponseTablesInnerSource } from '../models/SearchResources200ResponseTablesInnerSource.js';
import { SearchResources200ResponseTablesInnerTablesInner } from '../models/SearchResources200ResponseTablesInnerTablesInner.js';
import { SearchResources200ResponseTablesInnerTablesInnerColumnsInner } from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner.js';
import { SearchResourcesRequest } from '../models/SearchResourcesRequest.js';
import { SecurityFindingsFilterConditions } from '../models/SecurityFindingsFilterConditions.js';
import { SecurityInformation } from '../models/SecurityInformation.js';
import { SecurityPlan } from '../models/SecurityPlan.js';
import { SecurityPlanEnabledResponse } from '../models/SecurityPlanEnabledResponse.js';
import { SecurityResourceNotificationArguments } from '../models/SecurityResourceNotificationArguments.js';
import { SecurityScan } from '../models/SecurityScan.js';
import { SecurityScanConclusionCondition } from '../models/SecurityScanConclusionCondition.js';
import { SecurityScanConclusionFilters } from '../models/SecurityScanConclusionFilters.js';
import { SecurityScanNotificationData } from '../models/SecurityScanNotificationData.js';
import { SecurityScanResult } from '../models/SecurityScanResult.js';
import { SecurityScansSummaryResponse } from '../models/SecurityScansSummaryResponse.js';
import { SecuritySnapshotNotificationArguments } from '../models/SecuritySnapshotNotificationArguments.js';
import { SecuritySummary } from '../models/SecuritySummary.js';
import { SendA2AMessageRequest } from '../models/SendA2AMessageRequest.js';
import { SendMessageToAI400Response } from '../models/SendMessageToAI400Response.js';
import { SendMessageToAIRequest } from '../models/SendMessageToAIRequest.js';
import { SensitivityAnnotation } from '../models/SensitivityAnnotation.js';
import { SensitivityAnnotationsCondition } from '../models/SensitivityAnnotationsCondition.js';
import { SensitivityLabelsDetails } from '../models/SensitivityLabelsDetails.js';
import { SensitivityLabelsFilters } from '../models/SensitivityLabelsFilters.js';
import { ServiceProviderDetails } from '../models/ServiceProviderDetails.js';
import { Session } from '../models/Session.js';
import { SetupAwsPrivateLinkRequest } from '../models/SetupAwsPrivateLinkRequest.js';
import { SetupAwsPrivateLinkResponse } from '../models/SetupAwsPrivateLinkResponse.js';
import { SetupMongoAtlasPrivateLinkRequest } from '../models/SetupMongoAtlasPrivateLinkRequest.js';
import { SetupMongoAtlasPrivateLinkResponse } from '../models/SetupMongoAtlasPrivateLinkResponse.js';
import { SeverityFilters } from '../models/SeverityFilters.js';
import { SingleResourceBackupZeroEtlConfiguration } from '../models/SingleResourceBackupZeroEtlConfiguration.js';
import { Snapshot } from '../models/Snapshot.js';
import { SnapshotAccessDeniedNotificationArguments } from '../models/SnapshotAccessDeniedNotificationArguments.js';
import { SnapshotCoverage } from '../models/SnapshotCoverage.js';
import { SnapshotDateFilters } from '../models/SnapshotDateFilters.js';
import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions.js';
import { SnapshotFindingCountsResponse } from '../models/SnapshotFindingCountsResponse.js';
import { SnapshotHistogramBucket } from '../models/SnapshotHistogramBucket.js';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters.js';
import { SnapshotLocation } from '../models/SnapshotLocation.js';
import { SnapshotReference } from '../models/SnapshotReference.js';
import { SnapshotStorage } from '../models/SnapshotStorage.js';
import { SnapshotTimeFilters } from '../models/SnapshotTimeFilters.js';
import { SnapshotsSummaryResponse } from '../models/SnapshotsSummaryResponse.js';
import { SnowflakeIntegrationConfig } from '../models/SnowflakeIntegrationConfig.js';
import { SortBackupJobBy } from '../models/SortBackupJobBy.js';
import { SortLogsBy } from '../models/SortLogsBy.js';
import { SortResourceBy } from '../models/SortResourceBy.js';
import { SortRestoreAccountsBy } from '../models/SortRestoreAccountsBy.js';
import { SortRestoreJobBy } from '../models/SortRestoreJobBy.js';
import { SortSnapshotsBy } from '../models/SortSnapshotsBy.js';
import { SortSourceAccountsBy } from '../models/SortSourceAccountsBy.js';
import { SourceAccount } from '../models/SourceAccount.js';
import { SourceAccountAttributesInput } from '../models/SourceAccountAttributesInput.js';
import { SourceAccountCloudAttributes } from '../models/SourceAccountCloudAttributes.js';
import { SourceAccountMetricsConfig } from '../models/SourceAccountMetricsConfig.js';
import { SourceAccountProviderIdFilters } from '../models/SourceAccountProviderIdFilters.js';
import { SourceAccountsFilterConditions } from '../models/SourceAccountsFilterConditions.js';
import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit.js';
import { SourceRegionFilters } from '../models/SourceRegionFilters.js';
import { SourceSizeCheckResult } from '../models/SourceSizeCheckResult.js';
import { SourceStorage } from '../models/SourceStorage.js';
import { SourceStorageBackupStatus } from '../models/SourceStorageBackupStatus.js';
import { SqlInstructions } from '../models/SqlInstructions.js';
import { SqlVmNetworkInfo } from '../models/SqlVmNetworkInfo.js';
import { SsoIntegrationSettings } from '../models/SsoIntegrationSettings.js';
import { StackNameFilters } from '../models/StackNameFilters.js';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan.js';
import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig.js';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules.js';
import { StandardIntervalConfig } from '../models/StandardIntervalConfig.js';
import { StartTimeDateFilters } from '../models/StartTimeDateFilters.js';
import { StatusCodeFilters } from '../models/StatusCodeFilters.js';
import { StatusProperties } from '../models/StatusProperties.js';
import { StepProgressMetric } from '../models/StepProgressMetric.js';
import { StepProgressView } from '../models/StepProgressView.js';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination.js';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget.js';
import { StorageGateway } from '../models/StorageGateway.js';
import { StorageGatewayDetails } from '../models/StorageGatewayDetails.js';
import { SubmitMyMPARequestRequest } from '../models/SubmitMyMPARequestRequest.js';
import { SubmitMyMPARequestResponse } from '../models/SubmitMyMPARequestResponse.js';
import { SubnetConfig } from '../models/SubnetConfig.js';
import { SubnetFilters } from '../models/SubnetFilters.js';
import { SubnetPerAvailabilityZone } from '../models/SubnetPerAvailabilityZone.js';
import { SubnetsCondition } from '../models/SubnetsCondition.js';
import { SupportedProviders } from '../models/SupportedProviders.js';
import { TableRecord } from '../models/TableRecord.js';
import { TagKeyValue } from '../models/TagKeyValue.js';
import { TagKeyValuesCondition } from '../models/TagKeyValuesCondition.js';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters.js';
import { TagKeysCondition } from '../models/TagKeysCondition.js';
import { TagKeysFilters } from '../models/TagKeysFilters.js';
import { TakeNativeSnapshotRequest } from '../models/TakeNativeSnapshotRequest.js';
import { TakeSnapshotRequest } from '../models/TakeSnapshotRequest.js';
import { TakeSnapshotResponse } from '../models/TakeSnapshotResponse.js';
import { TeardownAwsPrivateLinkResponse } from '../models/TeardownAwsPrivateLinkResponse.js';
import { TeardownMongoAtlasPrivateLinkResponse } from '../models/TeardownMongoAtlasPrivateLinkResponse.js';
import { ThreatDetectionFilters } from '../models/ThreatDetectionFilters.js';
import { ThreatHuntingResult } from '../models/ThreatHuntingResult.js';
import { ThreatHuntingScanRequest } from '../models/ThreatHuntingScanRequest.js';
import { TimeFrame } from '../models/TimeFrame.js';
import { TimeOfDay } from '../models/TimeOfDay.js';
import { TimeOfYear } from '../models/TimeOfYear.js';
import { TokenResponse } from '../models/TokenResponse.js';
import { TotalSourceStorageSizeRequest } from '../models/TotalSourceStorageSizeRequest.js';
import { TotalSourceStorageSizeResponse } from '../models/TotalSourceStorageSizeResponse.js';
import { TrendPoint } from '../models/TrendPoint.js';
import { TriggerKeyspacesScheduledDump200Response } from '../models/TriggerKeyspacesScheduledDump200Response.js';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord.js';
import { UnifiedDBServerRecord } from '../models/UnifiedDBServerRecord.js';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord.js';
import { UnifiedSchemaRecord } from '../models/UnifiedSchemaRecord.js';
import { UnifiedTableRecord } from '../models/UnifiedTableRecord.js';
import { UpPulumiStacksResponse } from '../models/UpPulumiStacksResponse.js';
import { UpdateAccountCompanyContactsRequest } from '../models/UpdateAccountCompanyContactsRequest.js';
import { UpdateAccountLabelsRequest } from '../models/UpdateAccountLabelsRequest.js';
import { UpdateAccountProfileResponse } from '../models/UpdateAccountProfileResponse.js';
import { UpdateApiCredentialsRequest } from '../models/UpdateApiCredentialsRequest.js';
import { UpdateAwsRestoreAccountAttributes } from '../models/UpdateAwsRestoreAccountAttributes.js';
import { UpdateAwsSourceAccountAttributes } from '../models/UpdateAwsSourceAccountAttributes.js';
import { UpdateBackupPolicyRequest } from '../models/UpdateBackupPolicyRequest.js';
import { UpdateBackupPolicyResponse } from '../models/UpdateBackupPolicyResponse.js';
import { UpdateBackupZeroEtlPolicyInput } from '../models/UpdateBackupZeroEtlPolicyInput.js';
import { UpdateClassificationPolicyRequest } from '../models/UpdateClassificationPolicyRequest.js';
import { UpdateClassificationPolicyResponse } from '../models/UpdateClassificationPolicyResponse.js';
import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest.js';
import { UpdateCloudResourceConfigurationRequestCdcBackup } from '../models/UpdateCloudResourceConfigurationRequestCdcBackup.js';
import { UpdateCloudResourceConfigurationRequestInventoryBackup } from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup.js';
import { UpdateControlViolationInput } from '../models/UpdateControlViolationInput.js';
import { UpdateDlsgPolicyRequest } from '../models/UpdateDlsgPolicyRequest.js';
import { UpdateDlsgPolicyResponse } from '../models/UpdateDlsgPolicyResponse.js';
import { UpdateGcpRestoreAccountAttributes } from '../models/UpdateGcpRestoreAccountAttributes.js';
import { UpdateGcpSourceAccountAttributes } from '../models/UpdateGcpSourceAccountAttributes.js';
import { UpdateIdpGroupRequest } from '../models/UpdateIdpGroupRequest.js';
import { UpdateIdpGroupResponse } from '../models/UpdateIdpGroupResponse.js';
import { UpdateIntegrationRequest } from '../models/UpdateIntegrationRequest.js';
import { UpdateIntegrationResponse } from '../models/UpdateIntegrationResponse.js';
import { UpdateMPAPolicyRequest } from '../models/UpdateMPAPolicyRequest.js';
import { UpdateMPAPolicyResponse } from '../models/UpdateMPAPolicyResponse.js';
import { UpdateObjectStoreScanMethodRequest } from '../models/UpdateObjectStoreScanMethodRequest.js';
import { UpdateObjectStoreScanMethodResponse } from '../models/UpdateObjectStoreScanMethodResponse.js';
import { UpdateOrganizationIdpRequest } from '../models/UpdateOrganizationIdpRequest.js';
import { UpdateOrganizationIdpResponse } from '../models/UpdateOrganizationIdpResponse.js';
import { UpdateProjectConfigurationKeyRequest } from '../models/UpdateProjectConfigurationKeyRequest.js';
import { UpdatePulumiConfigurationRequest } from '../models/UpdatePulumiConfigurationRequest.js';
import { UpdateResourceSecurityScansExclusionRequest } from '../models/UpdateResourceSecurityScansExclusionRequest.js';
import { UpdateRestoreAccountAttributesInput } from '../models/UpdateRestoreAccountAttributesInput.js';
import { UpdateRestoreAccountConnectivityConfigRequest } from '../models/UpdateRestoreAccountConnectivityConfigRequest.js';
import { UpdateRestoreAccountConnectivityConfigResponse } from '../models/UpdateRestoreAccountConnectivityConfigResponse.js';
import { UpdateRestoreAccountRequest } from '../models/UpdateRestoreAccountRequest.js';
import { UpdateRestoreAccountResponse } from '../models/UpdateRestoreAccountResponse.js';
import { UpdateRestoreTemplateRequest } from '../models/UpdateRestoreTemplateRequest.js';
import { UpdateRestoreTemplateResponse } from '../models/UpdateRestoreTemplateResponse.js';
import { UpdateRoleRequest } from '../models/UpdateRoleRequest.js';
import { UpdateRoleResponse } from '../models/UpdateRoleResponse.js';
import { UpdateSamlIdentityProviderInput } from '../models/UpdateSamlIdentityProviderInput.js';
import { UpdateSessionRequest } from '../models/UpdateSessionRequest.js';
import { UpdateShouldFullBackupResourceRequest } from '../models/UpdateShouldFullBackupResourceRequest.js';
import { UpdateSourceAccountAttributesInput } from '../models/UpdateSourceAccountAttributesInput.js';
import { UpdateSourceAccountRequest } from '../models/UpdateSourceAccountRequest.js';
import { UpdateSourceAccountResponse } from '../models/UpdateSourceAccountResponse.js';
import { UpdateThreatHuntingScanRequestRequest } from '../models/UpdateThreatHuntingScanRequestRequest.js';
import { UpdateUserInput } from '../models/UpdateUserInput.js';
import { UpdateVaultRequest } from '../models/UpdateVaultRequest.js';
import { UpdateVaultResponse } from '../models/UpdateVaultResponse.js';
import { UpdateViewerRoleRequest } from '../models/UpdateViewerRoleRequest.js';
import { Usage } from '../models/Usage.js';
import { UsageTypeFilters } from '../models/UsageTypeFilters.js';
import { User } from '../models/User.js';
import { UserIdFilters } from '../models/UserIdFilters.js';
import { VNetConfig } from '../models/VNetConfig.js';
import { ValidateResourceConfigurationRequest } from '../models/ValidateResourceConfigurationRequest.js';
import { ValidateResourceConfigurationResponse } from '../models/ValidateResourceConfigurationResponse.js';
import { VaultFilters } from '../models/VaultFilters.js';
import { VaultMetadataReplicationConfig } from '../models/VaultMetadataReplicationConfig.js';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments.js';
import { VaultProviderAttributes } from '../models/VaultProviderAttributes.js';
import { VaultProviderAttributesInput } from '../models/VaultProviderAttributesInput.js';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount.js';
import { VaultTieringPolicy } from '../models/VaultTieringPolicy.js';
import { VerifyMongoAtlasPrivateLinkResponse } from '../models/VerifyMongoAtlasPrivateLinkResponse.js';
import { Viewer } from '../models/Viewer.js';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments.js';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination.js';
import { VisualizationHistogramSeries } from '../models/VisualizationHistogramSeries.js';
import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint.js';
import { VisualizationLabel } from '../models/VisualizationLabel.js';
import { VolumeSettings } from '../models/VolumeSettings.js';
import { VpcCondition } from '../models/VpcCondition.js';
import { VpcPropertyFilters } from '../models/VpcPropertyFilters.js';
import { WeeklyConfig } from '../models/WeeklyConfig.js';
import { YearlySnapshotDistribution } from '../models/YearlySnapshotDistribution.js';
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
let enumsMap = new Set([
    "AccessConditionEffect",
    "AccountInstallationMethod",
    "AccountState",
    "AccountStatusReason",
    "AgreementWithCreditsTypeEnum",
    "AuditLogAction",
    "AuditLogAuthMethod",
    "AuditLogAuthStatus",
    "AuditLogChangeSource",
    "AuditLogEnrichmentStatus",
    "AuditLogInitiatorType",
    "AuditLogMfaMethod",
    "AwsEbsVolumeResourceVolumeTypeEnum",
    "AwsEbsVolumeResourceStateEnum",
    "AwsFsxResourceFileSystemTypeEnum",
    "AwsFsxResourceStorageTypeEnum",
    "AwsFsxResourceLifecycleStatusEnum",
    "AwsKeyspacesResourceCdcStatusEnum",
    "AwsKeyspacesResourceCdcViewTypeEnum",
    "AwsNativeStandardIntervalConfigIntervalHoursEnum",
    "AwsRdsEngine",
    "AzureAppRegistrationOptionApplicationTypeEnum",
    "AzureFileShareRestoreFileSpecFileSpecTypeEnum",
    "AzureFilesBackupPolicyPlanStorageRedundancyEnum",
    "AzureFilesBackupPolicyPlanScheduleModeEnum",
    "AzureMarketplaceWebhookInputActionEnum",
    "AzureMarketplaceWebhookInputStatusEnum",
    "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
    "AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum",
    "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
    "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
    "AzureOnboardingStatusStatusEnum",
    "AzureRestorePointDataRestorePointTypeEnum",
    "AzureVaultType",
    "BackedByCategory",
    "BackupJobSortField",
    "BackupJobType",
    "BackupPolicyType",
    "BackupStatus",
    "BackupZeroEtlIcebergTransformType",
    "BackupZeroEtlIdentityColumnField",
    "BackupZeroEtlPolicyScope",
    "BackupZeroEtlRoutingMode",
    "BackupZeroEtlSingleResourceTableMappingMode",
    "BillingProvider",
    "BillingTransactionHistoryTransactionTypeEnum",
    "BulkRestoreItemStatus",
    "BulkSelectSnapshotStatus",
    "CdcBackupModeCheckResultModeEnum",
    "CloudAccountType",
    "CloudResourceAttachmentEventType",
    "CognitoExchangeRequestGrantTypeEnum",
    "ConditionOperatorEnum",
    "CostDataGroupBy",
    "CostGranularity",
    "CostProduct",
    "CostRecordMetadataType",
    "CostUnit",
    "CreateOAuthAppRequestTypeEnum",
    "DBSnapshotType",
    "DataTransferOperationType",
    "DayOfWeek",
    "DetectorSummaryDetectorTypeEnum",
    "DetectorSummaryConclusionEnum",
    "DetectorType",
    "DirectoryEntityType",
    "DownloadGdsgObjectsRequestRoleEnum",
    "DsgRequestType",
    "DsgStorageTier",
    "DynamoDBRestoreToS3OutputFormat",
    "DynamoDbBillingMode",
    "EFSRestoreDestinationRestoreTypeEnum",
    "EFSRestoreDestinationPerformanceModeEnum",
    "EFSRestoreDestinationThroughputModeEnum",
    "EfsSnapshotPropertiesPerformanceModeEnum",
    "EfsSnapshotPropertiesThroughputModeEnum",
    "EksClusterStatus",
    "EncryptionType",
    "Environment",
    "EonAccountStatus",
    "EonAccountType",
    "ErrorCode",
    "ExportComplianceReportRequestFormatEnum",
    "FindingCountEntryDetectorTypeEnum",
    "FindingObjectType",
    "FsxOntapVolumeVolumeTypeEnum",
    "FsxOntapVolumeSecurityStyleEnum",
    "GcpDiskResourceDiskTypeEnum",
    "GcpDiskResourceStatusEnum",
    "GcpNetworkType",
    "GcsLocationType",
    "GdsgDeleteResultOutcomeEnum",
    "GdsgObjectEntryRoleEnum",
    "GdsgObjectEntryTierEnum",
    "GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum",
    "GetAwsPrivateLinkStatusResponseStatusEnum",
    "HighFrequencyBackupScheduleFrequency",
    "HighFrequencyIntervalConfigIntervalMinutesEnum",
    "IndexRestoreMode",
    "InitiatorType",
    "IntegType",
    "IssueType",
    "JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum",
    "JobProgressStepKind",
    "JobProgressStepScanningBucketDataScanTypeEnum",
    "JobProgressStepStatus",
    "JobStatus",
    "JobStepName",
    "JobStepStatus",
    "KubeAccessStatus",
    "KubernetesAccessMode",
    "ListOperators",
    "LogSourceTypeEnum",
    "LogSourceWithPolicyTypeEnum",
    "LogicalOperator",
    "MPADecision",
    "MPAEntityType",
    "MPAListRequestSortField",
    "MPAOperationScope",
    "MPAOperationType",
    "MPARequestListPerspective",
    "MPARequestStatus",
    "MPAReviewSubmitDecision",
    "MPASubmitAction",
    "MeteringDimension",
    "Microsoft365SelectionMode",
    "Microsoft365UserLicenseStatusEnum",
    "MinRetentionRuleFrequencyEnum",
    "MongoDbBackupConfigAnalyticsNodeModeEnum",
    "MongoDbBackupConfigScanThrottleModeEnum",
    "MongoDbBackupConfigScanStrategyEnum",
    "NetworkClassification",
    "NetworkInterfaceConfigModeEnum",
    "NotificationPolicyTypeEnum",
    "NotificationStatus",
    "NotificationType",
    "OAuthAppTypeEnum",
    "ObjectStoreCoverageReason",
    "ObjectStoreExclusionRuleStoreTypeEnum",
    "ObjectStoreExclusionRuleMatchTypeEnum",
    "PartialRestoreType",
    "PathType",
    "PermissionCategory",
    "PermissionType",
    "PitrIntervalConfigIntervalMinutesEnum",
    "PrivateLinkCheckResultStatusEnum",
    "ProjectConfigurationKeyEnum",
    "Provider",
    "ProviderCategory",
    "QueryDBRestoreDestinationType",
    "QueryDBStatus",
    "QuotaStatus",
    "RdsPasswordConfigPasswordManagementTypeEnum",
    "ResourceBlockerType",
    "ResourceSelectorMode",
    "ResourceSortField",
    "ResourceType",
    "RestoreAccountSortField",
    "RestoreAtlasClusterInputShardingModeEnum",
    "RestoreAzureFileShareRequestRestoreRequestTypeEnum",
    "RestoreAzureFileShareRequestRecoveryTypeEnum",
    "RestoreJobSortField",
    "RestoreJobType",
    "RestoreMethod",
    "RestoreMethodAvailabilityReason",
    "RestoreObfuscationConfigModeEnum",
    "RestoreTemplateResourceType",
    "RevalidationStatus",
    "RoleInstallationMethod",
    "RuleComponent",
    "ScalarOperators",
    "ScanJobType",
    "ScheduleMode",
    "ScheduleTimezone",
    "ScheduleType",
    "SecurityAssignmentStatus",
    "SecurityScanConclusionEnum",
    "SecurityScanDetectorTypeEnum",
    "SecurityScanReviewerTypeEnum",
    "SecurityScanConclusion",
    "SecurityScanNotificationDataDetectorTypeEnum",
    "SecurityScanNotificationDataConclusionEnum",
    "SecurityScanResultEvidenceTypeEnum",
    "SecurityScanResultTypeEnum",
    "SendA2AMessageRequestJsonrpcEnum",
    "SendA2AMessageRequestMethodEnum",
    "SensitivityLevel",
    "SessionScope",
    "Severity",
    "SeverityFilterValue",
    "SnapshotCoverageAvailability",
    "SnapshotLocationSnapshotTypeEnum",
    "SnapshotRangePick",
    "SnapshotSortField",
    "SnapshotStatus",
    "SortLogsByFieldEnum",
    "SortOrder",
    "SourceAccountSortField",
    "StandardBackupScheduleFrequency",
    "StandardIntervalConfigIntervalHoursEnum",
    "StepProgressUnit",
    "StorageGatewayStatus",
    "StringOperators",
    "SubnetConfigModeEnum",
    "ThreatHuntingStatus",
    "UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum",
    "UsageType",
    "UsageUnit",
    "VNetConfigModeEnum",
    "VaultProtectionMode",
    "VaultStatus",
    "VaultTieringPolicyType",
    "WorkspaceRestoreMode",
]);
let typeMap = {
    "AccessCondition": AccessCondition,
    "AccessConditionalExpression": AccessConditionalExpression,
    "AccessibleOrganizationAccount": AccessibleOrganizationAccount,
    "Account": Account,
    "AccountConfigInput": AccountConfigInput,
    "AccountDisplayNameFilters": AccountDisplayNameFilters,
    "AccountIdCondition": AccountIdCondition,
    "AccountIdFilters": AccountIdFilters,
    "AccountMetricsDestination": AccountMetricsDestination,
    "AccountNameFilters": AccountNameFilters,
    "AccountStatusFilters": AccountStatusFilters,
    "AccountUpdateInput": AccountUpdateInput,
    "AccountVersion": AccountVersion,
    "ActionFilters": ActionFilters,
    "ActivateAtlasOrganizationResponse": ActivateAtlasOrganizationResponse,
    "ActivateGcpFolderResponse": ActivateGcpFolderResponse,
    "ActivateGcpOrganizationResponse": ActivateGcpOrganizationResponse,
    "AddRestoreAtlasPrivateLinkRequest": AddRestoreAtlasPrivateLinkRequest,
    "AdeRestoreEncryptionConfig": AdeRestoreEncryptionConfig,
    "AgreementWithCredits": AgreementWithCredits,
    "Ami": Ami,
    "AmiBlockDevice": AmiBlockDevice,
    "AnnuallyConfig": AnnuallyConfig,
    "AnomalyDataPoint": AnomalyDataPoint,
    "AnomalyGraphData": AnomalyGraphData,
    "ApiCredentials": ApiCredentials,
    "ApiCredentialsProperties": ApiCredentialsProperties,
    "App": App,
    "AppFilters": AppFilters,
    "ApplicationOverride": ApplicationOverride,
    "AppsCondition": AppsCondition,
    "AppsDetails": AppsDetails,
    "AtlasCluster": AtlasCluster,
    "AtlasClusters": AtlasClusters,
    "AtlasOrganization": AtlasOrganization,
    "AtlasProject": AtlasProject,
    "AtlasProjects": AtlasProjects,
    "AuditLog": AuditLog,
    "AuditLogCloudContext": AuditLogCloudContext,
    "AuditLogEntitiesInner": AuditLogEntitiesInner,
    "AuditLogExtendedData": AuditLogExtendedData,
    "AuditLogExtendedDataAuth": AuditLogExtendedDataAuth,
    "AuditLogExtendedDataMpa": AuditLogExtendedDataMpa,
    "AuditLogFilterConditions": AuditLogFilterConditions,
    "AuditLogSecurityContext": AuditLogSecurityContext,
    "AuditLogStateSnapshot": AuditLogStateSnapshot,
    "AuthResponse": AuthResponse,
    "AuthV2AssociateSoftwareTokenRequest": AuthV2AssociateSoftwareTokenRequest,
    "AuthV2AssociateSoftwareTokenResponse": AuthV2AssociateSoftwareTokenResponse,
    "AuthV2ConfirmForgotPasswordRequest": AuthV2ConfirmForgotPasswordRequest,
    "AuthV2ForgotPasswordRequest": AuthV2ForgotPasswordRequest,
    "AuthV2ForgotPasswordResponse": AuthV2ForgotPasswordResponse,
    "AuthV2LoginRequest": AuthV2LoginRequest,
    "AuthV2RespondChallengeRequest": AuthV2RespondChallengeRequest,
    "AuthV2VerifySoftwareTokenRequest": AuthV2VerifySoftwareTokenRequest,
    "AuthV2VerifySoftwareTokenResponse": AuthV2VerifySoftwareTokenResponse,
    "AwsAccountConfigInput": AwsAccountConfigInput,
    "AwsAccountMetricsDestination": AwsAccountMetricsDestination,
    "AwsCassandraClusterRestoreDestination": AwsCassandraClusterRestoreDestination,
    "AwsCassandraClusterRestoreTarget": AwsCassandraClusterRestoreTarget,
    "AwsDatabaseDestination": AwsDatabaseDestination,
    "AwsDynamoDBDestination": AwsDynamoDBDestination,
    "AwsDynamoDbResource": AwsDynamoDbResource,
    "AwsDynamoDbSnapshotProperties": AwsDynamoDbSnapshotProperties,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection,
    "AwsEbsSnapshotConvertResult": AwsEbsSnapshotConvertResult,
    "AwsEbsVolumeResource": AwsEbsVolumeResource,
    "AwsEbsVolumeRestoreData": AwsEbsVolumeRestoreData,
    "AwsEbsVolumeRestoreResult": AwsEbsVolumeRestoreResult,
    "AwsEbsVolumeSnapshotProperties": AwsEbsVolumeSnapshotProperties,
    "AwsEc2AmiConvertResult": AwsEc2AmiConvertResult,
    "AwsEc2InstanceRestoreDestination": AwsEc2InstanceRestoreDestination,
    "AwsEc2InstanceRestoreResult": AwsEc2InstanceRestoreResult,
    "AwsEc2InstanceRestoreTarget": AwsEc2InstanceRestoreTarget,
    "AwsEc2Resource": AwsEc2Resource,
    "AwsEc2SnapshotProperties": AwsEc2SnapshotProperties,
    "AwsEksNamespaceResource": AwsEksNamespaceResource,
    "AwsEksNamespaceSnapshotProperties": AwsEksNamespaceSnapshotProperties,
    "AwsFsxResource": AwsFsxResource,
    "AwsKeyspacesDestination": AwsKeyspacesDestination,
    "AwsKeyspacesResource": AwsKeyspacesResource,
    "AwsNativePitrBackupPolicyPlan": AwsNativePitrBackupPolicyPlan,
    "AwsNativePitrBackupResourceType": AwsNativePitrBackupResourceType,
    "AwsNativePitrConfig": AwsNativePitrConfig,
    "AwsNativeStandardBackupPolicyPlan": AwsNativeStandardBackupPolicyPlan,
    "AwsNativeStandardBackupScheduleConfig": AwsNativeStandardBackupScheduleConfig,
    "AwsNativeStandardBackupSchedules": AwsNativeStandardBackupSchedules,
    "AwsNativeStandardIntervalConfig": AwsNativeStandardIntervalConfig,
    "AwsNeptuneResource": AwsNeptuneResource,
    "AwsRdsResource": AwsRdsResource,
    "AwsRdsResourceAurora": AwsRdsResourceAurora,
    "AwsRdsResourceStorageSettings": AwsRdsResourceStorageSettings,
    "AwsRdsSnapshotProperties": AwsRdsSnapshotProperties,
    "AwsRestoreAccountAttributes": AwsRestoreAccountAttributes,
    "AwsRestoreAccountAttributesInput": AwsRestoreAccountAttributesInput,
    "AwsRestoreAccountConnectivityConfig": AwsRestoreAccountConnectivityConfig,
    "AwsRestoreServerNetworkParams": AwsRestoreServerNetworkParams,
    "AwsSourceAccountAttributes": AwsSourceAccountAttributes,
    "AwsSourceAccountAttributesInput": AwsSourceAccountAttributesInput,
    "AwsVaultConfig": AwsVaultConfig,
    "AwsVaultConfigInput": AwsVaultConfigInput,
    "AwsVpcConnectivityConfig": AwsVpcConnectivityConfig,
    "AzureAccountConfigInput": AzureAccountConfigInput,
    "AzureAksNamespaceResource": AzureAksNamespaceResource,
    "AzureAppRegistrationOption": AzureAppRegistrationOption,
    "AzureBackupApplicationsResponse": AzureBackupApplicationsResponse,
    "AzureCmkEligibleApp": AzureCmkEligibleApp,
    "AzureConsentUrlResponse": AzureConsentUrlResponse,
    "AzureDisk": AzureDisk,
    "AzureDiskRestoreData": AzureDiskRestoreData,
    "AzureDiskRestoreDestination": AzureDiskRestoreDestination,
    "AzureDiskRestoreResult": AzureDiskRestoreResult,
    "AzureDiskSettings": AzureDiskSettings,
    "AzureDiskTarget": AzureDiskTarget,
    "AzureEonApplication": AzureEonApplication,
    "AzureFileShareRestoreFileSpec": AzureFileShareRestoreFileSpec,
    "AzureFilesBackupPolicyPlan": AzureFilesBackupPolicyPlan,
    "AzureFilesBackupSchedules": AzureFilesBackupSchedules,
    "AzureFilesStorageAccountSelection": AzureFilesStorageAccountSelection,
    "AzureListResourceGroupsResponse": AzureListResourceGroupsResponse,
    "AzureListSubscriptionsResponse": AzureListSubscriptionsResponse,
    "AzureManagementGroup": AzureManagementGroup,
    "AzureManagementGroups": AzureManagementGroups,
    "AzureMarketplaceWebhookInput": AzureMarketplaceWebhookInput,
    "AzureMarketplaceWebhookInputSubscription": AzureMarketplaceWebhookInputSubscription,
    "AzureMarketplaceWebhookInputSubscriptionBeneficiary": AzureMarketplaceWebhookInputSubscriptionBeneficiary,
    "AzureMarketplaceWebhookInputSubscriptionPurchaser": AzureMarketplaceWebhookInputSubscriptionPurchaser,
    "AzureMarketplaceWebhookInputSubscriptionTerm": AzureMarketplaceWebhookInputSubscriptionTerm,
    "AzureMssqlSnapshotProperties": AzureMssqlSnapshotProperties,
    "AzureOnboardedTenantsResponse": AzureOnboardedTenantsResponse,
    "AzureOnboardingStatus": AzureOnboardingStatus,
    "AzureOptionalCapabilities": AzureOptionalCapabilities,
    "AzurePostgresDatabaseRestoreDestination": AzurePostgresDatabaseRestoreDestination,
    "AzurePostgresDatabaseRestoreTarget": AzurePostgresDatabaseRestoreTarget,
    "AzureResourceGroup": AzureResourceGroup,
    "AzureResourceGroups": AzureResourceGroups,
    "AzureRestoreAccountAttributes": AzureRestoreAccountAttributes,
    "AzureRestoreAccountAttributesInput": AzureRestoreAccountAttributesInput,
    "AzureRestoreAccountConnectivityConfig": AzureRestoreAccountConnectivityConfig,
    "AzureRestorePointData": AzureRestorePointData,
    "AzureRestorePointSpec": AzureRestorePointSpec,
    "AzureSapHanaResource": AzureSapHanaResource,
    "AzureScanningAccountSetupStatus200Response": AzureScanningAccountSetupStatus200Response,
    "AzureSourceAccountAttributes": AzureSourceAccountAttributes,
    "AzureSourceAccountAttributesInput": AzureSourceAccountAttributesInput,
    "AzureSqlDatabaseNativePitrBackupPolicyPlan": AzureSqlDatabaseNativePitrBackupPolicyPlan,
    "AzureSqlDatabaseNativePitrBackupResourceType": AzureSqlDatabaseNativePitrBackupResourceType,
    "AzureSqlDatabaseNativePitrConfig": AzureSqlDatabaseNativePitrConfig,
    "AzureSqlDatabaseRestoreDestination": AzureSqlDatabaseRestoreDestination,
    "AzureSqlDatabaseRestoreTarget": AzureSqlDatabaseRestoreTarget,
    "AzureSqlRestoreTargetServers": AzureSqlRestoreTargetServers,
    "AzureSqlServer": AzureSqlServer,
    "AzureStorageAccount": AzureStorageAccount,
    "AzureStorageAccounts": AzureStorageAccounts,
    "AzureSubscription": AzureSubscription,
    "AzureTenant": AzureTenant,
    "AzureVaultConfig": AzureVaultConfig,
    "AzureVaultConfigInput": AzureVaultConfigInput,
    "AzureVmInstanceRestoreDestination": AzureVmInstanceRestoreDestination,
    "AzureVmInstanceRestoreResult": AzureVmInstanceRestoreResult,
    "AzureVmInstanceRestoreTarget": AzureVmInstanceRestoreTarget,
    "AzureVmResource": AzureVmResource,
    "AzureVmSnapshotProperties": AzureVmSnapshotProperties,
    "AzureVnetConnectivityConfig": AzureVnetConnectivityConfig,
    "BackedUpByResourceType": BackedUpByResourceType,
    "BackedUpByResourceTypeDataInner": BackedUpByResourceTypeDataInner,
    "BackedUpStorageDateHistogram": BackedUpStorageDateHistogram,
    "BackupControlViolations": BackupControlViolations,
    "BackupJob": BackupJob,
    "BackupJobResponse": BackupJobResponse,
    "BackupJobTypeFilters": BackupJobTypeFilters,
    "BackupJobsFilterConditions": BackupJobsFilterConditions,
    "BackupPoliciesFilters": BackupPoliciesFilters,
    "BackupPoliciesLimits": BackupPoliciesLimits,
    "BackupPoliciesSecurityConfig": BackupPoliciesSecurityConfig,
    "BackupPolicy": BackupPolicy,
    "BackupPolicyAppliesNotificationArguments": BackupPolicyAppliesNotificationArguments,
    "BackupPolicyConfig": BackupPolicyConfig,
    "BackupPolicyExpression": BackupPolicyExpression,
    "BackupPolicyGroupCondition": BackupPolicyGroupCondition,
    "BackupPolicyNotificationArguments": BackupPolicyNotificationArguments,
    "BackupPolicyPlan": BackupPolicyPlan,
    "BackupPolicyResourceSelector": BackupPolicyResourceSelector,
    "BackupPolicySecurityConfig": BackupPolicySecurityConfig,
    "BackupRegionsFilters": BackupRegionsFilters,
    "BackupSchedule": BackupSchedule,
    "BackupScope": BackupScope,
    "BackupScopeSummary": BackupScopeSummary,
    "BackupStatusFilters": BackupStatusFilters,
    "BackupVault": BackupVault,
    "BackupZeroEtlAccessConfiguration": BackupZeroEtlAccessConfiguration,
    "BackupZeroEtlAwsAccessConfiguration": BackupZeroEtlAwsAccessConfiguration,
    "BackupZeroEtlAwsGlueCatalogConfiguration": BackupZeroEtlAwsGlueCatalogConfiguration,
    "BackupZeroEtlCatalogConfiguration": BackupZeroEtlCatalogConfiguration,
    "BackupZeroEtlFilters": BackupZeroEtlFilters,
    "BackupZeroEtlIcebergPartitionSpec": BackupZeroEtlIcebergPartitionSpec,
    "BackupZeroEtlIcebergPartitionTransform": BackupZeroEtlIcebergPartitionTransform,
    "BackupZeroEtlIdentityColumnSpec": BackupZeroEtlIdentityColumnSpec,
    "BackupZeroEtlMultiResourceRoutingPolicy": BackupZeroEtlMultiResourceRoutingPolicy,
    "BackupZeroEtlPolicy": BackupZeroEtlPolicy,
    "BackupZeroEtlResourceSelector": BackupZeroEtlResourceSelector,
    "BackupZeroEtlSingleResourcePartitionConfig": BackupZeroEtlSingleResourcePartitionConfig,
    "BackupZeroEtlSingleResourceRoutingPolicy": BackupZeroEtlSingleResourceRoutingPolicy,
    "BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams": BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams,
    "BackupZeroEtlStorageConfiguration": BackupZeroEtlStorageConfiguration,
    "BackupZeroEtlTableFilter": BackupZeroEtlTableFilter,
    "BatchApplicationOverrides": BatchApplicationOverrides,
    "BatchOperationResponse": BatchOperationResponse,
    "BatchResourceValidationResult": BatchResourceValidationResult,
    "BatchUpdateLlgPoliciesRequest": BatchUpdateLlgPoliciesRequest,
    "BatchUpdateLlgPolicyItem": BatchUpdateLlgPolicyItem,
    "BatchValidateResourceConfigurationRequest": BatchValidateResourceConfigurationRequest,
    "BatchValidateResourceConfigurationResponse": BatchValidateResourceConfigurationResponse,
    "BigQueryDatasetDestination": BigQueryDatasetDestination,
    "BigQueryIntegrationConfig": BigQueryIntegrationConfig,
    "BigQueryNativePitrBackupPolicyPlan": BigQueryNativePitrBackupPolicyPlan,
    "BigQueryNativePitrBackupResourceType": BigQueryNativePitrBackupResourceType,
    "BigQueryNativePitrConfig": BigQueryNativePitrConfig,
    "BigQueryNativePitrDestination": BigQueryNativePitrDestination,
    "BillingPeriod": BillingPeriod,
    "BillingTransactionHistory": BillingTransactionHistory,
    "BooleanFilters": BooleanFilters,
    "BulkAttachRestoreTemplateRequest": BulkAttachRestoreTemplateRequest,
    "BulkDetachRestoreTemplateRequest": BulkDetachRestoreTemplateRequest,
    "BulkRestoreItem": BulkRestoreItem,
    "BulkRestoreRequest": BulkRestoreRequest,
    "BulkRestoreResponse": BulkRestoreResponse,
    "BulkRestoreResponseItemsInner": BulkRestoreResponseItemsInner,
    "BulkRestoreResponseJobsInner": BulkRestoreResponseJobsInner,
    "BulkRestoreValidateRequest": BulkRestoreValidateRequest,
    "BulkRestoreValidateResponse": BulkRestoreValidateResponse,
    "BulkRestoreValidateResponseItemsInner": BulkRestoreValidateResponseItemsInner,
    "BulkSelectSnapshotsForResourcesRequest": BulkSelectSnapshotsForResourcesRequest,
    "BulkSelectSnapshotsForResourcesResponse": BulkSelectSnapshotsForResourcesResponse,
    "BulkSelectSnapshotsForResourcesResponseItemsInner": BulkSelectSnapshotsForResourcesResponseItemsInner,
    "CancelExclusionFromBackupResponse": CancelExclusionFromBackupResponse,
    "CancelMyMPARequestResponse": CancelMyMPARequestResponse,
    "CassandraClusterResource": CassandraClusterResource,
    "CdcBackupModeCheckResult": CdcBackupModeCheckResult,
    "CheckAzureVMNameExists200Response": CheckAzureVMNameExists200Response,
    "CheckAzureVMNameExistsRequest": CheckAzureVMNameExistsRequest,
    "CheckCdcPrerequisitesResponse": CheckCdcPrerequisitesResponse,
    "ClassificationCategory": ClassificationCategory,
    "ClassificationPolicy": ClassificationPolicy,
    "ClassificationPolicySchedule": ClassificationPolicySchedule,
    "Classifications": Classifications,
    "CloudAccountIdFilters": CloudAccountIdFilters,
    "CloudAccountNotificationArguments": CloudAccountNotificationArguments,
    "CloudProviderCondition": CloudProviderCondition,
    "CloudProviderFilters": CloudProviderFilters,
    "CloudRegion": CloudRegion,
    "CloudResourceAttachmentEvent": CloudResourceAttachmentEvent,
    "CloudResourceConfiguration": CloudResourceConfiguration,
    "CloudResourceConfigurationCdcBackup": CloudResourceConfigurationCdcBackup,
    "CloudResourceConfigurationInventoryBackup": CloudResourceConfigurationInventoryBackup,
    "CloudResourceSecurityProperties": CloudResourceSecurityProperties,
    "CloudSnapshotsPerVolume": CloudSnapshotsPerVolume,
    "ClusterNameFilters": ClusterNameFilters,
    "CognitoExchangeRequest": CognitoExchangeRequest,
    "CognitoExchangeResponse": CognitoExchangeResponse,
    "ColumnMetadata": ColumnMetadata,
    "CompanyContact": CompanyContact,
    "ComplianceControlTrends": ComplianceControlTrends,
    "ComplianceSummary": ComplianceSummary,
    "ComplianceTrend": ComplianceTrend,
    "Condition": Condition,
    "ConnectAtlasOrganizationRequest": ConnectAtlasOrganizationRequest,
    "ConnectAtlasOrganizationResponse": ConnectAtlasOrganizationResponse,
    "ConnectAzureBackupAccountRequest": ConnectAzureBackupAccountRequest,
    "ConnectAzureBackupApplicationsRequest": ConnectAzureBackupApplicationsRequest,
    "ConnectAzureRestoreAccountRequest": ConnectAzureRestoreAccountRequest,
    "ConnectAzureSourceAccountRequest": ConnectAzureSourceAccountRequest,
    "ConnectAzureVaultAccountRequest": ConnectAzureVaultAccountRequest,
    "ConnectBYOApps200Response": ConnectBYOApps200Response,
    "ConnectBYOAppsRequest": ConnectBYOAppsRequest,
    "ConnectBYOAzureBackupApplicationsRequest": ConnectBYOAzureBackupApplicationsRequest,
    "ConnectCustomerVaultAccountRequest": ConnectCustomerVaultAccountRequest,
    "ConnectCustomerVaultAccountResponse": ConnectCustomerVaultAccountResponse,
    "ConnectGcpFolderRequest": ConnectGcpFolderRequest,
    "ConnectGcpFolderResponse": ConnectGcpFolderResponse,
    "ConnectGcpOrganizationRequest": ConnectGcpOrganizationRequest,
    "ConnectGcpOrganizationResponse": ConnectGcpOrganizationResponse,
    "ConnectRestoreAccountRequest": ConnectRestoreAccountRequest,
    "ConnectRestoreAccountResponse": ConnectRestoreAccountResponse,
    "ConnectRestoreAwsOrganizationalUnitRequest": ConnectRestoreAwsOrganizationalUnitRequest,
    "ConnectRestoreAwsOrganizationalUnitResponse": ConnectRestoreAwsOrganizationalUnitResponse,
    "ConnectSourceAccountRequest": ConnectSourceAccountRequest,
    "ConnectSourceAccountResponse": ConnectSourceAccountResponse,
    "ConnectSourceAwsOrganizationalUnitRequest": ConnectSourceAwsOrganizationalUnitRequest,
    "ConnectSourceAwsOrganizationalUnitResponse": ConnectSourceAwsOrganizationalUnitResponse,
    "Control": Control,
    "ControlComplianceEntry": ControlComplianceEntry,
    "ControlFailureCount": ControlFailureCount,
    "ControlPlaneConfig": ControlPlaneConfig,
    "ControlRules": ControlRules,
    "ControlTrendEntry": ControlTrendEntry,
    "ControlViolation": ControlViolation,
    "ControlViolations": ControlViolations,
    "ControlViolationsPerSeverity": ControlViolationsPerSeverity,
    "ControlViolationsPerSeverityViolatedControlsInner": ControlViolationsPerSeverityViolatedControlsInner,
    "ControlsFilters": ControlsFilters,
    "ConvertEbsSnapshotConfig": ConvertEbsSnapshotConfig,
    "ConvertEc2ImageConfig": ConvertEc2ImageConfig,
    "ConvertOtherSnapshotsOnDemandRequest": ConvertOtherSnapshotsOnDemandRequest,
    "ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner": ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner,
    "ConvertResourceSnapshotsRequest": ConvertResourceSnapshotsRequest,
    "ConvertResourceSnapshotsResponse": ConvertResourceSnapshotsResponse,
    "Cost": Cost,
    "CostDataFilters": CostDataFilters,
    "CostDataRecord": CostDataRecord,
    "CostDataRecordCost": CostDataRecordCost,
    "CostDataRecordDimensions": CostDataRecordDimensions,
    "CostProductFilters": CostProductFilters,
    "CostRecordMetadata": CostRecordMetadata,
    "CostRecordMetadataDataTransfer": CostRecordMetadataDataTransfer,
    "CreateAccountInput": CreateAccountInput,
    "CreateApiCredentialsRequest": CreateApiCredentialsRequest,
    "CreateApiCredentialsResponse": CreateApiCredentialsResponse,
    "CreateBackupPolicyRequest": CreateBackupPolicyRequest,
    "CreateBackupPolicyResponse": CreateBackupPolicyResponse,
    "CreateBackupZeroEtlPolicyInput": CreateBackupZeroEtlPolicyInput,
    "CreateClassificationPolicyRequest": CreateClassificationPolicyRequest,
    "CreateClassificationPolicyResponse": CreateClassificationPolicyResponse,
    "CreateDlsgPolicyRequest": CreateDlsgPolicyRequest,
    "CreateDlsgPolicyResponse": CreateDlsgPolicyResponse,
    "CreateFabricTableShortcutDemoRequest": CreateFabricTableShortcutDemoRequest,
    "CreateFabricTableShortcutDemoRequestShortcutsInner": CreateFabricTableShortcutDemoRequestShortcutsInner,
    "CreateFabricTableShortcutDemoResponse": CreateFabricTableShortcutDemoResponse,
    "CreateFabricTableShortcutDemoResponseResultsInner": CreateFabricTableShortcutDemoResponseResultsInner,
    "CreateFindingExclusionPatternInput": CreateFindingExclusionPatternInput,
    "CreateIdpGroupRequest": CreateIdpGroupRequest,
    "CreateIdpGroupResponse": CreateIdpGroupResponse,
    "CreateIntegrationRequest": CreateIntegrationRequest,
    "CreateIntegrationResponse": CreateIntegrationResponse,
    "CreateMPAPolicyRequest": CreateMPAPolicyRequest,
    "CreateMPAPolicyResponse": CreateMPAPolicyResponse,
    "CreateMPARequestReviewRequest": CreateMPARequestReviewRequest,
    "CreateMPARequestReviewResponse": CreateMPARequestReviewResponse,
    "CreateOAuthAppRequest": CreateOAuthAppRequest,
    "CreateOAuthAppResponse": CreateOAuthAppResponse,
    "CreateOrganizationIdpRequest": CreateOrganizationIdpRequest,
    "CreateOrganizationIdpResponse": CreateOrganizationIdpResponse,
    "CreatePolicyInput": CreatePolicyInput,
    "CreatePolicyScheduleInput": CreatePolicyScheduleInput,
    "CreateProjectInput": CreateProjectInput,
    "CreatePulumiConfigurationRequest": CreatePulumiConfigurationRequest,
    "CreateRestoreTemplateRequest": CreateRestoreTemplateRequest,
    "CreateRestoreTemplateResponse": CreateRestoreTemplateResponse,
    "CreateRoleRequest": CreateRoleRequest,
    "CreateRoleResponse": CreateRoleResponse,
    "CreateSamlIdentityProviderConfigInput": CreateSamlIdentityProviderConfigInput,
    "CreateScanJobInput": CreateScanJobInput,
    "CreateScanJobResponse": CreateScanJobResponse,
    "CreateSessionRequest": CreateSessionRequest,
    "CreateThreatHuntingScanRequestRequest": CreateThreatHuntingScanRequestRequest,
    "CreateThreatHuntingScanRequestResponse": CreateThreatHuntingScanRequestResponse,
    "CreateUserInput": CreateUserInput,
    "CreateVaultRequest": CreateVaultRequest,
    "CreateVaultResponse": CreateVaultResponse,
    "CredentialFinding": CredentialFinding,
    "CreditsMonthlyUsageNotificationArguments": CreditsMonthlyUsageNotificationArguments,
    "CreditsNotificationArguments": CreditsNotificationArguments,
    "CrossResourceQueryRequest": CrossResourceQueryRequest,
    "CrossResourceQueryRequestResourcesInner": CrossResourceQueryRequestResourcesInner,
    "CustomTagsInner": CustomTagsInner,
    "CustomerVaultAccount": CustomerVaultAccount,
    "DBResourceMetadata": DBResourceMetadata,
    "DBServerRecord": DBServerRecord,
    "DBSnapshotMetadata": DBSnapshotMetadata,
    "DailyConfig": DailyConfig,
    "DailySnapshotData": DailySnapshotData,
    "DailyStorageSummaries": DailyStorageSummaries,
    "DailyStorageSummary": DailyStorageSummary,
    "DataClassEntitiesFilters": DataClassEntitiesFilters,
    "DataClassesCondition": DataClassesCondition,
    "DataClassesDetails": DataClassesDetails,
    "DataClassesFilters": DataClassesFilters,
    "DataClassificationEntity": DataClassificationEntity,
    "DataClassificationEntityOption": DataClassificationEntityOption,
    "DataShareIntegrationConfig": DataShareIntegrationConfig,
    "DatabaseDestination": DatabaseDestination,
    "DatabaseRecord": DatabaseRecord,
    "DatabricksIntegrationConfig": DatabricksIntegrationConfig,
    "DeactivateAccountRequest": DeactivateAccountRequest,
    "DeactivateAccountResponse": DeactivateAccountResponse,
    "DeactivateAtlasOrganizationResponse": DeactivateAtlasOrganizationResponse,
    "DeactivateGcpFolderResponse": DeactivateGcpFolderResponse,
    "DeactivateGcpOrganizationResponse": DeactivateGcpOrganizationResponse,
    "DeleteGdsgObjectsRequest": DeleteGdsgObjectsRequest,
    "DeleteGdsgObjectsResponse": DeleteGdsgObjectsResponse,
    "DestinationDetails": DestinationDetails,
    "DestinationProviderAttributes": DestinationProviderAttributes,
    "DestinationProviderAttributesAzure": DestinationProviderAttributesAzure,
    "DestinationRestoreTypeAttributes": DestinationRestoreTypeAttributes,
    "DetectorSummary": DetectorSummary,
    "DetectorTypeFilters": DetectorTypeFilters,
    "DirectoryEntityRecord": DirectoryEntityRecord,
    "DirectorySearchFilter": DirectorySearchFilter,
    "DisableResourceOverrideLimitsResponse": DisableResourceOverrideLimitsResponse,
    "DisconnectCustomerVaultAccountResponse": DisconnectCustomerVaultAccountResponse,
    "DisconnectRestoreAccountResponse": DisconnectRestoreAccountResponse,
    "DisconnectRestoreAwsOrganizationalUnitResponse": DisconnectRestoreAwsOrganizationalUnitResponse,
    "DisconnectSourceAccountResponse": DisconnectSourceAccountResponse,
    "DisconnectSourceAwsOrganizationalUnitResponse": DisconnectSourceAwsOrganizationalUnitResponse,
    "DiscoveryInvokeParams": DiscoveryInvokeParams,
    "DiscoveryJob": DiscoveryJob,
    "DiscoveryStatusResponse": DiscoveryStatusResponse,
    "DlsgPolicy": DlsgPolicy,
    "DlsgPolicyConfig": DlsgPolicyConfig,
    "DlsgPolicyFilters": DlsgPolicyFilters,
    "DlsgPolicyPlan": DlsgPolicyPlan,
    "DlsgSettings": DlsgSettings,
    "DocumentDBRestoreDestination": DocumentDBRestoreDestination,
    "DocumentDbClusterParameterGroup": DocumentDbClusterParameterGroup,
    "DocumentDbClusterParameterGroups": DocumentDbClusterParameterGroups,
    "DocumentDbSnapshotProperties": DocumentDbSnapshotProperties,
    "DownloadGdsgObjectsRequest": DownloadGdsgObjectsRequest,
    "DriftProtectionPolicy": DriftProtectionPolicy,
    "DriftProtectionSummary": DriftProtectionSummary,
    "DriftProtectionTimePoint": DriftProtectionTimePoint,
    "DsgBucketFilters": DsgBucketFilters,
    "DsgEnvironmentFilters": DsgEnvironmentFilters,
    "DsgRegionFilters": DsgRegionFilters,
    "DsgRequestTypeFilters": DsgRequestTypeFilters,
    "DsgStorageTierFilters": DsgStorageTierFilters,
    "DynamoDBAdvancedIndexConfig": DynamoDBAdvancedIndexConfig,
    "DynamoDBRestoreMethodAvailabilityRequest": DynamoDBRestoreMethodAvailabilityRequest,
    "DynamoDBRestoreMethodAvailabilityResponse": DynamoDBRestoreMethodAvailabilityResponse,
    "DynamoDbBackupConfig": DynamoDbBackupConfig,
    "DynamoDbBackupConfigApplication": DynamoDbBackupConfigApplication,
    "DynamodbTableRestoreDestination": DynamodbTableRestoreDestination,
    "EFSRestoreDestination": EFSRestoreDestination,
    "EbsRestoreDestination": EbsRestoreDestination,
    "EbsSnapshotRestoreDestination": EbsSnapshotRestoreDestination,
    "EbsSnapshotTarget": EbsSnapshotTarget,
    "EbsTarget": EbsTarget,
    "Ec2TemplateParams": Ec2TemplateParams,
    "Ec2TemplateParamsAdditionalTagsInner": Ec2TemplateParamsAdditionalTagsInner,
    "EfsSnapshotProperties": EfsSnapshotProperties,
    "EksCluster": EksCluster,
    "EksNamespaceRestoreDestination": EksNamespaceRestoreDestination,
    "EksNamespaceRestoreResult": EksNamespaceRestoreResult,
    "EksVolumeRestoreResult": EksVolumeRestoreResult,
    "EmailSearchFilter": EmailSearchFilter,
    "EmrIntegrationConfig": EmrIntegrationConfig,
    "EnableFromLimitExceededResponse": EnableFromLimitExceededResponse,
    "EnableResourceOverrideLimitsResponse": EnableResourceOverrideLimitsResponse,
    "EnableRestoreAccountMetricsConfigRequest": EnableRestoreAccountMetricsConfigRequest,
    "EnableRestoreAccountMetricsConfigResponse": EnableRestoreAccountMetricsConfigResponse,
    "EnableSourceAccountMetricsConfigRequest": EnableSourceAccountMetricsConfigRequest,
    "EnableSourceAccountMetricsConfigResponse": EnableSourceAccountMetricsConfigResponse,
    "EncryptionKey": EncryptionKey,
    "EncryptionKeys": EncryptionKeys,
    "EncryptionTypeCondition": EncryptionTypeCondition,
    "EncryptionTypeFilters": EncryptionTypeFilters,
    "EndTimeDateFilters": EndTimeDateFilters,
    "EnvironmentCondition": EnvironmentCondition,
    "EnvironmentDetails": EnvironmentDetails,
    "EnvironmentFilters": EnvironmentFilters,
    "EonAccount": EonAccount,
    "EonAccountIdFilters": EonAccountIdFilters,
    "EonOrganization": EonOrganization,
    "EonOrganizationSummary": EonOrganizationSummary,
    "EvaluateRestoreTemplateResponse": EvaluateRestoreTemplateResponse,
    "EvidenceTypeFilters": EvidenceTypeFilters,
    "ExcludeFromBackupResponse": ExcludeFromBackupResponse,
    "ExclusionPatternFilterConditions": ExclusionPatternFilterConditions,
    "ExclusionPatternResourceFilter": ExclusionPatternResourceFilter,
    "ExportAccessDeniedItemsRequest": ExportAccessDeniedItemsRequest,
    "ExportComplianceReportRequest": ExportComplianceReportRequest,
    "ExportComplianceReportResponse": ExportComplianceReportResponse,
    "ExportCostData400Response": ExportCostData400Response,
    "ExportCostDataRequest": ExportCostDataRequest,
    "FSxRestoreDestination": FSxRestoreDestination,
    "FSxRestoreDestinationOntapRestoreOptions": FSxRestoreDestinationOntapRestoreOptions,
    "FeatureFlagOverrideGet200Response": FeatureFlagOverrideGet200Response,
    "FieldStatus": FieldStatus,
    "FileExplorerCountPathFilesResponse": FileExplorerCountPathFilesResponse,
    "FileExplorerCountSecurityAlertsInResourceResponse": FileExplorerCountSecurityAlertsInResourceResponse,
    "FileExplorerCountWorkspaceEntitiesResponse": FileExplorerCountWorkspaceEntitiesResponse,
    "FileExplorerResponse": FileExplorerResponse,
    "FilePath": FilePath,
    "FileRestoreData": FileRestoreData,
    "FileSearchRecord": FileSearchRecord,
    "FileSnapshot": FileSnapshot,
    "FindingCountEntry": FindingCountEntry,
    "FindingEntry": FindingEntry,
    "FindingExclusionPattern": FindingExclusionPattern,
    "FindingObjectTypeFilters": FindingObjectTypeFilters,
    "FindingResourceFilters": FindingResourceFilters,
    "ForceDeleteSnapshotsRequest": ForceDeleteSnapshotsRequest,
    "FreeTextFilters": FreeTextFilters,
    "FsxOntapVolume": FsxOntapVolume,
    "FsxSnapshotProperties": FsxSnapshotProperties,
    "FsxVolumeBackupInfo": FsxVolumeBackupInfo,
    "GCSBucket": GCSBucket,
    "GCSBuckets": GCSBuckets,
    "GCSRestoreDestination": GCSRestoreDestination,
    "GCSRestoreTarget": GCSRestoreTarget,
    "GcpAccountConfigInput": GcpAccountConfigInput,
    "GcpBigQueryDatasetRestoreResult": GcpBigQueryDatasetRestoreResult,
    "GcpBigQueryResource": GcpBigQueryResource,
    "GcpBigQueryResourceMaterializedViewsInner": GcpBigQueryResourceMaterializedViewsInner,
    "GcpBigQueryResourceRoutinesInner": GcpBigQueryResourceRoutinesInner,
    "GcpBigQueryResourceTablesInner": GcpBigQueryResourceTablesInner,
    "GcpBigQueryResourceViewsInner": GcpBigQueryResourceViewsInner,
    "GcpCloudSqlResource": GcpCloudSqlResource,
    "GcpCloudSqlResourceStorageSettings": GcpCloudSqlResourceStorageSettings,
    "GcpCloudSqlRestoreDestination": GcpCloudSqlRestoreDestination,
    "GcpCloudSqlSnapshotProperties": GcpCloudSqlSnapshotProperties,
    "GcpCloudSqlTarget": GcpCloudSqlTarget,
    "GcpDiskResource": GcpDiskResource,
    "GcpDiskRestoreData": GcpDiskRestoreData,
    "GcpDiskRestoreDestination": GcpDiskRestoreDestination,
    "GcpDiskSettings": GcpDiskSettings,
    "GcpDiskSnapshotProperties": GcpDiskSnapshotProperties,
    "GcpDiskTarget": GcpDiskTarget,
    "GcpDiskTypesResponse": GcpDiskTypesResponse,
    "GcpEncryptionKey": GcpEncryptionKey,
    "GcpEncryptionKeys": GcpEncryptionKeys,
    "GcpGcsResource": GcpGcsResource,
    "GcpGkeNamespaceResource": GcpGkeNamespaceResource,
    "GcpLabelFilter": GcpLabelFilter,
    "GcpMachineTypesResponse": GcpMachineTypesResponse,
    "GcpNetworkConnectivityConfig": GcpNetworkConnectivityConfig,
    "GcpOrganization": GcpOrganization,
    "GcpRestoreAccountAttributes": GcpRestoreAccountAttributes,
    "GcpRestoreAccountAttributesInput": GcpRestoreAccountAttributesInput,
    "GcpRestoreAccountConnectivityConfig": GcpRestoreAccountConnectivityConfig,
    "GcpSapHanaResource": GcpSapHanaResource,
    "GcpSourceAccountAttributes": GcpSourceAccountAttributes,
    "GcpSourceAccountAttributesInput": GcpSourceAccountAttributesInput,
    "GcpSubnet": GcpSubnet,
    "GcpSubnetPerRegion": GcpSubnetPerRegion,
    "GcpTagFilter": GcpTagFilter,
    "GcpVaultConfig": GcpVaultConfig,
    "GcpVaultConfigInput": GcpVaultConfigInput,
    "GcpVmInstanceRestoreDestination": GcpVmInstanceRestoreDestination,
    "GcpVmInstanceRestoreResult": GcpVmInstanceRestoreResult,
    "GcpVmInstanceRestoreTarget": GcpVmInstanceRestoreTarget,
    "GcpVmResource": GcpVmResource,
    "GcpVmSnapshotProperties": GcpVmSnapshotProperties,
    "GdsgActiveBatchJobs": GdsgActiveBatchJobs,
    "GdsgBigtableClusterStats": GdsgBigtableClusterStats,
    "GdsgBigtableStorageTypeBytes": GdsgBigtableStorageTypeBytes,
    "GdsgBigtableTableCpu": GdsgBigtableTableCpu,
    "GdsgBigtableTableStorage": GdsgBigtableTableStorage,
    "GdsgBucketStats": GdsgBucketStats,
    "GdsgDeleteResult": GdsgDeleteResult,
    "GdsgDevStats": GdsgDevStats,
    "GdsgEnvironment": GdsgEnvironment,
    "GdsgEnvironmentRegion": GdsgEnvironmentRegion,
    "GdsgObjectEntry": GdsgObjectEntry,
    "GdsgOperationalNotificationArguments": GdsgOperationalNotificationArguments,
    "GdsgOperationalWarning": GdsgOperationalWarning,
    "GdsgQueueLagStats": GdsgQueueLagStats,
    "GdsgRegionStats": GdsgRegionStats,
    "GdsgRegionStatsPoint": GdsgRegionStatsPoint,
    "GdsgStorageBreakdownEntry": GdsgStorageBreakdownEntry,
    "GdsgStorageByBucketEntry": GdsgStorageByBucketEntry,
    "GdsgStorageByTierEntry": GdsgStorageByTierEntry,
    "GdsgWorkerHeartbeatStats": GdsgWorkerHeartbeatStats,
    "GdsgWorkerHeartbeats": GdsgWorkerHeartbeats,
    "GenericSnapshotData": GenericSnapshotData,
    "GetAWSStackDetailsResponse": GetAWSStackDetailsResponse,
    "GetActionApprovalSummaryResponse": GetActionApprovalSummaryResponse,
    "GetAdditionalAzureAppsOnboardingStatus200Response": GetAdditionalAzureAppsOnboardingStatus200Response,
    "GetAgreementsResponse": GetAgreementsResponse,
    "GetAwsPrivateLinkStatusResponse": GetAwsPrivateLinkStatusResponse,
    "GetAzureQueryExportStorage200Response": GetAzureQueryExportStorage200Response,
    "GetBackupJobResponse": GetBackupJobResponse,
    "GetBackupPolicyResponse": GetBackupPolicyResponse,
    "GetBillingPeriodsResponse": GetBillingPeriodsResponse,
    "GetBulkRestoreSnapshotHistogramRequest": GetBulkRestoreSnapshotHistogramRequest,
    "GetBulkRestoreSnapshotHistogramResponse": GetBulkRestoreSnapshotHistogramResponse,
    "GetClassificationPolicyResponse": GetClassificationPolicyResponse,
    "GetCloudResourceSecurityPropertiesResponse": GetCloudResourceSecurityPropertiesResponse,
    "GetCredits400Response": GetCredits400Response,
    "GetCreditsResponse": GetCreditsResponse,
    "GetDlsgPolicyResponse": GetDlsgPolicyResponse,
    "GetGcsServiceAgentResponse": GetGcsServiceAgentResponse,
    "GetGdsgDevStatsResponse": GetGdsgDevStatsResponse,
    "GetGdsgRegionStatsResponse": GetGdsgRegionStatsResponse,
    "GetIdpGroupResponse": GetIdpGroupResponse,
    "GetIntegrationResponse": GetIntegrationResponse,
    "GetJobProgressStepsResponse": GetJobProgressStepsResponse,
    "GetLimitsResponseValue": GetLimitsResponseValue,
    "GetMPAPolicyResponse": GetMPAPolicyResponse,
    "GetMPARequestResponse": GetMPARequestResponse,
    "GetObjectStoreScanMethodResponse": GetObjectStoreScanMethodResponse,
    "GetProjectConfigurationKeyResponse": GetProjectConfigurationKeyResponse,
    "GetProjectConfigurationKeysResponse": GetProjectConfigurationKeysResponse,
    "GetResourceResponse": GetResourceResponse,
    "GetRestoreAccountCanDelete200Response": GetRestoreAccountCanDelete200Response,
    "GetRestoreAccountConnectivityConfigResponse": GetRestoreAccountConnectivityConfigResponse,
    "GetRestoreAccountMetricsConfigResponse": GetRestoreAccountMetricsConfigResponse,
    "GetRestoreAccountResponse": GetRestoreAccountResponse,
    "GetRestoreJobResponse": GetRestoreJobResponse,
    "GetRestoreTemplateResponse": GetRestoreTemplateResponse,
    "GetRoleResponse": GetRoleResponse,
    "GetScanJobResponse": GetScanJobResponse,
    "GetSnapshotResponse": GetSnapshotResponse,
    "GetSourceAccountCanDelete200Response": GetSourceAccountCanDelete200Response,
    "GetSourceAccountMetricsConfigResponse": GetSourceAccountMetricsConfigResponse,
    "GetSourceAccountResponse": GetSourceAccountResponse,
    "GetSqlVmNetworkInfoRequest": GetSqlVmNetworkInfoRequest,
    "GetSqlVmNetworkInfoResponse": GetSqlVmNetworkInfoResponse,
    "GetVaultResponse": GetVaultResponse,
    "GlobalClusterIdentifierCondition": GlobalClusterIdentifierCondition,
    "GoogleWorkspaceBackupPolicyPlan": GoogleWorkspaceBackupPolicyPlan,
    "GoogleWorkspaceConnectionInfo": GoogleWorkspaceConnectionInfo,
    "GoogleWorkspaceGroup": GoogleWorkspaceGroup,
    "GoogleWorkspaceOrgUnit": GoogleWorkspaceOrgUnit,
    "GoogleWorkspaceResource": GoogleWorkspaceResource,
    "GoogleWorkspaceRestoreAccountAttributes": GoogleWorkspaceRestoreAccountAttributes,
    "GoogleWorkspaceRestoreAccountAttributesInput": GoogleWorkspaceRestoreAccountAttributesInput,
    "GoogleWorkspaceServiceAccountInfo": GoogleWorkspaceServiceAccountInfo,
    "GoogleWorkspaceSharedDrive": GoogleWorkspaceSharedDrive,
    "GoogleWorkspaceSnapshotProperties": GoogleWorkspaceSnapshotProperties,
    "GoogleWorkspaceSourceAccountAttributes": GoogleWorkspaceSourceAccountAttributes,
    "GoogleWorkspaceSourceAccountAttributesInput": GoogleWorkspaceSourceAccountAttributesInput,
    "GoogleWorkspaceUser": GoogleWorkspaceUser,
    "GoogleWorkspaceWithPolicyStatus": GoogleWorkspaceWithPolicyStatus,
    "GroupBreakdown": GroupBreakdown,
    "GroupBreakdownEntry": GroupBreakdownEntry,
    "HighFrequencyBackupPolicyPlan": HighFrequencyBackupPolicyPlan,
    "HighFrequencyBackupResourceType": HighFrequencyBackupResourceType,
    "HighFrequencyBackupScheduleConfig": HighFrequencyBackupScheduleConfig,
    "HighFrequencyBackupSchedules": HighFrequencyBackupSchedules,
    "HighFrequencyIntervalConfig": HighFrequencyIntervalConfig,
    "HoldSnapshotRequest": HoldSnapshotRequest,
    "IDs": IDs,
    "IdFilters": IdFilters,
    "Identifier": Identifier,
    "IdentityProvidersNames": IdentityProvidersNames,
    "Idp": Idp,
    "IdpGroup": IdpGroup,
    "ImportDlsgCertificateRequest": ImportDlsgCertificateRequest,
    "InfectedDataByClassification": InfectedDataByClassification,
    "InfectedDataClassificationSize": InfectedDataClassificationSize,
    "InfectedDataOverTime": InfectedDataOverTime,
    "InfectedDateSize": InfectedDateSize,
    "InfectedResourcesCountResponse": InfectedResourcesCountResponse,
    "InitAuthInput": InitAuthInput,
    "Initiator": Initiator,
    "InitiatorIdentity": InitiatorIdentity,
    "InitiatorNameFilters": InitiatorNameFilters,
    "IntegConfig": IntegConfig,
    "IntegrationConfig": IntegrationConfig,
    "IntrospectRequest": IntrospectRequest,
    "IntrospectResponse": IntrospectResponse,
    "InventoryAzureDisk": InventoryAzureDisk,
    "InventoryBackupPolicy": InventoryBackupPolicy,
    "InventoryClassificationPolicy": InventoryClassificationPolicy,
    "InventoryFilterConditions": InventoryFilterConditions,
    "InventoryGcpDisk": InventoryGcpDisk,
    "InventoryResource": InventoryResource,
    "InventoryResourceMetadata": InventoryResourceMetadata,
    "InventorySnapshotVolume": InventorySnapshotVolume,
    "InventoryVault": InventoryVault,
    "InventoryVolume": InventoryVolume,
    "IsVaultDeletableResponse": IsVaultDeletableResponse,
    "IssueMutedNotificationArguments": IssueMutedNotificationArguments,
    "IssuesFilters": IssuesFilters,
    "JobExecutionDetails": JobExecutionDetails,
    "JobFailedNotificationArguments": JobFailedNotificationArguments,
    "JobIdFilters": JobIdFilters,
    "JobInitiationResponse": JobInitiationResponse,
    "JobMetricsReportFailedArguments": JobMetricsReportFailedArguments,
    "JobProgressStep": JobProgressStep,
    "JobProgressStepBucketDataBackupData": JobProgressStepBucketDataBackupData,
    "JobProgressStepBucketDataBackupDataCoverage": JobProgressStepBucketDataBackupDataCoverage,
    "JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner": JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner,
    "JobProgressStepBucketDataRestorationData": JobProgressStepBucketDataRestorationData,
    "JobProgressStepConnectingToRestoreServerData": JobProgressStepConnectingToRestoreServerData,
    "JobProgressStepCreateInstanceData": JobProgressStepCreateInstanceData,
    "JobProgressStepDatabaseClusterCreationData": JobProgressStepDatabaseClusterCreationData,
    "JobProgressStepDatabaseDataRestorationData": JobProgressStepDatabaseDataRestorationData,
    "JobProgressStepRestoreVolumeData": JobProgressStepRestoreVolumeData,
    "JobProgressStepRestoreWorkerData": JobProgressStepRestoreWorkerData,
    "JobProgressStepScanningBucketData": JobProgressStepScanningBucketData,
    "JobProgressStepScanningBucketDataTierByClassInner": JobProgressStepScanningBucketDataTierByClassInner,
    "JobProgressStepVolumeCreationData": JobProgressStepVolumeCreationData,
    "JobSnapshotDetails": JobSnapshotDetails,
    "JobStatusFilters": JobStatusFilters,
    "JobStep": JobStep,
    "JobSucceededNotificationArguments": JobSucceededNotificationArguments,
    "KeyspacesBackupConfig": KeyspacesBackupConfig,
    "KeyspacesBackupConfigApplication": KeyspacesBackupConfigApplication,
    "KeyspacesTableRestoreDestination": KeyspacesTableRestoreDestination,
    "LimitData": LimitData,
    "ListAccessibleAccountsResponse": ListAccessibleAccountsResponse,
    "ListAccountsResponse": ListAccountsResponse,
    "ListAllRegionsResponse": ListAllRegionsResponse,
    "ListAllRegionsResponseRegions": ListAllRegionsResponseRegions,
    "ListApiCredentialsResponse": ListApiCredentialsResponse,
    "ListApplicationOverrideResponse": ListApplicationOverrideResponse,
    "ListAtlasOrganizationsResponse": ListAtlasOrganizationsResponse,
    "ListAuditLogRequest": ListAuditLogRequest,
    "ListAuditLogResponse": ListAuditLogResponse,
    "ListAuditLogsResponse": ListAuditLogsResponse,
    "ListAwsVpcsResponse": ListAwsVpcsResponse,
    "ListAwsVpcsResponseVpcsInner": ListAwsVpcsResponseVpcsInner,
    "ListAzureAppRegistrationsResponse": ListAzureAppRegistrationsResponse,
    "ListAzureCmkEligibleAppsResponse": ListAzureCmkEligibleAppsResponse,
    "ListAzureFileShares200Response": ListAzureFileShares200Response,
    "ListAzureFileShares200ResponseFileSharesInner": ListAzureFileShares200ResponseFileSharesInner,
    "ListAzureFileSharesRequest": ListAzureFileSharesRequest,
    "ListAzureRegions200Response": ListAzureRegions200Response,
    "ListAzureSKUs200Response": ListAzureSKUs200Response,
    "ListAzureSKUs200ResponseSkusInner": ListAzureSKUs200ResponseSkusInner,
    "ListAzureSKUsRequest": ListAzureSKUsRequest,
    "ListAzureStorageAccountContainers200Response": ListAzureStorageAccountContainers200Response,
    "ListAzureStorageAccountContainersRequest": ListAzureStorageAccountContainersRequest,
    "ListAzureSubnets200Response": ListAzureSubnets200Response,
    "ListAzureSubnets200ResponseSubnetsInner": ListAzureSubnets200ResponseSubnetsInner,
    "ListAzureSubnetsRequest": ListAzureSubnetsRequest,
    "ListAzureUnassignedNetworkInterfaces200Response": ListAzureUnassignedNetworkInterfaces200Response,
    "ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner": ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner,
    "ListAzureUnassignedNetworkInterfacesRequest": ListAzureUnassignedNetworkInterfacesRequest,
    "ListAzureVirtualNetworks200Response": ListAzureVirtualNetworks200Response,
    "ListAzureVirtualNetworks200ResponseVirtualNetworksInner": ListAzureVirtualNetworks200ResponseVirtualNetworksInner,
    "ListAzureVirtualNetworksRequest": ListAzureVirtualNetworksRequest,
    "ListBackupJobTypesResponse": ListBackupJobTypesResponse,
    "ListBackupJobsInternal200Response": ListBackupJobsInternal200Response,
    "ListBackupJobsRequest": ListBackupJobsRequest,
    "ListBackupJobsResponse": ListBackupJobsResponse,
    "ListBackupPoliciesResponse": ListBackupPoliciesResponse,
    "ListBackupPolicyResponse": ListBackupPolicyResponse,
    "ListBackupVaultResponse": ListBackupVaultResponse,
    "ListBackupZeroEtlPoliciesResponse": ListBackupZeroEtlPoliciesResponse,
    "ListBillingTransactionHistoryRequest": ListBillingTransactionHistoryRequest,
    "ListBillingTransactionHistoryResponse": ListBillingTransactionHistoryResponse,
    "ListClassificationCategoriesResponse": ListClassificationCategoriesResponse,
    "ListClassificationPoliciesResponse": ListClassificationPoliciesResponse,
    "ListCloudSnapshotsResponse": ListCloudSnapshotsResponse,
    "ListComplianceResourcesResponse": ListComplianceResourcesResponse,
    "ListControlViolationsResponse": ListControlViolationsResponse,
    "ListControlsResponse": ListControlsResponse,
    "ListCredentialFindingsResponse": ListCredentialFindingsResponse,
    "ListDailySnapshotsResponse": ListDailySnapshotsResponse,
    "ListDataClassificationEntitiesResponse": ListDataClassificationEntitiesResponse,
    "ListDatabaseSnapshotsResponse": ListDatabaseSnapshotsResponse,
    "ListDlsgPoliciesResponse": ListDlsgPoliciesResponse,
    "ListDynamoDbBackupConfigsResponse": ListDynamoDbBackupConfigsResponse,
    "ListEksClustersResponse": ListEksClustersResponse,
    "ListExclusionPatternResourcesResponse": ListExclusionPatternResourcesResponse,
    "ListFindingExclusionPatternsRequest": ListFindingExclusionPatternsRequest,
    "ListFindingExclusionPatternsResponse": ListFindingExclusionPatternsResponse,
    "ListFindingsResponse": ListFindingsResponse,
    "ListGcpFoldersResponse": ListGcpFoldersResponse,
    "ListGcpNetworksResponse": ListGcpNetworksResponse,
    "ListGcpNetworksResponseNetworksInner": ListGcpNetworksResponseNetworksInner,
    "ListGcpOrganizationsResponse": ListGcpOrganizationsResponse,
    "ListGcpSubnetsResponse": ListGcpSubnetsResponse,
    "ListGdsgEnvironmentsResponse": ListGdsgEnvironmentsResponse,
    "ListGdsgObjectsResponse": ListGdsgObjectsResponse,
    "ListGoogleWorkspaceGroups200Response": ListGoogleWorkspaceGroups200Response,
    "ListGoogleWorkspaceOrgUnits200Response": ListGoogleWorkspaceOrgUnits200Response,
    "ListGoogleWorkspaceSharedDrives200Response": ListGoogleWorkspaceSharedDrives200Response,
    "ListGoogleWorkspaceUsers200Response": ListGoogleWorkspaceUsers200Response,
    "ListGoogleWorkspacesWithPolicyStatusResponse": ListGoogleWorkspacesWithPolicyStatusResponse,
    "ListGroupConversationsRequest": ListGroupConversationsRequest,
    "ListIdpGroupsResponse": ListIdpGroupsResponse,
    "ListIdpsResponse": ListIdpsResponse,
    "ListInfectedSnapshotsResponse": ListInfectedSnapshotsResponse,
    "ListInitiatorsResponse": ListInitiatorsResponse,
    "ListInstanceProfilesResponse": ListInstanceProfilesResponse,
    "ListInstanceTypesResponse": ListInstanceTypesResponse,
    "ListIntegrationsResponse": ListIntegrationsResponse,
    "ListInventoryAppsResponse": ListInventoryAppsResponse,
    "ListInventoryBackupRegionsResponse": ListInventoryBackupRegionsResponse,
    "ListInventoryClassificationEntitiesResponse": ListInventoryClassificationEntitiesResponse,
    "ListInventoryEnvironmentsResponse": ListInventoryEnvironmentsResponse,
    "ListInventoryGlobalDatabasesResponse": ListInventoryGlobalDatabasesResponse,
    "ListInventoryItemSnapshotsResponse": ListInventoryItemSnapshotsResponse,
    "ListInventoryNetworksResponse": ListInventoryNetworksResponse,
    "ListInventoryRequest": ListInventoryRequest,
    "ListInventoryResourceGroupsResponse": ListInventoryResourceGroupsResponse,
    "ListInventoryResourceIdentifiersResponse": ListInventoryResourceIdentifiersResponse,
    "ListInventoryResourceTypesResponse": ListInventoryResourceTypesResponse,
    "ListInventoryResourcesResponse": ListInventoryResourcesResponse,
    "ListInventorySensitivityAnnotationValuesResponse": ListInventorySensitivityAnnotationValuesResponse,
    "ListInventorySnapshotsRequest": ListInventorySnapshotsRequest,
    "ListInventorySnapshotsResponse": ListInventorySnapshotsResponse,
    "ListInventorySourceRegionsResponse": ListInventorySourceRegionsResponse,
    "ListInventorySubnetsResponse": ListInventorySubnetsResponse,
    "ListInventoryTagsResponse": ListInventoryTagsResponse,
    "ListJobErrorCodesResponse": ListJobErrorCodesResponse,
    "ListKeyspacesBackupConfigsResponse": ListKeyspacesBackupConfigsResponse,
    "ListKnownAppsResponse": ListKnownAppsResponse,
    "ListLogSourcesPoliciesResponse": ListLogSourcesPoliciesResponse,
    "ListLogSourcesResponse": ListLogSourcesResponse,
    "ListMPAOperationsResponse": ListMPAOperationsResponse,
    "ListMPAPoliciesResponse": ListMPAPoliciesResponse,
    "ListMPARequestsRequest": ListMPARequestsRequest,
    "ListMPARequestsRequestFilters": ListMPARequestsRequestFilters,
    "ListMPARequestsResponse": ListMPARequestsResponse,
    "ListMPARequestsSort": ListMPARequestsSort,
    "ListMicrosoft365GroupMembers200Response": ListMicrosoft365GroupMembers200Response,
    "ListMicrosoft365Groups200Response": ListMicrosoft365Groups200Response,
    "ListMicrosoft365GroupsRequest": ListMicrosoft365GroupsRequest,
    "ListMicrosoft365SharePointSites200Response": ListMicrosoft365SharePointSites200Response,
    "ListMicrosoft365SharePointSitesRequest": ListMicrosoft365SharePointSitesRequest,
    "ListMicrosoft365Users200Response": ListMicrosoft365Users200Response,
    "ListMicrosoft365UsersRequest": ListMicrosoft365UsersRequest,
    "ListMongoAtlasPrivateLinks200Response": ListMongoAtlasPrivateLinks200Response,
    "ListMongoDbBackupConfigsResponse": ListMongoDbBackupConfigsResponse,
    "ListMyMPARequestsRequest": ListMyMPARequestsRequest,
    "ListMyMPARequestsRequestFilters": ListMyMPARequestsRequestFilters,
    "ListMyMPARequestsResponse": ListMyMPARequestsResponse,
    "ListNotificationPoliciesResponse": ListNotificationPoliciesResponse,
    "ListNotificationsResponse": ListNotificationsResponse,
    "ListOAuthAppsResponse": ListOAuthAppsResponse,
    "ListObjectStoreExclusionRulesResponse": ListObjectStoreExclusionRulesResponse,
    "ListOrganizationAccountsResponse": ListOrganizationAccountsResponse,
    "ListOrganizationIdpsResponse": ListOrganizationIdpsResponse,
    "ListPermissionsResponse": ListPermissionsResponse,
    "ListProjectsResponse": ListProjectsResponse,
    "ListResourceAttachmentEventsResponse": ListResourceAttachmentEventsResponse,
    "ListResourcesResponse": ListResourcesResponse,
    "ListRestoreAccountsRequest": ListRestoreAccountsRequest,
    "ListRestoreAccountsResponse": ListRestoreAccountsResponse,
    "ListRestoreAwsOrganizationalUnitsResponse": ListRestoreAwsOrganizationalUnitsResponse,
    "ListRestoreJobTypesResponse": ListRestoreJobTypesResponse,
    "ListRestoreJobsInternal200Response": ListRestoreJobsInternal200Response,
    "ListRestoreJobsRequest": ListRestoreJobsRequest,
    "ListRestoreJobsResponse": ListRestoreJobsResponse,
    "ListRestoreTemplatesRequest": ListRestoreTemplatesRequest,
    "ListRestoreTemplatesResponse": ListRestoreTemplatesResponse,
    "ListRestoreTemplatesResponsePagination": ListRestoreTemplatesResponsePagination,
    "ListRolesResponse": ListRolesResponse,
    "ListScanJobTypesResponse": ListScanJobTypesResponse,
    "ListScanJobsInternal200Response": ListScanJobsInternal200Response,
    "ListScanJobsRequest": ListScanJobsRequest,
    "ListScanJobsResponse": ListScanJobsResponse,
    "ListSecurityFindingsRequest": ListSecurityFindingsRequest,
    "ListSensitivityAnnotationsResponse": ListSensitivityAnnotationsResponse,
    "ListSourceAccountsRequest": ListSourceAccountsRequest,
    "ListSourceAccountsResponse": ListSourceAccountsResponse,
    "ListSourceAwsOrganizationalUnitsResponse": ListSourceAwsOrganizationalUnitsResponse,
    "ListStorageGatewaysResponse": ListStorageGatewaysResponse,
    "ListSubnetsResponse": ListSubnetsResponse,
    "ListSubnetsResponseV2": ListSubnetsResponseV2,
    "ListSubnetsResponseV2SubnetsInner": ListSubnetsResponseV2SubnetsInner,
    "ListThreatHuntingResultsRequest": ListThreatHuntingResultsRequest,
    "ListThreatHuntingResultsResponse": ListThreatHuntingResultsResponse,
    "ListThreatHuntingScanRequestsRequest": ListThreatHuntingScanRequestsRequest,
    "ListThreatHuntingScanRequestsResponse": ListThreatHuntingScanRequestsResponse,
    "ListUsersResponse": ListUsersResponse,
    "LlgLocationResource": LlgLocationResource,
    "LlgLocationWithResources": LlgLocationWithResources,
    "LlgResourcePolicy": LlgResourcePolicy,
    "LogRecord": LogRecord,
    "LogSource": LogSource,
    "LogSourceLocation": LogSourceLocation,
    "LogSourceLocationCloudTrail": LogSourceLocationCloudTrail,
    "LogSourceLocationCloudWatchLogs": LogSourceLocationCloudWatchLogs,
    "LogSourceLocationDatadog": LogSourceLocationDatadog,
    "LogSourceLocationGcpCloudLogging": LogSourceLocationGcpCloudLogging,
    "LogSourceLocationSplunkDdss": LogSourceLocationSplunkDdss,
    "LogSourceWithPolicy": LogSourceWithPolicy,
    "LogsHistogramDataPoint": LogsHistogramDataPoint,
    "LogsSchema": LogsSchema,
    "LogsSchemaColumn": LogsSchemaColumn,
    "LogsSchemaEntry": LogsSchemaEntry,
    "LogsSchemasResponse": LogsSchemasResponse,
    "LuceneQueryInput": LuceneQueryInput,
    "MPAInterceptedResponse": MPAInterceptedResponse,
    "MPAInterceptedResponseMpaPolicies": MPAInterceptedResponseMpaPolicies,
    "MPAOperationInfo": MPAOperationInfo,
    "MPAPolicy": MPAPolicy,
    "MPAPolicyExpression": MPAPolicyExpression,
    "MPAPolicyGroupCondition": MPAPolicyGroupCondition,
    "MPARequest": MPARequest,
    "MPARequestDetail": MPARequestDetail,
    "MPARequestNotificationArguments": MPARequestNotificationArguments,
    "MPARequestPolicyDetail": MPARequestPolicyDetail,
    "MPAResourceSelector": MPAResourceSelector,
    "MPAReview": MPAReview,
    "MPAReviewNotificationArguments": MPAReviewNotificationArguments,
    "MaxRetentionDaysLimit": MaxRetentionDaysLimit,
    "MaxRetentionRule": MaxRetentionRule,
    "Message": Message,
    "Microsoft365ConnectionInfo": Microsoft365ConnectionInfo,
    "Microsoft365EntitySelection": Microsoft365EntitySelection,
    "Microsoft365GraphPermission": Microsoft365GraphPermission,
    "Microsoft365Group": Microsoft365Group,
    "Microsoft365PolicyConfig": Microsoft365PolicyConfig,
    "Microsoft365Resource": Microsoft365Resource,
    "Microsoft365RestoreAccountAttributesInput": Microsoft365RestoreAccountAttributesInput,
    "Microsoft365SharePointSite": Microsoft365SharePointSite,
    "Microsoft365SourceAccountAttributesInput": Microsoft365SourceAccountAttributesInput,
    "Microsoft365User": Microsoft365User,
    "MicrosoftFabricIntegrationConfig": MicrosoftFabricIntegrationConfig,
    "MinRetentionRule": MinRetentionRule,
    "ModelError": ModelError,
    "MongoAtlasClusterResource": MongoAtlasClusterResource,
    "MongoAtlasPrivateLinkEntry": MongoAtlasPrivateLinkEntry,
    "MongoAtlasRestoreAccountAttributes": MongoAtlasRestoreAccountAttributes,
    "MongoAtlasRestoreAccountAttributesInput": MongoAtlasRestoreAccountAttributesInput,
    "MongoAtlasSourceAccountAttributes": MongoAtlasSourceAccountAttributes,
    "MongoAtlasSourceAccountAttributesInput": MongoAtlasSourceAccountAttributesInput,
    "MongoDbBackupConfig": MongoDbBackupConfig,
    "MonthlyConfig": MonthlyConfig,
    "MonthlySnapshotData": MonthlySnapshotData,
    "MsaAcceptanceResponse": MsaAcceptanceResponse,
    "MultiResourceBackupZeroEtlConfiguration": MultiResourceBackupZeroEtlConfiguration,
    "NativeStandardConfig": NativeStandardConfig,
    "NeptuneClusterParameterGroup": NeptuneClusterParameterGroup,
    "NeptuneClusterParameterGroups": NeptuneClusterParameterGroups,
    "NeptuneRestoreDestination": NeptuneRestoreDestination,
    "NeptuneSnapshotProperties": NeptuneSnapshotProperties,
    "NetworkClassificationCondition": NetworkClassificationCondition,
    "NetworkClassificationDetails": NetworkClassificationDetails,
    "NetworkClassificationFilters": NetworkClassificationFilters,
    "NetworkInterfaceConfig": NetworkInterfaceConfig,
    "Notification": Notification,
    "NotificationArguments": NotificationArguments,
    "NotificationPolicy": NotificationPolicy,
    "NotificationPolicyConfig": NotificationPolicyConfig,
    "NotificationPolicyConfigDatadog": NotificationPolicyConfigDatadog,
    "NotificationPolicyConfigEmail": NotificationPolicyConfigEmail,
    "NotificationPolicyConfigServiceNow": NotificationPolicyConfigServiceNow,
    "NotificationPolicyConfigSlack": NotificationPolicyConfigSlack,
    "NotificationPolicyConfigSns": NotificationPolicyConfigSns,
    "NotificationPolicyConfigSplunk": NotificationPolicyConfigSplunk,
    "NotificationPolicyConfigWebhook": NotificationPolicyConfigWebhook,
    "NumberOfCopiesRule": NumberOfCopiesRule,
    "OAuthApp": OAuthApp,
    "Oauth2TokenResponse": Oauth2TokenResponse,
    "ObjectStorageDestination": ObjectStorageDestination,
    "ObjectStoreCoverageBreakdown": ObjectStoreCoverageBreakdown,
    "ObjectStoreCoverageReasonEntry": ObjectStoreCoverageReasonEntry,
    "ObjectStoreExclusionRule": ObjectStoreExclusionRule,
    "ObjectStoreScanMethod": ObjectStoreScanMethod,
    "ObjectStoreScanMethodSetting": ObjectStoreScanMethodSetting,
    "ObjectStoreTierClass": ObjectStoreTierClass,
    "OnboardAdditionalAzureApps200Response": OnboardAdditionalAzureApps200Response,
    "OnboardAdditionalAzureAppsRequest": OnboardAdditionalAzureAppsRequest,
    "OnboardRdsCdcRequest": OnboardRdsCdcRequest,
    "OnboardRdsCdcResponse": OnboardRdsCdcResponse,
    "OnboardingAzureResourceGroup": OnboardingAzureResourceGroup,
    "OperatingSystem": OperatingSystem,
    "OperationIdFilters": OperationIdFilters,
    "OrganizationAccount": OrganizationAccount,
    "OrganizationAccountRole": OrganizationAccountRole,
    "OrganizationIdp": OrganizationIdp,
    "OrganizationSamlServiceProviderDetails": OrganizationSamlServiceProviderDetails,
    "OverrideDataClassificationsRequest": OverrideDataClassificationsRequest,
    "OverrideDataClassificationsResponse": OverrideDataClassificationsResponse,
    "OverrideEnvironmentRequest": OverrideEnvironmentRequest,
    "OverrideEnvironmentResponse": OverrideEnvironmentResponse,
    "OverrideNetworkClassificationRequest": OverrideNetworkClassificationRequest,
    "OverrideNetworkClassificationResponse": OverrideNetworkClassificationResponse,
    "OverrideSensitivityAnnotationsRequest": OverrideSensitivityAnnotationsRequest,
    "Pagination": Pagination,
    "ParameterCheckResult": ParameterCheckResult,
    "ParentIdFilters": ParentIdFilters,
    "PartialRestoreData": PartialRestoreData,
    "Path": Path,
    "PathSnapshotsRequest": PathSnapshotsRequest,
    "PathSnapshotsResponse": PathSnapshotsResponse,
    "Permission": Permission,
    "PermissionGrant": PermissionGrant,
    "PermissionGrantInput": PermissionGrantInput,
    "PersistentVolumeClaimProperties": PersistentVolumeClaimProperties,
    "PitrBackupPolicyPlan": PitrBackupPolicyPlan,
    "PitrBackupResourceType": PitrBackupResourceType,
    "PitrBackupSchedules": PitrBackupSchedules,
    "PitrIntervalConfig": PitrIntervalConfig,
    "PitrRestoreVaultWindows": PitrRestoreVaultWindows,
    "PitrRestoreWindow": PitrRestoreWindow,
    "PitrRestoreWindowsResponse": PitrRestoreWindowsResponse,
    "Preferences": Preferences,
    "PrivateLinkCheckResult": PrivateLinkCheckResult,
    "PrivateLinkFormatInstructions": PrivateLinkFormatInstructions,
    "PrivateLinkInstructionStep": PrivateLinkInstructionStep,
    "Project": Project,
    "ProjectIdFilters": ProjectIdFilters,
    "ProviderAccountIdFilters": ProviderAccountIdFilters,
    "ProviderCategoryFilters": ProviderCategoryFilters,
    "ProviderParentIdFilters": ProviderParentIdFilters,
    "ProviderRestoreAccountConnectivityConfig": ProviderRestoreAccountConnectivityConfig,
    "PulumiConfiguration": PulumiConfiguration,
    "PulumiConfigurations": PulumiConfigurations,
    "PulumiConfigurationsFilterConditions": PulumiConfigurationsFilterConditions,
    "PulumiConfigurationsRequest": PulumiConfigurationsRequest,
    "QueryCostData400Response": QueryCostData400Response,
    "QueryCostDataRequest": QueryCostDataRequest,
    "QueryCostDataResponse": QueryCostDataResponse,
    "QueryDBRequest": QueryDBRequest,
    "QueryDBResponse": QueryDBResponse,
    "QueryDBRestoreDestination": QueryDBRestoreDestination,
    "QueryDBResultResponse": QueryDBResultResponse,
    "QueryDBStatusResponse": QueryDBStatusResponse,
    "QuotaStatusFilters": QuotaStatusFilters,
    "RamShareCheckResult": RamShareCheckResult,
    "RansomwareResourceNotificationArguments": RansomwareResourceNotificationArguments,
    "RdsNativePitrAdvancedConfig": RdsNativePitrAdvancedConfig,
    "RdsNativePitrClusterAdvancedConfig": RdsNativePitrClusterAdvancedConfig,
    "RdsNativePitrNetworkConfig": RdsNativePitrNetworkConfig,
    "RdsNativePitrWindow": RdsNativePitrWindow,
    "RdsPasswordConfig": RdsPasswordConfig,
    "RdsSecurityGroup": RdsSecurityGroup,
    "ReactivateAccountRequest": ReactivateAccountRequest,
    "ReassessActionRequiredRequest": ReassessActionRequiredRequest,
    "ReassessActionRequiredResponse": ReassessActionRequiredResponse,
    "ReconnectCustomerVaultAccountResponse": ReconnectCustomerVaultAccountResponse,
    "ReconnectRestoreAccountResponse": ReconnectRestoreAccountResponse,
    "ReconnectRestoreAwsOrganizationalUnitResponse": ReconnectRestoreAwsOrganizationalUnitResponse,
    "ReconnectSourceAccountResponse": ReconnectSourceAccountResponse,
    "ReconnectSourceAwsOrganizationalUnitResponse": ReconnectSourceAwsOrganizationalUnitResponse,
    "RecordRestoreResult": RecordRestoreResult,
    "RecoveryPointData": RecoveryPointData,
    "RegionCondition": RegionCondition,
    "RegisterInput": RegisterInput,
    "RegisterInputBillingToken": RegisterInputBillingToken,
    "RegisterResponse": RegisterResponse,
    "RelatedGlobalDbCluster": RelatedGlobalDbCluster,
    "RequestDetails": RequestDetails,
    "ResourceBackupSettings": ResourceBackupSettings,
    "ResourceBlockerDetail": ResourceBlockerDetail,
    "ResourceComplianceRow": ResourceComplianceRow,
    "ResourceDetails": ResourceDetails,
    "ResourceGroupNameCondition": ResourceGroupNameCondition,
    "ResourceIdCondition": ResourceIdCondition,
    "ResourceIdFilters": ResourceIdFilters,
    "ResourceIdentifiers": ResourceIdentifiers,
    "ResourceNameCondition": ResourceNameCondition,
    "ResourceNameFilters": ResourceNameFilters,
    "ResourceProperties": ResourceProperties,
    "ResourceQuota": ResourceQuota,
    "ResourceReference": ResourceReference,
    "ResourceSnapshot": ResourceSnapshot,
    "ResourceSnapshotProperties": ResourceSnapshotProperties,
    "ResourceTag": ResourceTag,
    "ResourceTypeCondition": ResourceTypeCondition,
    "ResourceTypeFilters": ResourceTypeFilters,
    "ResourceTypeToSecurityGroup": ResourceTypeToSecurityGroup,
    "ResourceValidationError": ResourceValidationError,
    "RestoreAccount": RestoreAccount,
    "RestoreAccountAttributesInput": RestoreAccountAttributesInput,
    "RestoreAccountCloudAttributes": RestoreAccountCloudAttributes,
    "RestoreAccountConnectivityConfig": RestoreAccountConnectivityConfig,
    "RestoreAccountMetricsConfig": RestoreAccountMetricsConfig,
    "RestoreAccountRegions": RestoreAccountRegions,
    "RestoreAccountsFilterConditions": RestoreAccountsFilterConditions,
    "RestoreAtlasClusterInput": RestoreAtlasClusterInput,
    "RestoreAvailabilityZones": RestoreAvailabilityZones,
    "RestoreAwsCassandraClusterRequest": RestoreAwsCassandraClusterRequest,
    "RestoreAwsEc2InstanceRequest": RestoreAwsEc2InstanceRequest,
    "RestoreAwsOrganizationalUnit": RestoreAwsOrganizationalUnit,
    "RestoreAzureDiskConfig": RestoreAzureDiskConfig,
    "RestoreAzureDiskRequest": RestoreAzureDiskRequest,
    "RestoreAzureFileShareRequest": RestoreAzureFileShareRequest,
    "RestoreAzureInstanceDiskInput": RestoreAzureInstanceDiskInput,
    "RestoreAzurePostgresDatabaseRequest": RestoreAzurePostgresDatabaseRequest,
    "RestoreAzureSqlDatabaseNativePitrRequest": RestoreAzureSqlDatabaseNativePitrRequest,
    "RestoreAzureSqlDatabaseRequest": RestoreAzureSqlDatabaseRequest,
    "RestoreAzureSqlVmPitrRequest": RestoreAzureSqlVmPitrRequest,
    "RestoreAzureVMInstanceConfig": RestoreAzureVMInstanceConfig,
    "RestoreAzureVmInstanceRequest": RestoreAzureVmInstanceRequest,
    "RestoreBigQueryDatasetRequest": RestoreBigQueryDatasetRequest,
    "RestoreBigQueryNativePitrRequest": RestoreBigQueryNativePitrRequest,
    "RestoreBucketRequest": RestoreBucketRequest,
    "RestoreDbToRdsInstanceRequest": RestoreDbToRdsInstanceRequest,
    "RestoreDbToRdsSnapshotRequest": RestoreDbToRdsSnapshotRequest,
    "RestoreDestinationLimits": RestoreDestinationLimits,
    "RestoreDocumentDBRequest": RestoreDocumentDBRequest,
    "RestoreDynamoDBTableRequest": RestoreDynamoDBTableRequest,
    "RestoreDynamoDBToExistingTableRequest": RestoreDynamoDBToExistingTableRequest,
    "RestoreDynamoDBToS3Request": RestoreDynamoDBToS3Request,
    "RestoreDynamoDbTableConfig": RestoreDynamoDbTableConfig,
    "RestoreEFSRequest": RestoreEFSRequest,
    "RestoreEbsVolumeConfig": RestoreEbsVolumeConfig,
    "RestoreEc2InstanceConfig": RestoreEc2InstanceConfig,
    "RestoreEksNamespaceConfig": RestoreEksNamespaceConfig,
    "RestoreEksNamespaceInput": RestoreEksNamespaceInput,
    "RestoreEksNamespaceVolumeInput": RestoreEksNamespaceVolumeInput,
    "RestoreFSxRequest": RestoreFSxRequest,
    "RestoreFilesRequest": RestoreFilesRequest,
    "RestoreGceDiskConfig": RestoreGceDiskConfig,
    "RestoreGceInstanceConfig": RestoreGceInstanceConfig,
    "RestoreGcpCloudSqlDatabaseConfig": RestoreGcpCloudSqlDatabaseConfig,
    "RestoreGcpCloudSqlRequest": RestoreGcpCloudSqlRequest,
    "RestoreGcpDiskRequest": RestoreGcpDiskRequest,
    "RestoreGcpInstanceDiskInput": RestoreGcpInstanceDiskInput,
    "RestoreGcpVmInstanceRequest": RestoreGcpVmInstanceRequest,
    "RestoreGoogleWorkspaceRequest": RestoreGoogleWorkspaceRequest,
    "RestoreImageImageDeviceInput": RestoreImageImageDeviceInput,
    "RestoreImageImageInput": RestoreImageImageInput,
    "RestoreImageInput": RestoreImageInput,
    "RestoreImageVolumeInput": RestoreImageVolumeInput,
    "RestoreInstanceImageDeviceInput": RestoreInstanceImageDeviceInput,
    "RestoreInstanceImageInput": RestoreInstanceImageInput,
    "RestoreInstanceVolumeInput": RestoreInstanceVolumeInput,
    "RestoreJob": RestoreJob,
    "RestoreJobConfiguration": RestoreJobConfiguration,
    "RestoreJobInitiationResponse": RestoreJobInitiationResponse,
    "RestoreJobTypeFilters": RestoreJobTypeFilters,
    "RestoreJobsFilterConditions": RestoreJobsFilterConditions,
    "RestoreKeyspacesTableRequest": RestoreKeyspacesTableRequest,
    "RestoreMicrosoft365Request": RestoreMicrosoft365Request,
    "RestoreNeptuneRequest": RestoreNeptuneRequest,
    "RestoreObfuscationConfig": RestoreObfuscationConfig,
    "RestoreRdsInstanceClasses": RestoreRdsInstanceClasses,
    "RestoreRdsInstanceConfig": RestoreRdsInstanceConfig,
    "RestoreRdsNativePitrRequest": RestoreRdsNativePitrRequest,
    "RestoreRdsSubnetGroups": RestoreRdsSubnetGroups,
    "RestoreRdsSubnetGroupsRdsSubnetGroupsInner": RestoreRdsSubnetGroupsRdsSubnetGroupsInner,
    "RestoreResult": RestoreResult,
    "RestoreSecurityGroups": RestoreSecurityGroups,
    "RestoreSecurityGroupsSecurityGroupsInner": RestoreSecurityGroupsSecurityGroupsInner,
    "RestoreTemplate": RestoreTemplate,
    "RestoreTemplateFilterConditions": RestoreTemplateFilterConditions,
    "RestoreTemplateIdFilters": RestoreTemplateIdFilters,
    "RestoreTemplateResourceTypeFilters": RestoreTemplateResourceTypeFilters,
    "RestoreVolumeToEbsRequest": RestoreVolumeToEbsRequest,
    "RestoreVolumeToEbsSnapshotRequest": RestoreVolumeToEbsSnapshotRequest,
    "RevalidateRestoreTemplateRequest": RevalidateRestoreTemplateRequest,
    "RevalidateRestoreTemplateResponse": RevalidateRestoreTemplateResponse,
    "RevalidationReport": RevalidationReport,
    "Role": Role,
    "RoleAccessGroupCondition": RoleAccessGroupCondition,
    "RoleUsage": RoleUsage,
    "RuleOutcome": RuleOutcome,
    "RuleOutcomeList": RuleOutcomeList,
    "S3Bucket": S3Bucket,
    "S3Buckets": S3Buckets,
    "S3RestoreDestination": S3RestoreDestination,
    "S3RestoreTarget": S3RestoreTarget,
    "S3TemplateParams": S3TemplateParams,
    "SAMLCallback400Response": SAMLCallback400Response,
    "SAMLCallback401Response": SAMLCallback401Response,
    "SAMLCallback500Response": SAMLCallback500Response,
    "SameSourceAccountRestoreLimits": SameSourceAccountRestoreLimits,
    "SamlIdentityProvider": SamlIdentityProvider,
    "SamlIdentityProviderConfigsResponse": SamlIdentityProviderConfigsResponse,
    "SapHanaInstance": SapHanaInstance,
    "SapHanaRestoreProperties": SapHanaRestoreProperties,
    "SaveCloudResourceSecurityPropertiesRequest": SaveCloudResourceSecurityPropertiesRequest,
    "ScanJob": ScanJob,
    "SchemaRecord": SchemaRecord,
    "SearchDBResponse": SearchDBResponse,
    "SearchDirectoryEntitiesRequest": SearchDirectoryEntitiesRequest,
    "SearchDirectoryEntitiesResponse": SearchDirectoryEntitiesResponse,
    "SearchFilesResponse": SearchFilesResponse,
    "SearchInput": SearchInput,
    "SearchLogsHistogramInput": SearchLogsHistogramInput,
    "SearchLogsHistogramResponse": SearchLogsHistogramResponse,
    "SearchLogsInput": SearchLogsInput,
    "SearchLogsResponse": SearchLogsResponse,
    "SearchResources200Response": SearchResources200Response,
    "SearchResources200ResponseTablesInner": SearchResources200ResponseTablesInner,
    "SearchResources200ResponseTablesInnerResource": SearchResources200ResponseTablesInnerResource,
    "SearchResources200ResponseTablesInnerSnapshots": SearchResources200ResponseTablesInnerSnapshots,
    "SearchResources200ResponseTablesInnerSource": SearchResources200ResponseTablesInnerSource,
    "SearchResources200ResponseTablesInnerTablesInner": SearchResources200ResponseTablesInnerTablesInner,
    "SearchResources200ResponseTablesInnerTablesInnerColumnsInner": SearchResources200ResponseTablesInnerTablesInnerColumnsInner,
    "SearchResourcesRequest": SearchResourcesRequest,
    "SecurityFindingsFilterConditions": SecurityFindingsFilterConditions,
    "SecurityInformation": SecurityInformation,
    "SecurityPlan": SecurityPlan,
    "SecurityPlanEnabledResponse": SecurityPlanEnabledResponse,
    "SecurityResourceNotificationArguments": SecurityResourceNotificationArguments,
    "SecurityScan": SecurityScan,
    "SecurityScanConclusionCondition": SecurityScanConclusionCondition,
    "SecurityScanConclusionFilters": SecurityScanConclusionFilters,
    "SecurityScanNotificationData": SecurityScanNotificationData,
    "SecurityScanResult": SecurityScanResult,
    "SecurityScansSummaryResponse": SecurityScansSummaryResponse,
    "SecuritySnapshotNotificationArguments": SecuritySnapshotNotificationArguments,
    "SecuritySummary": SecuritySummary,
    "SendA2AMessageRequest": SendA2AMessageRequest,
    "SendMessageToAI400Response": SendMessageToAI400Response,
    "SendMessageToAIRequest": SendMessageToAIRequest,
    "SensitivityAnnotation": SensitivityAnnotation,
    "SensitivityAnnotationsCondition": SensitivityAnnotationsCondition,
    "SensitivityLabelsDetails": SensitivityLabelsDetails,
    "SensitivityLabelsFilters": SensitivityLabelsFilters,
    "ServiceProviderDetails": ServiceProviderDetails,
    "Session": Session,
    "SetupAwsPrivateLinkRequest": SetupAwsPrivateLinkRequest,
    "SetupAwsPrivateLinkResponse": SetupAwsPrivateLinkResponse,
    "SetupMongoAtlasPrivateLinkRequest": SetupMongoAtlasPrivateLinkRequest,
    "SetupMongoAtlasPrivateLinkResponse": SetupMongoAtlasPrivateLinkResponse,
    "SeverityFilters": SeverityFilters,
    "SingleResourceBackupZeroEtlConfiguration": SingleResourceBackupZeroEtlConfiguration,
    "Snapshot": Snapshot,
    "SnapshotAccessDeniedNotificationArguments": SnapshotAccessDeniedNotificationArguments,
    "SnapshotCoverage": SnapshotCoverage,
    "SnapshotDateFilters": SnapshotDateFilters,
    "SnapshotFilterConditions": SnapshotFilterConditions,
    "SnapshotFindingCountsResponse": SnapshotFindingCountsResponse,
    "SnapshotHistogramBucket": SnapshotHistogramBucket,
    "SnapshotIdFilters": SnapshotIdFilters,
    "SnapshotLocation": SnapshotLocation,
    "SnapshotReference": SnapshotReference,
    "SnapshotStorage": SnapshotStorage,
    "SnapshotTimeFilters": SnapshotTimeFilters,
    "SnapshotsSummaryResponse": SnapshotsSummaryResponse,
    "SnowflakeIntegrationConfig": SnowflakeIntegrationConfig,
    "SortBackupJobBy": SortBackupJobBy,
    "SortLogsBy": SortLogsBy,
    "SortResourceBy": SortResourceBy,
    "SortRestoreAccountsBy": SortRestoreAccountsBy,
    "SortRestoreJobBy": SortRestoreJobBy,
    "SortSnapshotsBy": SortSnapshotsBy,
    "SortSourceAccountsBy": SortSourceAccountsBy,
    "SourceAccount": SourceAccount,
    "SourceAccountAttributesInput": SourceAccountAttributesInput,
    "SourceAccountCloudAttributes": SourceAccountCloudAttributes,
    "SourceAccountMetricsConfig": SourceAccountMetricsConfig,
    "SourceAccountProviderIdFilters": SourceAccountProviderIdFilters,
    "SourceAccountsFilterConditions": SourceAccountsFilterConditions,
    "SourceAwsOrganizationalUnit": SourceAwsOrganizationalUnit,
    "SourceRegionFilters": SourceRegionFilters,
    "SourceSizeCheckResult": SourceSizeCheckResult,
    "SourceStorage": SourceStorage,
    "SourceStorageBackupStatus": SourceStorageBackupStatus,
    "SqlInstructions": SqlInstructions,
    "SqlVmNetworkInfo": SqlVmNetworkInfo,
    "SsoIntegrationSettings": SsoIntegrationSettings,
    "StackNameFilters": StackNameFilters,
    "StandardBackupPolicyPlan": StandardBackupPolicyPlan,
    "StandardBackupScheduleConfig": StandardBackupScheduleConfig,
    "StandardBackupSchedules": StandardBackupSchedules,
    "StandardIntervalConfig": StandardIntervalConfig,
    "StartTimeDateFilters": StartTimeDateFilters,
    "StatusCodeFilters": StatusCodeFilters,
    "StatusProperties": StatusProperties,
    "StepProgressMetric": StepProgressMetric,
    "StepProgressView": StepProgressView,
    "StorageAccountContainerRestoreDestination": StorageAccountContainerRestoreDestination,
    "StorageAccountRestoreTarget": StorageAccountRestoreTarget,
    "StorageGateway": StorageGateway,
    "StorageGatewayDetails": StorageGatewayDetails,
    "SubmitMyMPARequestRequest": SubmitMyMPARequestRequest,
    "SubmitMyMPARequestResponse": SubmitMyMPARequestResponse,
    "SubnetConfig": SubnetConfig,
    "SubnetFilters": SubnetFilters,
    "SubnetPerAvailabilityZone": SubnetPerAvailabilityZone,
    "SubnetsCondition": SubnetsCondition,
    "SupportedProviders": SupportedProviders,
    "TableRecord": TableRecord,
    "TagKeyValue": TagKeyValue,
    "TagKeyValuesCondition": TagKeyValuesCondition,
    "TagKeyValuesFilters": TagKeyValuesFilters,
    "TagKeysCondition": TagKeysCondition,
    "TagKeysFilters": TagKeysFilters,
    "TakeNativeSnapshotRequest": TakeNativeSnapshotRequest,
    "TakeSnapshotRequest": TakeSnapshotRequest,
    "TakeSnapshotResponse": TakeSnapshotResponse,
    "TeardownAwsPrivateLinkResponse": TeardownAwsPrivateLinkResponse,
    "TeardownMongoAtlasPrivateLinkResponse": TeardownMongoAtlasPrivateLinkResponse,
    "ThreatDetectionFilters": ThreatDetectionFilters,
    "ThreatHuntingResult": ThreatHuntingResult,
    "ThreatHuntingScanRequest": ThreatHuntingScanRequest,
    "TimeFrame": TimeFrame,
    "TimeOfDay": TimeOfDay,
    "TimeOfYear": TimeOfYear,
    "TokenResponse": TokenResponse,
    "TotalSourceStorageSizeRequest": TotalSourceStorageSizeRequest,
    "TotalSourceStorageSizeResponse": TotalSourceStorageSizeResponse,
    "TrendPoint": TrendPoint,
    "TriggerKeyspacesScheduledDump200Response": TriggerKeyspacesScheduledDump200Response,
    "UnifiedDBRecord": UnifiedDBRecord,
    "UnifiedDBServerRecord": UnifiedDBServerRecord,
    "UnifiedDatabaseRecord": UnifiedDatabaseRecord,
    "UnifiedSchemaRecord": UnifiedSchemaRecord,
    "UnifiedTableRecord": UnifiedTableRecord,
    "UpPulumiStacksResponse": UpPulumiStacksResponse,
    "UpdateAccountCompanyContactsRequest": UpdateAccountCompanyContactsRequest,
    "UpdateAccountLabelsRequest": UpdateAccountLabelsRequest,
    "UpdateAccountProfileResponse": UpdateAccountProfileResponse,
    "UpdateApiCredentialsRequest": UpdateApiCredentialsRequest,
    "UpdateAwsRestoreAccountAttributes": UpdateAwsRestoreAccountAttributes,
    "UpdateAwsSourceAccountAttributes": UpdateAwsSourceAccountAttributes,
    "UpdateBackupPolicyRequest": UpdateBackupPolicyRequest,
    "UpdateBackupPolicyResponse": UpdateBackupPolicyResponse,
    "UpdateBackupZeroEtlPolicyInput": UpdateBackupZeroEtlPolicyInput,
    "UpdateClassificationPolicyRequest": UpdateClassificationPolicyRequest,
    "UpdateClassificationPolicyResponse": UpdateClassificationPolicyResponse,
    "UpdateCloudResourceConfigurationRequest": UpdateCloudResourceConfigurationRequest,
    "UpdateCloudResourceConfigurationRequestCdcBackup": UpdateCloudResourceConfigurationRequestCdcBackup,
    "UpdateCloudResourceConfigurationRequestInventoryBackup": UpdateCloudResourceConfigurationRequestInventoryBackup,
    "UpdateControlViolationInput": UpdateControlViolationInput,
    "UpdateDlsgPolicyRequest": UpdateDlsgPolicyRequest,
    "UpdateDlsgPolicyResponse": UpdateDlsgPolicyResponse,
    "UpdateGcpRestoreAccountAttributes": UpdateGcpRestoreAccountAttributes,
    "UpdateGcpSourceAccountAttributes": UpdateGcpSourceAccountAttributes,
    "UpdateIdpGroupRequest": UpdateIdpGroupRequest,
    "UpdateIdpGroupResponse": UpdateIdpGroupResponse,
    "UpdateIntegrationRequest": UpdateIntegrationRequest,
    "UpdateIntegrationResponse": UpdateIntegrationResponse,
    "UpdateMPAPolicyRequest": UpdateMPAPolicyRequest,
    "UpdateMPAPolicyResponse": UpdateMPAPolicyResponse,
    "UpdateObjectStoreScanMethodRequest": UpdateObjectStoreScanMethodRequest,
    "UpdateObjectStoreScanMethodResponse": UpdateObjectStoreScanMethodResponse,
    "UpdateOrganizationIdpRequest": UpdateOrganizationIdpRequest,
    "UpdateOrganizationIdpResponse": UpdateOrganizationIdpResponse,
    "UpdateProjectConfigurationKeyRequest": UpdateProjectConfigurationKeyRequest,
    "UpdatePulumiConfigurationRequest": UpdatePulumiConfigurationRequest,
    "UpdateResourceSecurityScansExclusionRequest": UpdateResourceSecurityScansExclusionRequest,
    "UpdateRestoreAccountAttributesInput": UpdateRestoreAccountAttributesInput,
    "UpdateRestoreAccountConnectivityConfigRequest": UpdateRestoreAccountConnectivityConfigRequest,
    "UpdateRestoreAccountConnectivityConfigResponse": UpdateRestoreAccountConnectivityConfigResponse,
    "UpdateRestoreAccountRequest": UpdateRestoreAccountRequest,
    "UpdateRestoreAccountResponse": UpdateRestoreAccountResponse,
    "UpdateRestoreTemplateRequest": UpdateRestoreTemplateRequest,
    "UpdateRestoreTemplateResponse": UpdateRestoreTemplateResponse,
    "UpdateRoleRequest": UpdateRoleRequest,
    "UpdateRoleResponse": UpdateRoleResponse,
    "UpdateSamlIdentityProviderInput": UpdateSamlIdentityProviderInput,
    "UpdateSessionRequest": UpdateSessionRequest,
    "UpdateShouldFullBackupResourceRequest": UpdateShouldFullBackupResourceRequest,
    "UpdateSourceAccountAttributesInput": UpdateSourceAccountAttributesInput,
    "UpdateSourceAccountRequest": UpdateSourceAccountRequest,
    "UpdateSourceAccountResponse": UpdateSourceAccountResponse,
    "UpdateThreatHuntingScanRequestRequest": UpdateThreatHuntingScanRequestRequest,
    "UpdateUserInput": UpdateUserInput,
    "UpdateVaultRequest": UpdateVaultRequest,
    "UpdateVaultResponse": UpdateVaultResponse,
    "UpdateViewerRoleRequest": UpdateViewerRoleRequest,
    "Usage": Usage,
    "UsageTypeFilters": UsageTypeFilters,
    "User": User,
    "UserIdFilters": UserIdFilters,
    "VNetConfig": VNetConfig,
    "ValidateResourceConfigurationRequest": ValidateResourceConfigurationRequest,
    "ValidateResourceConfigurationResponse": ValidateResourceConfigurationResponse,
    "VaultFilters": VaultFilters,
    "VaultMetadataReplicationConfig": VaultMetadataReplicationConfig,
    "VaultNotificationArguments": VaultNotificationArguments,
    "VaultProviderAttributes": VaultProviderAttributes,
    "VaultProviderAttributesInput": VaultProviderAttributesInput,
    "VaultSnapshotCount": VaultSnapshotCount,
    "VaultTieringPolicy": VaultTieringPolicy,
    "VerifyMongoAtlasPrivateLinkResponse": VerifyMongoAtlasPrivateLinkResponse,
    "Viewer": Viewer,
    "ViolationsDetectionNotificationArguments": ViolationsDetectionNotificationArguments,
    "VirtualMachineRestoreDestination": VirtualMachineRestoreDestination,
    "VisualizationHistogramSeries": VisualizationHistogramSeries,
    "VisualizationHistogramTimePoint": VisualizationHistogramTimePoint,
    "VisualizationLabel": VisualizationLabel,
    "VolumeSettings": VolumeSettings,
    "VpcCondition": VpcCondition,
    "VpcPropertyFilters": VpcPropertyFilters,
    "WeeklyConfig": WeeklyConfig,
    "YearlySnapshotDistribution": YearlySnapshotDistribution,
};
export class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
            return data;
        }
        else if (type.startsWith("Array<", 0)) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith("Set<", 0)) {
            let subType = type.replace("Set<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let item of data) {
                transformedData.push(ObjectSerializer.serialize(item, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type.lastIndexOf("Set<", 0) === 0) {
            let subType = type.replace("Set<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let item of data) {
                transformedData.push(ObjectSerializer.deserialize(item, subType, format));
            }
            return new Set(transformedData);
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }
    static getPreferredMediaType(mediaTypes) {
        return "application/json";
    }
}
